import {
  Component,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { MachineMappingService } from 'src/app/services/machinemapping.service';
import { MatDialog } from '@angular/material/dialog';
import { PlantGroupElement } from 'src/app/models/O3AdministrationModels/plant-model';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { Router } from '@angular/router';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { NestedTreeControl } from '@angular/cdk/tree';
import { ShopFloorDataService } from 'src/app/services/shopFloorData.service';
import { EnterPriseGroupService } from 'src/app/services/enterpriseGroup.service';
import * as moment from 'moment';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { MatTabGroup } from '@angular/material/tabs';
import * as Chart from 'chart.js';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSort } from '@angular/material/sort';
import Swal from 'sweetalert2';
import { Validators } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { ButtonSelectRendererComponent } from 'src/app/components/button-select-render.components';
import { ButtonEditRendererComponent } from 'src/app/components/button-edit-render.components';
import { ButtonPrintRendererComponent } from 'src/app/components/button-print-render.components';
import { ButtonViewRendererComponent } from 'src/app/components/button-view-render.components';
import { CustomTooltip } from 'src/app/custom-tooltip.component';
import { PrimeCellEditorComponent } from 'src/app/editors/prime-cell-editor.component';
import { BtnCellRendererActualEntry } from 'src/app/btn-cell-rendererActualEntry.component';
import { BtnCellRenderer } from 'src/app/btn-cell-renderer.component';
import { ProcessControlService } from 'src/app/services/processControlService.service';
import { QualityParameterService } from 'src/app/services/quality-parameter.service';
import { ChecklistService } from 'src/app/services/checklist.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AreaService } from 'src/app/services/area.service';
import { TranslaterService } from 'src/app/services/translater.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { CrewScheduleService } from 'src/app/services/crewSchedule.service';
import { MachineParamtersService } from 'src/app/services/machine-paramters.service';
import { CustomLoadingCellRenderer } from 'src/app/aggrid custom/custom-loading-cell-renderer.component';
import { formatDate } from '@angular/common';
import { QualityexecutionService } from 'src/app/services/qualityexecution.service';
import { differenceInCalendarDays } from 'date-fns';
import { interval, Subscription } from 'rxjs';
import { CustomLoadingOverlay } from 'src/app/custom-loading-overlay.component';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { StockChart } from 'angular-highcharts';
import { Multilingual } from 'src/app/services/multilingual';
const pdfMake = require('pdfmake/build/pdfmake.js');
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
interface Group {
  value: string;
  viewValue: string;
}

interface Select {
  value: string;
  viewValue: string;
}

interface LineInterface {
  KpiparaId: number;
  KpiName: string;
  KpiValues: boolean;
}

interface batchCheckListInterface {
  BatchCheckListTypeId: number;
  Name: string;
  DataType: any;
  DataValue: any;
}

interface LotCode {
  value: string;
  viewValue: string;
}

interface ShiftCloseInterface {
  sno: number;
  item: string;
}

interface DataType {
  value: string;
  viewValue: string;
}

interface TypeName {
  value: string;
  viewValue: string;
}

export class QCGroup {
  [key: string]: any;
  level = 0;
  parent!: Group;
  expanded = true;
  totalCounts = 0;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}

@Component({
  selector: 'app-shop-floor-data',
  templateUrl: './shop-floor-data.component.html',
  styleUrls: ['./shop-floor-data.component.scss'],
})
export class ShopFloorDataComponent
  implements OnInit, OnDestroy, AfterViewInit {
  spinnerButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Analysis',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  spinnerButtonOptions1: MatProgressButtonOptions = {
    active: false,
    text: 'Comparison',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  spinnerButtonOptionsOrders: MatProgressButtonOptions = {
    active: false,
    text: 'PO List',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    buttonColor: 'primary',
    spinnerColor: 'accent',
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  };
  @ViewChild('pickerforprocessgrid') processpicker!: any;
  @ViewChild('pickerforqualitygrid') qualitypicker!: any;
  @ViewChild('visibleYearlyTarget')
  private visibleYearlyTargetTbl!: TemplateRef<any>;
  @ViewChild('visibleYearlyTargetQuality')
  private visibleYearlyTargetTblQuality!: TemplateRef<any>;
  @ViewChild('visibleParameterComparison')
  private visibleParameterComparison!: TemplateRef<any>;
  @ViewChild('visibleParameterComparisonQuality')
  private visibleParameterComparisonQuality!: TemplateRef<any>;
  @ViewChild(MatTable) table!: MatTable<any>;
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();
  @ViewChild('inputExp', { read: MatInput }) inputExp!: MatInput;
  @ViewChild('qualityBoolListModal')
  private qualityBoolListModal!: TemplateRef<any>;
  @ViewChild('displayProcessOrdersModal')
  private displayProcessOrdersModal!: TemplateRef<any>;
  @ViewChild('displayQualityOrdersModal')
  private displayQualityOrdersModal!: TemplateRef<any>;
  @ViewChild('pdfModel') private pdfModel!: TemplateRef<any>;
  @ViewChild('pdfModelQC') private pdfModelQC!: TemplateRef<any>;

  // @ViewChild('displayQualitySpecificationModal')
  // private displayQualitySpecificationModal!: TemplateRef<any>;
  // @ViewChild('displayQualityDefectModal')
  // private displayQualityDefectModal!: TemplateRef<any>;
  // @ViewChild('processControlSpecificationModal')
  // private processControlSpecificationModal!: TemplateRef<any>;
  // @ViewChild('displayProcssDefectModal')
  // private displayProcssDefectModal!: TemplateRef<any>;
  highChartsColor = [
    '#00008B',
    '#34A56F',
    '#F80000',
    '#2D0A77',
    '#8C001A',
    '#FF69B4',
    '#FA4A08',
    '#5453A6',
    '#8B008B',
    '#3090C7',
    '#F1C40F',
    '#CB4335',
    '#36454F',
    '#A569BD',
    '#FFA500',
    '#179fcc',
    '#093323',
    '#08fa03',
    '#048b8e',
    '#9637A4',
    '#F39C12',
    '#0b774e',
    '#F5B7B1',
    '#0d98da',
    '#512E5F',
    '#C471A5',
    '#0034bb',
    '#06573d',
    '#0d6e54',
    '#0692aa',
    '#611745',
    '#F80000',
    '#FFDF00',
    '#6D81A8',
    '#08FAC7',
    '#D208FA',
    '#FAEB08',
  ];

  displayProcssDefectModal!: boolean;
  shiftCloseFormArray!: FormArray;
  shiftCloseFormGroup!: FormGroup;
  groupByColumns: string[] = [];
  public showSeconds = false;
  varUnitName!: string;
  qualityProcessOrder = new MatTableDataSource<any>([]);
  ProcessOrder = new MatTableDataSource<any>([]);
  plantGroupSource = new MatTreeNestedDataSource<PlantGroupElement>();
  panelOpenState = false;
  Group!: string;
  KpiSelect!: string;
  LotCode!: string;
  DataType!: any;
  TypeName!: string;
  chart!: any;
  subscription!: Subscription;
  startDate!: Date;
  endDate!: Date;
  total!: any;
  total1!: any;
  result!: any;
  Result!: any;
  isParamterValuesModelVisible = false;
  ManPowerRequired!: any;
  ManPower!: any;
  processIntervalTypeDDL!: any[];
  QualityIntervalTypeDDL!: any[];
  chartArray: any[] = [];
  stock!: StockChart;
  crewId!: any;
  totalWaste!: any;
  dropdownId!: any;
  qty!: any;
  displayQualitySpecificationModal!: boolean;
  processControlSpecificationModal!: boolean;
  name!: any;
  startInterval!: any;
  endInterval!: any;
  intervalId!: any;
  changeIntervalMode!: boolean;
  isIntervalSaveMode!: boolean;
  successMessage!: any;
  JobDownTimeId!: any;
  newJbWasteHistoryList!: any[];
  updateOrderprocessingData = false;
  qualityBoolVal!: string;
  Exdpandhide = true;
  today = new Date();
  Collapsehide = false;
  isCardExpanded = false;
  isCardExpandedQuality = false;
  CollapsehideQuality = false;
  ExdpandhideQuality = true;
  userRoleForm!: FormGroup;
  poListForm!: FormGroup;
  wasteForm!: FormGroup;
  productionOutputForm!: FormGroup;
  groupDataForm!: FormGroup;
  processLineForm!: FormGroup;
  downTimeForm!: FormGroup;
  materialConsumptionForm!: FormGroup;
  materialFoodSectorConsumptionForm!: FormGroup;
  shortStopsForm!: FormGroup;
  displayQualityDefectModal!: boolean;
  machineForm = true;
  machineSelectProperty = false;
  formMode = true;
  updatedItemCode!: any;
  PlantList!: any[];
  masterList!: any[];
  processList!: any[];
  ItemTypeList!: any[];
  GTList!: any[];
  filteredGTList!: any[];
  isActive = true;
  isFoodSector: boolean = false;
  IsReworkRequired: boolean = false;
  isRework: boolean = false;
  ItemBOMList!: any[];
  ItemBOMViewList!: any[];
  batchItemBOMList!: MatTableDataSource<any>;
  materialHistoryItemBOMList!: MatTableDataSource<any>;
  WasteEntryId!: any;
  checklistIdNumber!: number;
  dddefualtValue!: any;
  GTDurationList: any[] = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7' },
    { id: 8, name: '8' },
    { id: 9, name: '9' },
    { id: 10, name: '10' },
  ];
  HardCodedFaultList: any[] = [
    { id: 207, name: 'Make Ready Waste' },
    { id: 208, name: 'Maintenance Related Wastee' },
    { id: 209, name: 'Operational Waste' },
    { id: 210, name: 'Material Related  Waste' },
  ];
  checkList!: any[];
  filteredModules!: any[];
  filteredStatus!: any[];
  processValues!: any[];
  processValues1!: any[];
  jobkpiId!: any;
  canvas!: any;
  ctx!: any;
  latestLotCode!: any[];
  JbBatchHistoryList!: any[];
  JbDowntimeHistoryList!: any[];
  JobBatchItemTypeId!: any;
  FaultList!: any[];
  selected = '207';
  value = '1';
  booleanConvertedArray: LineInterface[] = [];
  booleanConvertedArray1: LineInterface[] = [];
  booleanConvertedArray2: LineInterface[] = [];
  LineNode: any;
  sDate = new Date();
  displayUserModal = false;
  displayPoMode = true;
  groupDataMode = true;
  materialFormMode = true;
  centerLineMode = true;
  productionMode = true;
  isbuttDisabled = false;
  wasteMode = true;
  showMode = false;
  showButtons = false;
  materialConsumptionMode = true;
  downTimeMode = true;
  shortStopsMode = true;
  showShiftClose = false;
  wasteButtonShow = false;
  showMaterialButtons = false;
  onlymachineSelectProperty = false;
  showProductionOutputButtons = false;
  showStaticProductionOutputButtons = true;
  showDynamicProductionOutputButtons = false;
  showLastShiftProperty = false;
  isProcessGrid = false;
  homeCardList!: any;
  breadcrumList!: any;
  UnitNode!: any[];
  UnitArray!: any[];
  statusList!: any[];
  UnitArrayName!: any[];
  LineParameterList!: any[];
  MaterialParameterList!: any[];
  OEEInfoList!: any[];
  ValidationList!: any[];
  OEE!: any;
  Availability!: any;
  Performance!: any;
  Quality!: any;
  DowntimeInfoList!: any[];
  batchCheckList!: any[];
  arrayCheckList!: any[];
  checkListId!: any;
  batchtypeid!: any;
  UnitText: any;
  PPID!: any;
  obKpiParamInfoId1!: any;
  processTransactionId!: any;
  targetQty!: any;
  itemCode!: any;
  JobBatchId!: any;
  JobBatchMaterialId!: any;
  PPS_ID!: any;
  MachineId!: any;
  UserName!: any;
  Shift!: any;
  ShiftStart!: any;
  ShiftEnd!: any;
  Supervisor!: any;
  processMode = true;
  isAuto!: any;
  UnitName: any;
  tabGroup: any;
  date1!: any;
  DTFaultList!: any[];
  filteredDTFaultList!: any[];
  wasteFaultList!: any[];
  totalMaterial!: any;
  subtractedDate!: any;
  date2!: any;
  date3!: any;
  date4!: any;
  date5!: any;
  ONE_HOUR = 60 * 60 * 1000;
  TWO_HOURS = 2 * (60 * 60 * 1000);
  IsAccess: any;
  IsWrite: any;
  shiftCloseArray: ShiftCloseInterface[] = [];
  validationArray!: any[];
  resultWaste: any;
  isFoodMaterialHisory: boolean = false;
  batchConsumptionList!: any[];
  filteredbatchConsumptionList!: any[];
  invalidDate: boolean = false;
  PDtooltip: any;
  IDtooltip: any;
  cavityList!: any[];
  maxCavity: any;
  showCavity = false;
  //AG Grid Prop
  rowData!: any[];
  rowDataDowntimeHistory!: any[];
  rowDataWasteHistory!: any[];
  rowDataBatchHistory!: any[];
  rowDataMaterialBatchHistory!: any[];
  rowDataMaterialConsumptionHistory!: any[];
  rowDataProcessControl!: any[];
  rowDataQualityControl!: any[];
  rowDataQualityControl2!: any[];
  columnDefs!: any[];
  columnDefsProcessControl!: any[];
  columnDefsQualityControl!: any[];
  columnDefsDowntimeHistory!: any[];
  columnWasteHistry!: any[];
  columnBatchHistory!: any[];
  columnMaterialBatchHistory!: any[];
  columnMaterialConsumptionHistory!: any[];
  gridApi: any;
  gridColumnApi: any;
  qualityGridApi: any;
  qualityGridColumnApi: any;
  processGridApi: any;
  processGridColumnApi: any;
  frameworkComponents: any;
  loadingOverlayComponent: any;
  loadingOverlayComponentParams: any;
  autoGroupColumnDef = {
    headerName: 'Parameter Group',
    pinned: 'left',
    resizable: true,
    flex: 1,
    sortable: true,
    wrapText: true,
    autoHeight: true,
    filter: true,
    filterValueGetter: (params: any) => params.data.ParameterGroup,
  };
  gridOptions: any = {
    defaultColDef: {
      rowModelType: 'infinite',
      infiniteInitialRowCount: 2,
      editable: true,
      sortable: true,
      flex: 1,
      minWidth: 225,
      filter: true,
      resizable: true,
      wrapText: true,
      autoHeight: true,
    },
  };

  gridOptionsProcessControl: any = {
    suppressFieldDotNotation: true,
    defaultColDef: {
      flex: 1,
      resizable: true,
      sortable: true,
      wrapText: true,
      autoHeight: true,
      minWidth: 200,
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
    groupDefaultExpanded: 1,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      customTooltip: CustomTooltip,
      primeCellEditor: PrimeCellEditorComponent,
      btnCellRendererActualEntry: BtnCellRendererActualEntry,
      btnCellRenderer: BtnCellRenderer,
    },
  };

  gridOptionsQualityControl: any = {
    suppressFieldDotNotation: true,
    headerHeight: 50,
    flex: 1,
    groupDefaultExpanded: 1,
    paginationPageSize: 10,
    popupParent: document.querySelector('body'),
    frameworkComponents: {
      customTooltip: CustomTooltip,
      primeCellEditor: PrimeCellEditorComponent,
      btnCellRendererActualEntry: BtnCellRendererActualEntry,
      btnCellRenderer: BtnCellRenderer,
      customLoadingCellRenderer: CustomLoadingCellRenderer,
    },
  };
  // gridOptionsQualityControl: any = {
  //   defaultColDef: {
  //     floatingFilterComponentParams: {
  //       suppressFilterButton: false,
  //     },
  //     filterParams: { newRowsAction: 'keep' },
  //   },
  //   autoGroupColumnDef: {
  //     headerName: 'Paramter Group',
  //     pinned: 'left',
  //     resizable: true,
  //   },
  //   flex: 1,
  //   groupDefaultExpanded: 1,
  //   paginationPageSize: 10,
  //   popupParent: document.querySelector('body'),
  //   frameworkComponents: {
  //     customTooltip: CustomTooltip,
  //     primeCellEditor: PrimeCellEditorComponent,
  //     btnCellRendererActualEntry: BtnCellRendererActualEntry,
  //     btnCellRenderer: BtnCellRenderer,
  //     customLoadingCellRenderer: CustomLoadingCellRenderer,
  //   },
  // };
  rowSelection: any;
  unitId: any;
  intervalList: any;
  dropdownArray: any[] = [];
  newDropdownList: any = [];
  BatchCheckListTypeId!: any;
  dropdownDataValue!: any;
  // checklist execution  configuration table
  fileSave!: any;
  categoryTypeDDL: any[] = [
    { id: 'Yes', name: 'Yes' },
    { id: 'No', name: 'No' },
  ];
  yes = true;
  no = true;
  detailPrentId!: any;
  areaDDL!: any[];
  Plants!: any[];
  Groups!: any[];
  plantDDL!: any[];
  currentImagePath!: any;
  GoodExampleImage = false;
  BadExampleImage = false;
  groupByQCColumns: string[] = [];
  _alldata!: any[];
  _allDataQC!: any[];
  counter = 1;
  isAuto2 = false;
  preAuto = false;
  preAuto2 = false;
  preCheck!: any;
  preCheck2!: any;
  valueCheck!: any;
  valueCheck2!: any;
  goodImgArray: File[] = [];
  itemTypeDDL!: any[];
  listTypeDDL!: any[];
  executeRole!: any;
  hidetrue = false;
  plantId = 0;
  shiftName!: any;
  checklistId!: number;
  checklistDataForm!: FormGroup;
  checklistDatatableForm!: FormGroup;
  checkListAddModel = new MatTableDataSource<any | Group>([]);
  customerManagementDataSource = new MatTableDataSource<any>([]);
  itemColumns: string[] = ['items', 'good', 'bad', 'score', 'remarks'];
  customerManagementColumns: string[] = [
    'action',
    'listName',
    'Area',
    'Machine',
    'createdOn',
    'TotalExec',
    'LastexecDate',
  ];
  addtabledata: Array<{
    id: number;
    itemtype: number;
    drop: string;
    item: string;
    checkListDetailId: number;
    score: number;
    remarks: string;
    catType: string;
    goodImage: string;
    badImage: string;
  }> = [];
  groupTypeList: any;
  processControlForm!: FormGroup;
  qualityControlForm!: FormGroup;
  qualityGroupType: any;
  processGroupType: any;
  qualityControlGroupTypeList: any;
  crewScheduleList: any;
  qualityboolList: any;
  boolList: any;
  qualityIntervalList: any;
  paramterSpcecificationName: any;
  parameterspecifications = new MatTableDataSource<any>([]);
  parametrdefect!: MatTableDataSource<any>;
  ProcessControlDataForm!: FormGroup;
  chartSpecifications: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;
  processcontrolcolumns: string[] = [
    'LRL',
    'LSL',
    'LWL',
    'TGT',
    'UWL',
    'USL',
    'URL',
  ];
  defectColumns: string[] = [
    'DefectMode',
    'Department',
    'Line',
    'Unit',
    'Assembly',
    'Subassembly',
    'Component',
  ];
  qcVerifyColumns: string[] = [
    'ParameterId',
    'Parameter',
    'Sample',
    'Value',
    'verify',
    'remarks',
  ];
  processmodalordersColumns: string[] = [
    'ProcessOrder',
    'ProdCode',
    'ProdDesc',
    'StartTime',
    'EndTime',
  ];
  QualityordersColumns: string[] = [
    'ProcessOrder',
    'ProdCode',
    'ProdDesc',
    'StartTime',
    'EndTime',
  ];
  qcdataSource = new MatTableDataSource<any>([]);

  shiftList: any;
  qcRole = false;
  qcParamsSlot: any;
  qcStartTimeSlot: any;
  qcEndTimeSlot: any;
  qcheadertooltip: any;
  qcProcessorderNo: any;
  qcProdCode: any;
  qcProcdDesc: any;
  detailArray: any;
  verifyCheckedArray: any;
  verifcationStatus: any;
  remarks: any;
  currentprocessOrder: any;
  boolColId: any;
  getRowNodeId: (data: any) => any;
  boolRowIndex: any;
  selectionName: any;
  parameterGroupList: any;
  processparameterGroupList: any;
  qualityparameterGroupList: any;
  ResumeInterval = true;
  rowDataProcessControl2!: any[];
  selectedColumns: any = [];
  columns: any;
  selectedColumnsQC: any = [];
  columnsQC: any;
  machineProducts: any[];
  selectedParameters: any;
  selectedProducts: any;
  lang: any;
  range = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });
  constructor(
    private dialog: MatDialog,
    private sfdService: ShopFloorDataService,
    private toaster: ToastrService,
    private userManagementService: UserManagementService,
    public router: Router,
    private AreaServices: AreaService,
    private enterpriseGroupService: EnterPriseGroupService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private usermanagementService: UserManagementService,
    private kpiMaster: KpimasterService,
    private processService: ProcessControlService,
    private qualityParameterService: QualityParameterService,
    private qualityexecutionService: QualityexecutionService,
    private checklistService: ChecklistService,
    private notificationService: NotificationService,
    private machineService: MachineMappingService,
    private translater: TranslaterService,
    private translate: TranslateService,
    private crewService: CrewScheduleService,
    private machineParamtersService: MachineParamtersService
  ) {
    this.getRowNodeId = (data) => data.id;
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ? this.languageDir = 'rtl' : this.languageDir = 'ltr'; this.getLangWords(); });
    this.frameworkComponents = {
      buttonSelectRenderer: ButtonSelectRendererComponent,
      buttonEditRenderer: ButtonEditRendererComponent,
      buttonViewRenderer: ButtonViewRendererComponent,
      buttonPrintRenderer: ButtonPrintRendererComponent,
      customLoadingOverlay: CustomLoadingOverlay,
      customTooltip: CustomTooltip,
    };
    this.rowSelection = 'single';
    this.columnDefs = [
      {
        headerName: 'Actions',
        field: 'Actions',
        cellRenderer: 'buttonSelectRenderer',
        cellRendererParams: {
          onClick: this.selectHistory.bind(this),
          label: 'select',
        },
        maxWidth: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Id', field: 'PPDId', maxWidth: 85, headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'PO No', field: 'PO', maxWidth: 150, headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Operation No', field: 'Oper', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Status', field: 'OperStatus', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Product Details', field: 'ProductDetail', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Item Code', field: 'ItemCode', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Item Description', field: 'ItemDesc', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Priority', field: 'Priority', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
    ];

    this.columnDefsDowntimeHistory = [
      {
        headerName: 'Actions',
        field: 'Actions',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickDowntimeHistory.bind(this),
          label: 'Edit',
        },
        maxWidth: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Start time',
        field: 'StartTime',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'End time',
        field: 'EndTime',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Duration', field: 'Duration', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Fault', field: 'FaultName', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
    ];

    this.columnWasteHistry = [
      {
        headerName: 'Actions',
        field: 'Actions',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickWasteHistory.bind(this),
          label: 'Edit',
        },
        maxWidth: 100,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Category type', field: 'FaultName', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Time', field: 'Time', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'qty', field: 'Amount', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'mode', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
    ];

    this.columnBatchHistory = [
      {
        headerName: '',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickProductHistoryBatch.bind(this),
          label: 'Edit',
        },
        maxWidth: 70,
      },
      {
        headerName: 'Actions',
        field: 'Actions',
        cellRenderer: 'buttonViewRenderer',
        cellRendererParams: {
          onClick: this.onClickPopupViewForChecklistHistory.bind(this),
          label: 'View',
        },
        maxWidth: 85,
        suppressMenu: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: '',
        cellRenderer: 'buttonPrintRenderer',
        cellRendererParams: {
          onClick: this.onClickGetBarCodeDetails.bind(this),
          label: 'Print',
        },
        maxWidth: 70,
      },
      { headerName: 'Batch Consumption', field: 'IPBatchNo', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Lotcode/Pallets', field: 'BatchNo', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'act', field: 'Result', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Time',
        field: 'RollStarttime',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Created On', field: 'CreatedOn', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
    ];

    this.columnMaterialBatchHistory = [
      {
        headerName: 'Action',
        field: 'Actions',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickEditMaterialConsumptionBatch.bind(this),
          label: 'Edit',
        },
        maxWidth: 80,
        suppressMenu: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Item Type', field: 'Name', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Lotcode/Details', field: 'BatchNo', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'act', field: 'Result', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Time',
        field: 'RollStarttime',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        maxWidth: 180,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        maxWidth: 180,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Created By', field: 'CreatedBy', maxWidth: 120, headerValueGetter: this.localizeHeader.bind(this) },
    ];

    this.columnMaterialConsumptionHistory = [
      {
        headerName: 'Actions',
        field: 'Actions',
        cellRenderer: 'buttonEditRenderer',
        cellRendererParams: {
          onClick: this.onClickEditFoodSectorMaterial.bind(this),
          label: 'Edit',
        },
        maxWidth: 90,
        suppressMenu: true,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      {
        headerName: '',
        cellRenderer: 'buttonViewRenderer',
        cellRendererParams: {
          onClick: this.onClickPopupViewForMaterialHistory.bind(this),
          label: 'View',
        },
        maxWidth: 85,
        suppressMenu: true,
      },
      {
        headerName: 'Is Rework',
        field: 'IsRework',
        cellRenderer: (params: any) => (params.value === true ? 'Yes' : 'No'),
        maxWidth: 120,
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Lotcode/Pallet', field: 'BatchNo', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'act', field: 'Result', maxWidth: 180, headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Total Act Qty', field: 'Actual', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Remarks', field: 'remarks', headerValueGetter: this.localizeHeader.bind(this) },
      { headerName: 'Time', field: 'RollStarttime', headerValueGetter: this.localizeHeader.bind(this) },
      {
        headerName: 'Created On',
        field: 'CreatedOn',
        valueFormatter: function (params: any) {
          return moment(params.value).format('DD/MM/YYYY HH:mm');
        },
        headerValueGetter: this.localizeHeader.bind(this)
      },
      { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
    ];
    this.groupByColumns = ['itemGroup'];

    this.loadingOverlayComponent = 'customLoadingOverlay';
    this.loadingOverlayComponentParams = {
      loadingMessage: 'One moment please...',
    };
  }

  isPlantGroupModelVisible = false;

  // @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('displayRoleModal') private displayRoleModal!: TemplateRef<any>;
  @ViewChild('wastehistoryModal') private wastehistoryModal!: TemplateRef<any>;
  @ViewChild('displayPoModal') private displayPoModal!: TemplateRef<any>;
  // displayPoModal!: boolean;
  @ViewChild('lastshiftModal') private lastshiftModal!: TemplateRef<any>;
  @ViewChild('historyBatchModal') private historyBatchModal!: TemplateRef<any>;
  @ViewChild('historyMaterialModal')
  private historyMaterialModal!: TemplateRef<any>;
  @ViewChild('materialViewModal') private materialViewModal!: TemplateRef<any>;
  @ViewChild('popupViewModal') private popupViewModal!: TemplateRef<any>;
  @ViewChild('historyBatch1Modal')
  private historyBatch1Modal!: TemplateRef<any>;
  @ViewChild('centerlineModal') private centerlineModal!: TemplateRef<any>;
  @ViewChild('displayshiftcloseRoleModal')
  private displayshiftcloseRoleModal!: TemplateRef<any>;
  @ViewChild('batchchecklist1RoleModal')
  private batchchecklist1RoleModal!: TemplateRef<any>;
  @ViewChild('batchchecklistOnlyForShowRoleModal')
  private batchchecklistOnlyForShowRoleModal!: TemplateRef<any>;
  @ViewChild('imageZoomModel') private imageZoomModel!: TemplateRef<any>;
  @ViewChild('imageZoomModelShow')
  private imageZoomModelShow!: TemplateRef<any>;
  @ViewChild('matTabId', { static: false }) matTabId!: MatTabGroup;
  @ViewChild('displayQCModal') private displayQCModal!: TemplateRef<any>;
  groups!: any[];

  lotcode: LotCode[] = [
    { value: 'yes', viewValue: 'yes' },
    { value: 'no', viewValue: 'no' },
  ];

  datatype: DataType[] = [
    { value: 'Bool', viewValue: 'Bool' },
    { value: 'String', viewValue: 'String' },
    { value: 'Number', viewValue: 'Number' },
  ];

  select: Select[] = [
    { value: 'MachineParameters', viewValue: 'MachineParameters' },
    { value: 'MaterialParameters', viewValue: 'MaterialParameters' },
    { value: 'ClearanceParameters', viewValue: 'ClearanceParameters' },
  ];

  typename: TypeName[] = [
    { value: 'Batch Input', viewValue: 'Batch Input' },
    { value: 'Batch Output', viewValue: 'Batch Output' },
    { value: 'Waste', viewValue: 'Waste' },
  ];
  centerLineDataSource!: MatTableDataSource<any>;
  centerlineColumns: any[] = ['operationName', 'enteron', 'sfdcactions'];
  materialConsumptionDataSource!: MatTableDataSource<any>;
  materialConsumptionDataSource1!: MatTableDataSource<any>;
  materialColumns: any[] = [
    'itemtype',
    'batch',
    'length',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];

  materialFoodSectorColumns: any[] = [
    'isrework',
    'batch',
    'length',
    'totalActQty',
    'remarks',
    'time',
    'createdon',
    'createdby',
    'sfdcactions',
  ];
  materialSubColumns: any[] = [
    'itemtype',
    'itemDesc',
    'itemuom',
    'estQty',
    'actQty',
    'supplier',
    'prodDate',
    'expireDate',
  ];
  wasteDataSource!: MatTableDataSource<any>;
  ProductionOutputDataSource1!: MatTableDataSource<any>;
  ViewProductionOutputDataSource!: MatTableDataSource<any>;
  wasteDataSource1!: MatTableDataSource<any>;
  wasteColumns: any[] = [
    'cattype',
    'time',
    'failure',
    'uom',
    'createdon',
    'createdby',
  ];
  wastehistoryColumns: string[] = [
    'cattype',
    'time',
    'uom',
    'failure',
    'createdon',
    'createdby',
    'action',
  ];
  downtimeDataSource!: MatTableDataSource<any>;
  downtimeColumns: any[] = [
    'action',
    'starttime',
    'endtime',
    'duration',
    'fault',
    'remarks',
    'createdon',
    'createdby',
  ];
  downtimeColumnsShortStop: any[] = [
    'starttime',
    'endtime',
    'duration',
    'fault',
    'remarks',
    'createdon',
    'createdby',
  ];
  productionOutputDataSource!: MatTableDataSource<any>;
  productionColumns: any[] = ['checklist', 'values'];
  downtimeHistoryDataSource!: MatTableDataSource<any>;
  production1Columns: string[] = [
    'action',
    'batchCon',
    'lotcode',
    'act',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];
  downtimehistoryColumns: string[] = [
    'sfdcactions',
    'starttime',
    'endtime',
    'duration',
    'fault',
    'remarks',
    'createdon',
    'createdby',
  ];
  HistoryBatchDataSource = new MatTableDataSource<any>();
  HistoryBatchDataSource1!: MatTableDataSource<any>;
  historyColumns: string[] = [
    'action',
    'batchCon',
    'lotcode',
    'act',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];

  historybatch1Columns: any[] = [
    'sfdcactions',
    'itemtype',
    'lotcode',
    'act',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];
  historybatchColumns: any[] = [
    'actions',
    'itemtype',
    'lotcode',
    'act',
    'remarks',
    'time',
    'createdon',
    'createdby',
  ];
  poListDataSource!: MatTableDataSource<any>;
  polistColumns: any[] = [
    'action',
    'Id',
    'poNo',
    'operationNo',
    'status',
    'productDetails',
    'itemCode',
    'itemDescription',
    'priority',
    'remarks',
    'createdon',
    'createdby',
  ];
  lastShiftDataSource!: MatTableDataSource<any>;
  lastshiftColumns: string[] = ['sno', 'validations'];
  processparameter1Columns: string[] = ['processparameter', 'values'];
  processparameter1DataSource!: MatTableDataSource<any>;
  processparameter2Columns: string[] = ['materialparameter', 'values'];
  processparameter22DataSource!: MatTableDataSource<any>;
  processparameter3Columns: string[] = ['lineclearance', 'values'];
  processparameter33DataSource!: MatTableDataSource<any>;
  sfdcColumns: string[] = ['name', 'action', 'sfdcactions'];
  SFDCColumns: string[] = ['result', 'name', 'uom', 'action', 'SFDCactions'];
  shiftDataSource!: MatTableDataSource<any>;
  shiftColumns: string[] = ['sno', 'validation', 'values'];
  shiftactionDataSource!: MatTableDataSource<any>;
  shiftactionColumns: any[] = ['sno', 'item'];
  PerformanceColumns: string[] = ['order', 'qty', 'speed', 'total', 'diff'];
  PerformanceDataSource!: MatTableDataSource<any>;
  qualityColumns: string[] = [
    'order',
    'production',
    'waste',
    'pieces',
    'calculation',
  ];
  qualityDataSource!: MatTableDataSource<any>;
  availabilityColumns: string[] = ['ttime', 'dtime', 'atime', 'rtime', 'mtime'];
  availabilityDataSource!: MatTableDataSource<any>;
  batchChecklist1Columns: string[] = ['checklist', 'values'];
  onlyShowCheckListDataSource!: MatTableDataSource<any>;
  batchChecklistOnlyForShowColumns: string[] = ['checklist', 'values'];
  treeControl = new NestedTreeControl<PlantGroupElement>(
    (node) => node.children
  );
  hasChild = (_: number, node: PlantGroupElement) =>
    !!node.children && node.children.length > 0;

  ngOnDestroy(): any {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngAfterViewInit(): void {
    this.gridOptionsProcessControl.api.hideOverlay();
    this.gridOptionsQualityControl.api.hideOverlay();
  }
  ngOnInit(): void {
    this.sDate.setHours(this.sDate.getHours() - 2);
    this.GetBreadcrumList();
    this.GetMenuAccess();
    this.getGroups();
    this.GetStatus();
    this.GetTotalBatchForStaticTotal();
    this.GetLableBatchForStatic();
    //this.getLangWords();
    this.date1 = new FormControl(new Date());
    this.date4 = new FormControl(new Date());
    this.date2 = new FormControl(
      new Date(new Date().getTime() + this.ONE_HOUR)
    );
    this.subtractedDate = new FormControl(new Date(new Date().getHours() - 2));
    this.date3 = Date();
    this.total = 'Total: ';
    this.itemCode = 'ProdCode: ';
    const role = localStorage.roleName ? JSON.parse(localStorage.roleName) : '';
    this.executeRole = role.includes('Operator');
    this.groupByQCColumns = ['ParamaterGroup'];
    this.groupDataForm = this.fb.group({
      Id: [],
      group: [''],
      status: [''],
      Unit: [''],
      processOrder: [''],
      operationName: [''],
      productDetail: [''],
      itemCode: [''],
      itemDescription: [''],
      remarks: [''],
      fromProcessDate: ['', Validators.required],
      toProcessDate: ['', Validators.required],
      processType: [''],
      parameterInterval: [],
      intervalType: [],
    });
    this.processControlForm = this.fb.group({
      groupType: [''],
      eventType: [''],
      timeInterval: [0],
      datePicker: [''],
      processType: [''],
      parameterGroup: [''],
      // fromProcessDate: [''],
      // toProcessDate: [''],
      pdfcolumn: [''],
    });
    this.qualityControlForm = this.fb.group({
      groupType: [''],
      eventType: [''],
      datePicker: [''],
      timeInterval: [0],
      fromProcessDate: [''],
      toProcessDate: [''],
      parameterGroup: [''],
      pdfcolumnQC: [''],
    });
    this.poListForm = this.fb.group({
      Id: [],
      poNo: [''],
      operationNo: [''],
      status: [''],
      productDetails: [''],
      itemCode: [''],
      itemDescription: [''],
      priority: [''],
      action: [''],
    });

    this.materialConsumptionForm = this.fb.group({
      Id: [],
      materialDate: new Date(),
      qty: [],
      lot: [],
      actQty: [],
      remarks: [],
      date: [],
    });
    this.materialFoodSectorConsumptionForm = this.fb.group({
      isRework: [],
      mlotCode: [],
      mActQtys: [],
      tActQtys: [],
      mTime: new FormControl(new Date(), [Validators.required]),
      remarks: [],
    });

    this.processLineForm = this.fb.group({});

    this.downTimeForm = this.fb.group({
      Id: [],
      startDate: new Date(),
      endDate: new Date(new Date().getTime() + this.ONE_HOUR),
      duration: [''],
      fault: [''],
      faults: [''],
      remarks: [''],
    });

    this.wasteForm = this.fb.group({
      categoryType: [],
      dateTime: new Date(),
      uom: [],
      failureMode: [],
    });

    this.shortStopsForm = this.fb.group({
      startDate: new Date(),
      endDate: new Date(),
      duration: [''],
      fault: [''],
      remarks: [''],
    });

    this.productionOutputForm = this.fb.group({
      batchcon: [],
      pallet: [''],
      actQty: [''],
      remarks: [''],
      time: new Date(),
    });

    this.checklistDataForm = this.fb.group({
      group: ['', Validators.required],
      plant: ['', Validators.required],
      checktype: ['', Validators.required],
      checkname: ['', [Validators.required, Validators.pattern('[^"]+$')]],
      area: [''],
      executionDate: ['', Validators.required],
      shift: [''],
      shiftName: [''],
      unitName: ['', Validators.required],
      currentProcessOrder: [''],
      currentProcessOrderId: [''],
      currentProductName: [''],
      previousProcessOrder: [''],
      previousProcessOrderId: [''],
      previousProductName: [''],
    });
    const start = new Date();
    const processdates: any[] = [];
    processdates.push(new Date(start.setHours(0, 0, 0, 0)).toISOString());
    processdates.push(new Date().toISOString());

    const processselected = {
      startDate: new Date(start.setHours(0, 0, 0, 0)),
      endDate: new Date(),
    };
    // this.processControlForm
    //   .get('datePicker')
    //   ?.setValue(processdates, { emitEvent: false });

    const qualitydates: any[] = [];
    qualitydates.push(new Date(start.setHours(0, 0, 0, 0)).toISOString());
    qualitydates.push(new Date().toISOString());

    // this.processControlForm
    //   .get('datePicker')
    //   ?.valueChanges.subscribe((v) => this.onToProcessDate());
    this.processControlForm.get('datePicker')?.setValue(processselected);
    const qualityselected = {
      startDate: new Date(start.setHours(0, 0, 0, 0)),
      endDate: new Date(),
    };
    this.qualityControlForm.get('datePicker')?.setValue(qualityselected);
    // this.qualityControlForm
    //   .get('datePicker')
    //   ?.valueChanges.subscribe((v) => this.onToProcessDateQuanlityControl());
    const source = interval(5 * 60 * 1000);
    // * 60
    this.subscription = source.subscribe((val) => this.onRefresh());
  }

  onRefresh(): void {
    if (this.processControlForm.valid || this.qualityControlForm.valid) {
      // this.processControlForm.get('toProcessDate')?.setValue(new Date());
      const startprocess = this.processControlForm.value.datePicker.startDate;
      const processselected = {
        startDate: startprocess,
        endDate: new Date(),
      };
      this.processControlForm.get('datePicker')?.setValue(processselected);
      // this.processControlForm
      //   .get('datePicker')
      //   ?.setValue([this.processControlForm.value.datePicker[0], new Date()], {
      //     emitEvent: false,
      //   });
      const startquality = this.qualityControlForm.value.datePicker.startDate;
      const qualityselected = {
        startDate: startquality,
        endDate: new Date(),
      };
      this.qualityControlForm.get('datePicker')?.setValue(qualityselected);
      // this.qualityControlForm
      //   .get('datePicker')
      //   ?.setValue([this.qualityControlForm.value.datePicker[0], new Date()], {
      //     emitEvent: false,
      //   });
      if (this.ResumeInterval) {
        this.rowDataProcessControl = [];
        this.rowDataQualityControl = [];
        this.onToProcessDate();
        this.onToProcessDateQuanlityControl();
      }
    } else {
      this.spinner.hide();
    }
  }

  toggleTimer(): void {
    if (this.ResumeInterval) {
      this.ResumeInterval = false;
    } else {
      this.ResumeInterval = true;
    }
  }

  GetCrewScheduleList(): void {
    const key = {
      PUID: this.unitId,
      Date: new Date(), // .format('YYYY-MM-DD'),
    };
    this.crewService.GetCrewScheduleList(key).then((res: any) => {
      this.crewScheduleList = res.CrewScheduleList;
      if (this.crewScheduleList.length) {
        const date = new Date();
        // tslint:disable-next-line:max-line-length
        const record = this.crewScheduleList.filter(
          (c: any) =>
            date.getTime() >= new Date(c.ShiftStart).getTime() &&
            date.getTime() <= new Date(c.ShiftEnd).getTime()
        );
        if (record.length) {
          const start = new Date(record[0].ShiftStart);
          const end = new Date();
          // this.processControlForm
          //   .get('datePicker')
          //   ?.setValue([start, end], { emitEvent: false });
          const processselected = {
            startDate: start,
            endDate: new Date(),
          };
          this.processControlForm.get('datePicker')?.setValue(processselected);
          const qualityselected = {
            startDate: start,
            endDate: new Date(),
          };
          this.qualityControlForm.get('datePicker')?.setValue(qualityselected);
          // this.qualityControlForm
          //   .get('datePicker')
          //   ?.setValue([start, end], { emitEvent: false });
          this.GetGroupTypeList();
          this.GetQualityControlGroupTypeList();
        } else {
          const start = new Date();
          const processselected = {
            startDate: new Date(start.setHours(0, 0, 0, 0)),
            endDate: new Date(),
          };
          this.processControlForm.get('datePicker')?.setValue(processselected);
          const qualityselected = {
            startDate: new Date(start.setHours(0, 0, 0, 0)),
            endDate: new Date(),
          };
          this.qualityControlForm.get('datePicker')?.setValue(qualityselected);
          // this.processControlForm
          //   .get('datePicker')
          //   ?.setValue(
          //     [new Date(start.setHours(0, 0, 0, 0)).toISOString(), new Date()],
          //     { emitEvent: false }
          //   );
          // this.qualityControlForm
          //   .get('datePicker')
          //   ?.setValue(
          //     [new Date(start.setHours(0, 0, 0, 0)).toISOString(), new Date()],
          //     { emitEvent: false }
          //   );
          this.GetGroupTypeList();
          this.GetQualityControlGroupTypeList();
        }
      } else {
        const start = new Date();
        const processselected = {
          startDate: new Date(start.setHours(0, 0, 0, 0)),
          endDate: new Date(),
        };
        this.processControlForm.get('datePicker')?.setValue(processselected);
        const qualityselected = {
          startDate: new Date(start.setHours(0, 0, 0, 0)),
          endDate: new Date(),
        };
        this.qualityControlForm.get('datePicker')?.setValue(qualityselected);
        // this.processControlForm
        //   .get('datePicker')
        //   ?.setValue(
        //     [new Date(start.setHours(0, 0, 0, 0)).toISOString(), new Date()],
        //     { emitEvent: false }
        //   );
        // this.qualityControlForm
        //   .get('datePicker')
        //   ?.setValue(
        //     [new Date(start.setHours(0, 0, 0, 0)).toISOString(), new Date()],
        //     { emitEvent: false }
        //   );
        this.GetGroupTypeList();
        this.GetQualityControlGroupTypeList();
      }
    });
  }
  public checkErrorMaterialFoodConsumption = (
    controlName: string,
    errorName: string
  ) => {
    return this.materialFoodSectorConsumptionForm.controls[
      controlName
    ].hasError(errorName);
  };

  public localizeHeader(parameters: any) {
    let headerIdentifier = parameters.colDef.field;
    return this.getTransalatedValue(headerIdentifier);
  }

  getTransalatedValue(value: string) {
    let val;
    if (this.langObj && this.langObj[value]) {
      val = this.langObj[value];
    }
    return val ? val : value;
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1,
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
      if (this.langObj) {
        this.gridApi?.refreshHeader();
      }
    });
  }

  get repeatactionItemsFormGroup(): any {
    return this.shiftCloseFormGroup.get('actionItems') as FormArray;
  }
  createactionItemsForm(): FormGroup {
    return this.fb.group({
      actionItem: [''],
    });
  }

  addRepeatActionItems(): void {
    this.shiftCloseFormArray.push(this.createactionItemsForm());
  }

  shAdd(): void {
    // //
    const data: ShiftCloseInterface[] = [];
    for (let i = 1; i <= 50; i++) {
      data.push(this.createNewRow(i));
    }
    this.shiftactionDataSource.data.push(
      this.createNewRow(this.shiftactionDataSource.data.length + 1)
    );
    this.shiftactionDataSource.filter = '';
    this.shiftCloseArray.push(
      this.createNewRow(this.shiftactionDataSource.data.length)
    );
  }

  createNewRow(id: number): ShiftCloseInterface {
    return {
      sno: id,
      item: '',
    };
  }

  shiftCloseChange(event: any, element: any): void {
    const found = this.shiftCloseArray.find((x) => x.sno === element.sno);
    if (found) {
      found.item = event.target.value.trim();
    }
  }

  validationChange(event: any, element: any): void {
    this.ValidationList.find((item) => item.KpiparaId === element.KpiparaId).KpiValues = event.target.value;
  }

  getProcessIntervalType(): void {
    const key = {
      puId: this.MachineId,
    };
    this.processService.getVariableGroupEvents(key).subscribe(
      (data: any) => {
        this.processIntervalTypeDDL = data;
        this.processControlForm
          .get('eventType')
          ?.setValue(this.processIntervalTypeDDL[0].val);
        this.onToProcessDate();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  getQualityIntervalType(): void {
    const key = {
      puId: this.MachineId,
    };
    this.processService.getQualityGroupEvents(key).subscribe(
      (data: any) => {
        this.QualityIntervalTypeDDL = data;
        if (this.QualityIntervalTypeDDL.length) {
          this.qualityControlForm
            .get('eventType')
            ?.setValue(this.QualityIntervalTypeDDL[0]?.val);
          this.onToProcessDateQuanlityControl();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  isNumber(val: any): boolean {
    return typeof val === 'number';
  }
  isBoolean(val: any): boolean {
    return typeof val === 'boolean';
  }
  isString(val: any): boolean {
    return typeof val === 'string';
  }

  // Below functionality is enabled only for OLP Machine 'ER-WE-PA' UnitId = 40
  // Auto Calculating the actual weight based on the calculation from the pallet info .

  calculateInput(event: any): void {
    if (this.unitId == 40 && event.target.value.length > 12) {
      const T1 = event.target.value.slice(3, 8) / 10000;
      const T2 = event.target.value.slice(8, 12);
      const Sum = T1 * T2;
      if (Sum > 0) {
        this.materialConsumptionForm.get('actQty')?.setValue(Sum.toFixed(2));
      }
    }
  }

  getGroups(): void {
    const key = {
      Id: 0,
    };
    this.sfdService.getGroupData(key).subscribe((res: any) => {
      this.unitId = '';
      this.groups = res.masterList;
      this.groupDataForm.get('group')?.setValue(this.groups[0]?.TypeId);
      if (this.groups.length > 0) {
        this.filteredModules = this.groups.slice();
      }
    });
  }

  GetSTFault(): void {
    const key = {
      PUId: this.MachineId,
    };
    this.sfdService.GetSTFault(key).subscribe((res: any) => {
      this.GTList = res.FaultList;
      this.filteredGTList = this.GTList.slice();
      this.shortStopsForm.get('fault')?.setValue(this.GTList[0]?.FaultId);
    });
  }

  GetStatus(): void {
    const key = {};
    this.sfdService.GetStatus(key).subscribe((res: any) => {
      this.statusList = res.masterList;
      if (this.statusList.length > 0) {
        this.filteredStatus = this.statusList.slice();
      }
    });
  }

  GetJbWasteHistoryForHistory(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: true,
    };
    this.spinner.show();
    this.sfdService.GetJbWasteHistory(key).subscribe((res: any) => {
      this.newJbWasteHistoryList = res.JbWasteHistoryList;
      this.rowDataWasteHistory = res.JbWasteHistoryList;
      this.spinner.hide();
      this.wasteDataSource1 = new MatTableDataSource<any>([
        this.newJbWasteHistoryList[0],
      ]);
    });
  }

  GetJbWasteHistory(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: false,
    };
    this.spinner.show();

    this.sfdService.GetJbWasteHistory(key).subscribe((res: any) => {
      this.newJbWasteHistoryList = res.JbWasteHistoryList;
      this.wasteDataSource1 = new MatTableDataSource<any>(
        res.JbWasteHistoryList
      );
      this.spinner.hide();
    });
  }

  SaveJBWasteInfo(): void {
    const key = {
      TransactionTypeId: 1,
      PPDID: this.PPID,
      WasteEntryId: 0,
      FaultId: this.wasteForm.get('categoryType')?.value,
      Amount: this.wasteForm.get('uom')?.value,
      Time: this.wasteForm.value.dateTime,
      Remarks: this.wasteForm.get('failureMode')?.value,
      UserId: 0,
    };
    this.sfdService.SaveJBWasteInfo(key).subscribe(
      (res: any) => {
        this.GetJbWasteHistoryForHistory();
        this.GetTotalWaste();
        this.showPopupMsg(res.ErrorMessage);
        this.wasteForm.get('failureMode')?.reset();
        this.wasteForm.get('uom')?.reset();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  UpdateJBWasteInfo(): void {
    const key = {
      TransactionTypeId: 2,
      PPDID: this.PPID,
      WasteEntryId: this.WasteEntryId,
      FaultId: this.wasteForm.get('categoryType')?.value,
      Amount: this.wasteForm.get('uom')?.value,
      Time: this.wasteForm.value.dateTime,
      Remarks: this.wasteForm.get('failureMode')?.value,
      UserId: 0,
    };

    this.sfdService.SaveJBWasteInfo(key).subscribe(
      (res: any) => {
        this.GetJbWasteHistory();
        this.GetTotalWaste();
        this.showPopupMsg(res.ErrorMessage);
        this.wasteForm.get('failureMode')?.reset();
        this.wasteForm.get('uom')?.reset();
        this.wasteMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  GetKpiParameters(): void {
    const key = {
      PUId: this.MachineId,
      UserId: 0,
    };
    this.spinner.show();

    this.sfdService.GetKpiParameters(key).subscribe((res: any) => {
      this.processparameter1DataSource = new MatTableDataSource<any>(
        res.ProcessParameterList
      );
      this.processparameter22DataSource = new MatTableDataSource<any>(
        res.MeterialParameterList
      );
      this.processparameter33DataSource = new MatTableDataSource<any>(
        res.LineParameterList
      );
      this.spinner.hide();
    });
  }

  SumbitJobKpiParameters(element1: any): void {
    this.processValues1 = [];
    console.log(element1);
    const table1 = this.processparameter1DataSource.filteredData;
    const table2 = this.processparameter22DataSource.filteredData;
    const table3 = this.processparameter33DataSource.filteredData;
    table1.forEach((element) => {
      console.log(element);
      const Id = element.id;
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues1.push(data);
    });
    table2.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues1.push(data);
    });
    table3.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues1.push(data);
    });
    const key = {
      UserId: 0,
      TransactionTypeId: 1,
      JobKpiParamInfoId: 0,
      JobkpiparaInfoList: this.processValues1,
    };
    this.sfdService.SumbitJobKpiParameters(key).subscribe(
      (res: any) => {
        this.GetKpiParamInfoList(element1);
        this.showPopupMsg(res.ErrorMessage);
        this.dialog.closeAll();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  SumbitJobKpiParameters1(element1: any): void {
    // //
    this.processValues = [];
    const table1 = this.processparameter1DataSource.filteredData;
    const table2 = this.processparameter22DataSource.filteredData;
    const table3 = this.processparameter33DataSource.filteredData;
    table1.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues.push(data);
    });
    table2.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues.push(data);
    });
    table3.forEach((element) => {
      const data = {
        PPD_Id: this.PPID,
        KpiParameterId: element.KpiparaId,
        KpiParameterValue: element.KpiValues,
      };
      this.processValues.push(data);
    });
    const key = {
      UserId: 0,
      TransactionTypeId: 2,
      JobKpiParamInfoId: this.obKpiParamInfoId1,
      JobkpiparaInfoList: this.processValues,
    };
    this.sfdService.SumbitJobKpiParameters(key).subscribe(
      (res: any) => {
        console.log(res);
        this.GetKpiParamInfoList(element1);
        this.showPopupMsg(res.ErrorMessage);
        this.dialog.closeAll();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  editProcessParameter(element: any): void {
    this.centerLineMode = false;
    this.dialog.open(this.centerlineModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.obKpiParamInfoId1 = element.JobKpiParamInfoId;
    this.GetKpiParamInfoDetails();
  }

  GetKpiParamInfoDetails(): void {
    this.booleanConvertedArray = [];
    this.booleanConvertedArray1 = [];
    this.booleanConvertedArray2 = [];
    const key = {
      PPD_Id: this.PPID,
      UserId: 0,
      JobKpiParamInfoId: this.obKpiParamInfoId1,
    };
    this.spinner.show();
    this.sfdService.GetKpiParamInfoDetails(key).subscribe((res: any) => {
      this.spinner.hide();

      this.MaterialParameterList = res.MeterialParameterList;
      this.LineParameterList = res.LineParameterList;
      res.ProcessParameterList.forEach((element: any) => {
        const data = {
          KpiparaId: element.KpiparaId,
          KpiName: element.KpiName,
          KpiValues: element.KpiValues,
        };
        this.booleanConvertedArray2.push(data);
      });
      res.MeterialParameterList.forEach((element: any) => {
        const data = {
          KpiparaId: element.KpiparaId,
          KpiName: element.KpiName,
          KpiValues: element.KpiValues,
        };
        this.booleanConvertedArray.push(data);
      });
      res.LineParameterList.forEach((element: any) => {
        const data = {
          KpiparaId: element.KpiparaId,
          KpiName: element.KpiName,
          KpiValues: Boolean(JSON.parse(element.KpiValues)),
        };
        this.booleanConvertedArray1.push(data);
      });
      this.processparameter1DataSource = new MatTableDataSource<any>(
        this.booleanConvertedArray2
      );
      this.processparameter22DataSource = new MatTableDataSource<LineInterface>(
        this.booleanConvertedArray
      );
      this.processparameter33DataSource = new MatTableDataSource<LineInterface>(
        this.booleanConvertedArray1
      );
    });
  }

  GetTreeModal(): void {
    const key = {
      EGId: this.groupDataForm.value.group,
      Level: 'Unit',
      IsOptional: 0,
    };
    this.sfdService.GetTreeModal(key).subscribe((res: any) => {
      this.masterList = res.TreeModalList;
    });
  }

  SelectVarUnitName(unitname: any): any {
    if (unitname.title === 'UNT') {
      this.varUnitName = unitname.name;
      this.isPlantGroupModelVisible = false;
    }
  }

  opencenterlineModal(): void {
    this.processparameter1DataSource = new MatTableDataSource<any>([]);
    this.processparameter22DataSource = new MatTableDataSource<any>([]);
    this.processparameter33DataSource = new MatTableDataSource<any>([]);

    this.centerLineMode = true;
    if (this.machineSelectProperty === true) {
      this.dialog.open(this.centerlineModal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
    } else {
      this.toaster.error('error', this.translate.instant('PoListSelection'));
    }
    this.GetKpiParameters();
  }

  openHistorybatchModal(element: any): void {
    if (this.machineSelectProperty === true) {
      this.dialog.open(this.historyBatch1Modal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
    } else {
      this.toaster.error('error', this.translate.instant('PoListSelection'));
    }
    this.GetJbBatchHistory1();
  }
  openHistoryModal(): void {
    if (this.machineSelectProperty === true) {
      this.dialog.open(this.historyBatchModal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
      this.GetJbBatchHistoryNew();
      this.getLabelProductOutput();
    } else {
      this.toaster.error('error', this.translate.instant('PoListSelection'));
    }
  }

  getLabelProductOutput(): void {
    const key = {
      BatchTypeId: this.PPID,
      UserId: 0,
      PUID: this.MachineId,
      TypeId: 2,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.columnBatchHistory.forEach(function (colDef, index) {
        if (colDef.headerName === 'act') {
          colDef.headerName = 'Act Qty' + '(' + res.Result + ')';
        }
      });
      this.gridOptions.api.setColumnDefs(this.columnBatchHistory);
    });
  }

  onClickPopupViewForChecklistHistory(data: any): void {
    this.openPopupViewForChecklistHistory(data.data);
  }

  openPopupViewForChecklistHistory(element: any): void {
    this.dialog.open(this.popupViewModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.viewProductionHistoryBatch(element);
  }

  openWasteHistoryModal(): void {
    if (this.machineSelectProperty === true) {
      this.dialog.open(this.wastehistoryModal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
      this.GetJbWasteHistoryForHistory();
    } else {
      this.toaster.error('error', this.translate.instant('PoListSelection'));
    }
  }

  openModal(): void {
    if (this.onlymachineSelectProperty === true) {
      this.dialog.open(this.displayRoleModal, {
        width: '100vw !important',
        height: 'auto',
        minWidth: '100vw',
      });
      this.GetJbDowntimeHistory1();
    } else {
      this.toaster.error('error', this.translate.instant('UnitSelection'));
    }
  }

  openTreeModal(): void {
    this.updateOrderprocessingData = true;
    const key = {
      EGId: this.groupDataForm.value.group,
      level: 'Unit',
      CreatedBy: 0,
      IsOptional: 0,
    };

    this.enterpriseGroupService.getTreeModal(key).subscribe(
      (data: any) => {
        const plantGroupData: PlantGroupElement[] = data.TreeModalList;
        this.plantGroupSource.data = plantGroupData;
        this.treeControl.dataNodes = this.plantGroupSource.data;
        this.isPlantGroupModelVisible = true;
        this.expandAllNode();
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  // collapse group view
  collapseAllNode(): void {
    this.treeControl.collapseAll();
  }

  selectHistory(data: any): void {
    this.selectHistoryProcessOrders(data.data);
    this.GetAllQualityParameterIntervals();
  }

  // start interval event change
  changeStartParameterInterval(event: any): void {
    this.startInterval = event;
  }

  // end interval event change
  changeEndParameterInterval(event: any): void {
    this.endInterval = event;
  }

  async GetAllQualityParameterIntervals(): Promise<void> {
    const key = {
      puId: this.MachineId,
    };
    this.qualityParameterService
      .GetAllQualityParameterIntervals(key)
      .subscribe((res: any) => {
        if (res.length !== 0) {
          this.intervalId = res[0].intervalId;
          this.changeIntervalMode = false;
          if (
            res[0].intervalStartDate !== '' &&
            res[0].intervalEndDate !== ''
          ) {
            const startInterval = this.toDateWithOutTimeZone(
              res[0].intervalStartDate
            );
            // const endInterval = this.toDateWithOutTimeZone(res[0].intervalEndDate);
            const endInterval = new Date(
              new Date(
                this.toDateWithOutTimeZone(res[0].intervalStartDate)
              ).getTime() +
              60 * 60 * 24 * 1000
            );
            this.startInterval = startInterval;
            this.endInterval = endInterval;
            this.groupDataForm.get('fromProcessDate')?.setValue(startInterval);
            this.groupDataForm.get('toProcessDate')?.setValue(endInterval);
          }
        } else {
          this.changeIntervalMode = true;
          this.isIntervalSaveMode = true;
          this.changeStartParameterInterval('');
          this.changeEndParameterInterval('');
          this.toDateWithOutTimeZone('');
        }
      });
  }

  // convert UTC time stamp to current date and time
  toDateWithOutTimeZone(date: any): any {
    const tempTime = date.split(':');
    const dt = new Date();
    dt.setHours(tempTime[0]);
    dt.setMinutes(tempTime[1]);
    dt.setSeconds(tempTime[2]);
    return dt;
  }

  selectHistoryProcessOrdersForSelectionChange(element: any): void {
    this.groupDataForm.get('Unit')?.reset();
    this.groupDataForm.get('status')?.reset();
    this.materialConsumptionForm.get('materialDate')?.reset();
    this.materialConsumptionForm.get('qty')?.reset();
    this.wasteForm.get('categoryType')?.reset();
    this.downTimeForm.get('fault')?.reset();
    this.shortStopsForm.get('fault')?.reset();
    this.shortStopsForm.get('duration')?.reset();
    this.productionOutputForm.get('pallet')?.reset();
    this.ItemTypeList = [];
    this.FaultList = [];
    this.DTFaultList = [];
    this.GTList = [];
    this.filteredDTFaultList = [];
    this.filteredGTList = [];
    this.masterList = [];
    this.rowDataProcessControl = [];
    this.rowDataQualityControl = [];
    // this.statusList = [];
    this.showButtons = false;
    this.showShiftClose = false;
    this.onlymachineSelectProperty = false;
    this.machineSelectProperty = false;
    this.productionOutputDataSource = new MatTableDataSource<any>([]);
    this.selectHistoryProcessOrders(element);
  }
  selectHistoryProcessOrders(element: any): void {
    this.dialog.closeAll();
    this.centerLineDataSource = new MatTableDataSource<any>([]);
    this.materialConsumptionDataSource = new MatTableDataSource<any>([]);
    this.HistoryBatchDataSource1 = new MatTableDataSource<any>([]);
    this.wasteDataSource1 = new MatTableDataSource<any>([]);
    this.downtimeDataSource = new MatTableDataSource<any>([]);
    this.total = 'Total: ';
    this.total1 = 'Total: ';
    this.totalWaste = 'Total: ';
    this.targetQty = '';
    this.itemCode = 'ProdCode: ';
    this.groupDataForm.get('Id')?.setValue(element.PPDId);
    this.groupDataForm.get('processOrder')?.setValue(element.PO);
    this.groupDataForm.get('operationName')?.setValue(element.Oper);
    this.groupDataForm.get('productDetail')?.setValue(element.ProductDetail);
    this.PDtooltip = element.ProductDetail;
    this.groupDataForm.get('itemCode')?.setValue(element.ItemCode);
    this.groupDataForm.get('itemDescription')?.setValue(element.ItemDesc);
    this.IDtooltip = element.ItemDesc;
    this.groupDataForm.get('remarks')?.setValue(element.Remarks);
    this.groupDataForm
      .get('status')
      ?.setValue(
        this.statusList.find((c) => c.TypeName === element.OperStatus)?.TypeId
      );
    this.PPID = element.PPDId;
    this.PPS_ID = element.PPS_Id;
    this.GetProcessOrderList();
    this.GetKpiParamInfoList(element);
    this.GetItemTypeByUnit(element);
    this.getChangeStartTime(element);
    this.GetStatus();
    this.GetTotalWaste();
    this.GetLableBatch1();
    this.GetJbWasteHistory();
    this.GetJbDowntimeHistory();
    this.getMinutes(element);
    this.GetLatestLotCode();
    this.GetTotalBatch1();
    this.LastInstOPjobBatch();
    this.GetLableBatchForWaste();
    this.getItemBomListInfo();
    this.getFoodSectorMaterialConsumptionList();
    this.getBatchConsumption();
    this.wasteButtonShow = true;
    this.showMaterialButtons = true;
    this.machineSelectProperty = true;
  }

  getQty(element: any): void {
    this.materialConsumptionForm.get('qty')?.setValue(element.Qty);
  }
  refreshRollOutput(): void {
    const data = {
      PUId: this.MachineId,
      PPDID: this.PPID,
    };
    this.sfdService.GetLatestLotCode(data).subscribe((res: any) => {
      this.latestLotCode = res;
      this.materialConsumptionForm.get('pallet')?.setValue(res.latestLotCode);
    });
  }

  applyFilterForSfdc(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.centerLineDataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterForHistoryBatch(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.materialConsumptionDataSource1.filter = filterValue
      .trim()
      .toLowerCase();
  }

  applyFilterForHistoryBatchNew(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.HistoryBatchDataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterForWasteHistoryDetail(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.wasteDataSource.filter = filterValue.trim().toLowerCase();
  }

  applyFilterForDownTimeHistory(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.downtimeHistoryDataSource.filter = filterValue.trim().toLowerCase();
  }

  GetProcessOrderList(): void {
    const key = {
      PUId: this.MachineId,
      PPDId: 0,
      UserId: 0,
    };
    this.spinner.show();
    this.sfdService.GetProcessOrderList(key).subscribe((res: any) => {
      this.rowData = res.ProcessOrderList;
      this.spinner.hide();
      this.getSorting(this.poListDataSource, 9);
    });
  }

  GetMenuAccess(): void {
    const key = {
      Id: localStorage.getItem('O3RightMenuId'),
    };
    this.kpiMaster.GetMenuAccess(key).subscribe(
      (data: any) => {
        this.IsAccess = data.IsAccess;
        this.IsWrite = data.IsWrite;

        this.columnMaterialBatchHistory = [
          {
            headerName: 'Action',
            field: 'Action',
            hide: !this.IsWrite,
            cellRenderer: 'buttonEditRenderer',
            cellRendererParams: {
              onClick: this.onClickEditMaterialConsumptionBatch.bind(this),
              label: 'Edit',
            },
            maxWidth: 80,
            suppressMenu: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          { headerName: 'Item Type', field: 'Name', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Lotcode/Details', field: 'BatchNo', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'act', field: 'Result', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
          {
            headerName: 'Time',
            field: 'RollStarttime',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            maxWidth: 180,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'Created On',
            field: 'CreatedOn',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            maxWidth: 180,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          { headerName: 'Created By', field: 'CreatedBy', maxWidth: 120, headerValueGetter: this.localizeHeader.bind(this) },
        ];

        this.columnBatchHistory = [
          {
            headerName: '',
            cellRenderer: 'buttonEditRenderer',
            hide: !this.IsWrite,
            cellRendererParams: {
              onClick: this.onClickProductHistoryBatch.bind(this),
              label: 'Edit',
            },
            maxWidth: 70,
          },
          {
            headerName: 'Actions',
            field: 'Actions',
            cellRenderer: 'buttonViewRenderer',
            cellRendererParams: {
              onClick: this.onClickPopupViewForChecklistHistory.bind(this),
              label: 'View',
            },
            maxWidth: 85,
            suppressMenu: true,
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: '',
            cellRenderer: 'buttonPrintRenderer',
            cellRendererParams: {
              onClick: this.onClickGetBarCodeDetails.bind(this),
              label: 'Print',
            },
            maxWidth: 70,
          },
          { headerName: 'Batch Consumption', field: 'IPBatchNo', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Lotcode/Pallet', field: 'BatchNo', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'act', field: 'Result', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
          {
            headerName: 'Time',
            field: 'RollStarttime',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          { headerName: 'Created On', field: 'CreatedOn', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
        ];

        this.columnWasteHistry = [
          {
            headerName: 'Actions',
            field: 'Actions',
            hide: !this.IsWrite,
            cellRenderer: 'buttonEditRenderer',
            cellRendererParams: {
              onClick: this.onClickWasteHistory.bind(this),
              label: 'Edit',
            },
            maxWidth: 100,
            minWidth: 80,
            cellStyle: { textAlign: 'center' },
            headerValueGetter: this.localizeHeader.bind(this)
            // maxWidth: 100,
          },
          { headerName: 'Category type', field: 'FaultName', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Time', field: 'Time', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'qty', field: 'Amount', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'mode', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
          {
            headerName: 'Created On',
            field: 'CreatedOn',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
        ];

        this.columnDefsDowntimeHistory = [
          {
            headerName: 'Actions',
            field: 'Actions',
            cellRenderer: 'buttonEditRenderer',
            resizable: true,
            hide: !this.IsWrite,
            cellRendererParams: {
              onClick: this.onClickDowntimeHistory.bind(this),
              label: 'Edit',
            },
            maxWidth: 100,
            minWidth: 80,
            cellStyle: { textAlign: 'center' },
            headerValueGetter: this.localizeHeader.bind(this)
            //maxWidth: 100,
          },
          {
            headerName: 'Start time',
            field: 'StartTime',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          {
            headerName: 'End time',
            field: 'EndTime',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          { headerName: 'Duration', field: 'Duration', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Fault', field: 'FaultName', headerValueGetter: this.localizeHeader.bind(this) },
          { headerName: 'Remarks', field: 'Remarks', headerValueGetter: this.localizeHeader.bind(this) },
          {
            headerName: 'Created On',
            field: 'CreatedOn',
            valueFormatter: function (params: any) {
              return moment(params.value).format('DD/MM/YYYY HH:mm');
            },
            headerValueGetter: this.localizeHeader.bind(this)
          },
          { headerName: 'Created By', field: 'CreatedBy', headerValueGetter: this.localizeHeader.bind(this) },
        ];

        // this.IsWrite = false;
      },
      (error) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  //menu and breadcrumb
  GetBreadcrumList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe(
      (data: any) => {
        this.breadcrumList = data.BreadcrumList;
        this.moduleId = this.breadcrumList[0].id;
        this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
        console.log(data.BreadcrumList);
        this.getLangWords();
        this.lang = new Multilingual(this.translater, this.translate);
        this.lang.getLangWords();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }

  GetJbBatchHistory(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: false,
      BatchTypeId: 1,
      JobBatchItemTypeId:
        this.materialConsumptionForm.get('materialDate')?.value,
    };
    this.spinner.show();
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.materialConsumptionDataSource = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.spinner.hide();
    });
  }

  GetJbBatchHistory1(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: true,
      BatchTypeId: 1,
      JobBatchItemTypeId:
        this.materialConsumptionForm.get('materialDate')?.value,
    };
    this.spinner.show();
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.materialConsumptionDataSource1 = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.rowDataMaterialBatchHistory = res.JbBatchHistoryList;
      this.spinner.hide();
    });
  }

  GetJbBatchHistoryForUpdateProductionOutput(): void {

    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: false,
      BatchTypeId: 3,
      JobBatchItemTypeId: 0,
      JobBatchId: this.JobBatchId,
    };
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.productionOutputDataSource = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );

      this.GetJbBatchHistoryForProductionOutput();
    });
  }

  GetJbBatchHistoryForProductionOutput(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: false,
      BatchTypeId: 3,
      JobBatchId: this.JobBatchId,
      JobBatchItemTypeId: 0,
    };
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.productionOutputDataSource = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
    });
  }

  LastInstOPjobBatch(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: false,
      BatchTypeId: 3,
      JobBatchItemTypeId: 0,
    };
    this.spinner.show();

    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.HistoryBatchDataSource1 = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.spinner.hide();
    });
  }

  RefreshMaterialConsumption(): void {
    this.materialConsumptionForm.get('lot')?.reset();
    this.materialConsumptionForm.get('actQty')?.reset();
    this.materialConsumptionForm.get('remarks')?.reset();
    this.materialConsumptionMode = true;
  }

  RefreshMaterialSubConsumption(): void {
    this.materialFoodSectorConsumptionForm.get('remarks')?.reset();
    this.materialFoodSectorConsumptionForm.get('isRework')?.reset();
    this.materialFoodSectorConsumptionForm.get('mTime')?.setValue(new Date());
    this.JobBatchMaterialId = '';
    this.isRework = false;
    this.getItemBomListInfo();
  }

  RefreshMaterialSubConsumptionOnIsreworkChecked(): void {
    const key = {
      IsRework: this.isRework,
      PPDId: this.PPID,
    };
    this.sfdService.getItemBomListInfo(key).subscribe(
      (res: any) => {
        this.ItemBOMList = res.ItemBOMList;
        this.materialFoodSectorConsumptionForm
          .get('mActQtys')
          ?.setValue(res.Qty);
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  RefreshProductionOutput(): void {
    this.productionOutputForm.get('actQty')?.reset();
    this.productionOutputForm.get('remarks')?.reset();
    this.productionOutputForm.get('batchcon')?.reset();
    this.productionMode = true;
    this.GetBatchCheckListByUnit();
    this.LastInstOPjobBatch();
    this.GetLatestLotCode();
  }

  RefreshWaste(): void {
    this.wasteForm.get('failureMode')?.reset();
    this.wasteForm.get('uom')?.reset();
    this.wasteMode = true;
  }

  RefreshDownTime(): void {
    this.downTimeForm.get('remarks')?.reset();
    this.dialog.closeAll();
    this.downTimeMode = true;
  }

  RefreshShrtStops(): void {
    this.shortStopsForm.get('remarks')?.reset();
    this.shortStopsMode = true;
    this.dialog.closeAll();
  }

  onClickEditMaterialConsumptionBatch(data: any): void {
    this.editMaterialConsumptionHistoryBatch(data.data);
  }

  editMaterialConsumptionHistoryBatch(element: any): void {
    this.materialConsumptionMode = false;
    this.materialConsumptionForm.get('lot')?.setValue(element.BatchNo);
    this.materialConsumptionForm.get('actQty')?.setValue(element.Result);
    this.materialConsumptionForm.get('remarks')?.setValue(element.Remarks);
    this.materialConsumptionForm.get('date')?.setValue(element.RollStarttime);
    this.JobBatchId = element.JobBatchId;
    this.dialog.closeAll();
  }

  onClickProductHistoryBatch(data: any): void {
    this.editProductionHistoryBatch(data.data);
  }

  editProductionHistoryBatch(element: any): void {
    this.productionMode = false;
    this.productionOutputForm.get('batchcon')?.setValue(element.IPBatchId);
    this.productionOutputForm.get('pallet')?.setValue(element.BatchNo);
    this.productionOutputForm.get('actQty')?.setValue(element.Result);
    this.productionOutputForm.get('remarks')?.setValue(element.Remarks);
    this.productionOutputForm.get('time')?.setValue(element.RollStarttime);
    this.JobBatchId = element.JobBatchId;
    this.productionOutputDataSource = new MatTableDataSource<any>([]);
    this.GetBatchCheckListByUnitForProductionOutput();
    this.dialog.closeAll();
  }

  viewProductionHistoryBatch(element: any): void {
    this.JobBatchId = element.JobBatchId;
    this.ViewProductionOutputDataSource = new MatTableDataSource<any>([]);
    this.ViewBatchCheckListByUnitForProductionOutput();
  }

  GetJbBatchchecklistDetails(): void {
    const key = {
      PUId: this.MachineId,
      JobBatchId: this.JobBatchId,
      UserId: 0,
    };
    this.sfdService.GetJbBatchchecklistDetails(key).subscribe(
      (res: any) => {
        console.log(res);
        this.productionOutputDataSource = new MatTableDataSource<any>(
          res.batchCheckList
        );

        this.showPopupMsg(res.ErrorMessage);
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  GetJbBatchchecklistDetailsOnlyForShow(): void {
    const key = {
      PUId: this.MachineId,
      JobBatchId: this.JobBatchId,
      UserId: 0,
    };
    this.sfdService.GetBatchCheckListByUnit(key).subscribe((res: any) => {
      res.batchCheckList.forEach(
        (element: { BatchCheckListTypeId: any; Name: any; DataType: any }) => {
          const data = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            DataValue: element.DataType === 'bool' ? false : '',
          };
          this.batchCheckList.push(data);
        }
      );
      this.onlyShowCheckListDataSource = new MatTableDataSource<any>(
        res.batchCheckList
      );
    });
  }

  editWasteHistory(element: any): void {
    this.wasteMode = false;
    this.wasteForm.get('dateTime')?.setValue(element.Time);
    this.wasteForm.get('failureMode')?.setValue(element.Remarks);
    this.wasteForm.get('uom')?.setValue(element.Amount);
    this.WasteEntryId = element.WasteEntryId;
    this.dialog.closeAll();
    this.wasteForm.get('categoryType')?.setValue(element.FaultId);
  }

  onClickDowntimeHistory(data: any): void {
    this.editDownTime(data.data);
  }

  onClickWasteHistory(data: any): void {
    this.editWasteHistory(data.data);
  }

  editDownTime(element: any): void {
    const tabGroup = this.matTabId;
    if (!tabGroup || !(tabGroup instanceof MatTabGroup)) {
      return;
    }
    const tabCount = tabGroup._tabs.length;
    tabGroup.selectedIndex = 0;
    this.downTimeMode = false;
    this.downTimeForm.get('startDate')?.setValue(element.StartTime);
    this.downTimeForm.get('endDate')?.setValue(element.EndTime);
    this.downTimeForm.get('duration')?.setValue(element.Duration);
    this.downTimeForm
      .get('fault')
      ?.setValue(
        this.DTFaultList.find((x) => x.FaultName === element.FaultName).FaultId
      );
    this.downTimeForm.get('remarks')?.setValue(element.Remarks);
    this.JobDownTimeId = element.JobDownTimeId;
    this.dialog.closeAll();
    this.getMinutes(element);
    this.getEndMinutes(element);
  }

  GetJbBatchHistoryNew(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
      Ishistory: true,
      BatchTypeId: 3,
      JobBatchItemTypeId: 0,
    };
    this.spinner.show();
    this.sfdService.GetJbBatchHistory(key).subscribe((res: any) => {
      this.spinner.hide();

      this.HistoryBatchDataSource1 = new MatTableDataSource<any>(
        res.JbBatchHistoryList[0]
      );
      this.HistoryBatchDataSource = new MatTableDataSource<any>(
        res.JbBatchHistoryList
      );
      this.rowDataBatchHistory = res.JbBatchHistoryList;

      this.LastInstOPjobBatch();
    });
  }

  GetJbDowntimeHistory(): void {
    const key = {
      PUID: this.MachineId,
      UserId: 0,
      Ishistory: false,
    };
    this.spinner.show();

    this.sfdService.GetJbDowntimeHistory(key).subscribe((res: any) => {
      this.spinner.hide();

      this.JbDowntimeHistoryList = res.JbDowntimeHistoryList;
      this.downtimeDataSource = new MatTableDataSource<any>(
        res.JbDowntimeHistoryList
      );
      this.downTimeForm.get('duration')?.setValue('60');
    });
  }

  GetJbDowntimeHistory1(): void {
    const key = {
      PUID: this.MachineId,
      UserId: 0,
      Ishistory: true,
    };
    this.spinner.show();
    this.sfdService.GetJbDowntimeHistory(key).subscribe((res: any) => {
      this.JbDowntimeHistoryList = res.JbDowntimeHistoryList;
      this.downtimeHistoryDataSource = new MatTableDataSource<any>(
        res.JbDowntimeHistoryList
      );
      this.rowDataDowntimeHistory = res.JbDowntimeHistoryList;
      this.spinner.hide();

      this.GetJbDowntimeHistory();
    });
  }
  getBatchConsumption() {
    const key = {
      id: this.PPID,
    };
    this.sfdService.getBatchConsumptionDD(key).subscribe(
      (res: any) => {
        this.batchConsumptionList = res.masterList;
        this.filteredbatchConsumptionList = this.batchConsumptionList.slice();
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  //================================================ Food Sector code here ============================//
  getFoodSector(unit: any) {
    const key = {
      Id: unit.PrimaryId,
    };
    this.sfdService.getFoodSector(key).subscribe(
      (res: any) => {
        this.isFoodSector = res.IsFoodSector;
        this.IsReworkRequired = res.IsReworkRequired;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  isReworkWork(event: any) {
    this.isRework = event.checked;
    this.RefreshMaterialSubConsumptionOnIsreworkChecked();
  }

  changeActQty(event: any, id: number) {
    this.ItemBOMList.find((item) => item.ItemBOMDetailId === id).ItemBOMValue =
      parseFloat(event.target.value);
  }

  changeSupplier(event: any, id: number) {
    this.ItemBOMList.find((item) => item.ItemBOMDetailId === id).Supplier =
      event.target.value;
  }

  changeProductionDate(event: any, id: number) {
    this.ItemBOMList.find(
      (item) => item.ItemBOMDetailId === id
    ).ProductionDate = moment(event.target.value).format('YYYY-MM-DD HH:mm');
    this.dateRangeValidation(id, event);
  }

  changeExpireDate(event: any, id: number) {
    this.ItemBOMList.find((item) => item.ItemBOMDetailId === id).ExpireDate =
      moment(event.target.value).format('YYYY-MM-DD HH:mm');
    this.dateRangeValidation(id, event);
  }

  dateRangeValidation(id: number, event: any) {
    let from = '';
    let to = '';
    this.ItemBOMList.forEach((item: any, index: any) => {
      if (item.ItemBOMDetailId === id) {
        from = item.ExpireDate;
        to = item.ProductionDate;
        if (from && to) {
          this.invalidDate = new Date(from).valueOf() > new Date(to).valueOf();
          this.invalidDate ? { invalidRange: { from, to } } : null;
          if (this.invalidDate === false) {
            this.toaster.error(this.translate.instant('CheckExpiryDate'));
            event.target.value = '';
            this.ItemBOMList.find(
              (item) => item.ItemBOMDetailId === id
            ).ExpireDate = '';
          }
        } else if (to === '' || to === null) {
          this.toaster.error(
            this.translate.instant('ProductionDateSelection')
          );
          event.target.value = '';
          this.ItemBOMList.find(
            (item) => item.ItemBOMDetailId === id
          ).ExpireDate = '';
        }
      }
    });
  }

  getItemBomListInfo() {
    this.materialFoodSectorConsumptionForm.get('remarks')?.reset();
    this.JobBatchMaterialId = '';
    const key = {
      IsRework: this.isRework,
      PPDId: this.PPID,
    };
    this.sfdService.getItemBomListInfo(key).subscribe(
      (res: any) => {
        this.ItemBOMList = res.ItemBOMList;
        this.materialFoodSectorConsumptionForm
          .get('mActQtys')
          ?.setValue(res.Qty);
        this.materialFoodSectorConsumptionForm
          .get('mlotCode')
          ?.setValue(res.Lotcode);
        if (!this.IsReworkRequired && this.ItemBOMList.length > 0) {
          //Need to change in SP as of now workaround
          for (let i = 0; i <= this.ItemBOMList.length; i++) {
            this.ItemBOMList.find(
              (element) => element.ItemBOMValue > 0
            ).ItemBOMValue = '';
          }
        }
      },
      (error: any) => {
        this.toaster.error('error', error.message);
      }
    );
  }

  SaveFoodSectorMaterialConsumption(): void {
    this.spinner.show();
    if (this.JobBatchMaterialId > 0) {
      const array: {
        ItemBOMDetailId: number;
        ItemBOMValue: any;
        Supplier: any;
        ExpireDate: any;
        ProductionDate: any;
      }[] = [];
      this.ItemBOMList.forEach((element) => {
        const data = {
          ItemBOMDetailId: element.ItemBOMDetailId,
          Supplier: element.Supplier,
          ExpireDate: element.ExpireDate,
          ProductionDate: element.ProductionDate,
          ItemBOMValue: element.ItemBOMValue,
        };
        array.push(data);
      });
      const key = {
        TransactionTypeId: 2,
        PPDID: this.PPID,
        Result: this.materialFoodSectorConsumptionForm.value.mActQtys,
        BatchNo: this.materialFoodSectorConsumptionForm.value.mlotCode,
        Remarks: this.materialFoodSectorConsumptionForm.value.remarks,
        RollStarttime: this.materialFoodSectorConsumptionForm.value.mTime,
        UserId: 0,
        JobBatchItemBomList: array,
        JobBatchId: this.JobBatchMaterialId,
      };
      this.sfdService.SaveFoodSectorMaterialConsumption(key).subscribe(
        (res: any) => {
          if (res.HasError === false) {
            this.toaster.success(
              this.translate.instant('Success'),
              this.translate.instant('MaterialConsumptionSaved')
            );
            this.getFoodSectorMaterialConsumptionList();
            this.getBatchConsumption();
            this.getItemBomListInfo();
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
          this.spinner.hide();
        }
      );
    } else if (this.materialFoodSectorConsumptionForm.valid) {
      const array: {
        ItemBOMDetailId: number;
        ItemBOMValue: any;
        Supplier: any;
        ExpireDate: any;
        ProductionDate: any;
      }[] = [];
      this.ItemBOMList.forEach((element) => {
        const data = {
          ItemBOMDetailId: element.ItemBOMDetailId,
          Supplier: element.Supplier,
          ExpireDate: element.ExpireDate,
          ProductionDate: element.ProductionDate,
          ItemBOMValue: element.ItemBOMValue,
        };
        array.push(data);
      });
      const key = {
        TransactionTypeId: 1,
        PPDID: this.PPID,
        Result: this.materialFoodSectorConsumptionForm.value.mActQtys,
        BatchNo: this.materialFoodSectorConsumptionForm.value.mlotCode,
        Remarks: this.materialFoodSectorConsumptionForm.value.remarks,
        RollStarttime: this.materialFoodSectorConsumptionForm.value.mTime,
        UserId: 0,
        JobBatchItemBomList: array,
      };
      this.sfdService.SaveFoodSectorMaterialConsumption(key).subscribe(
        (res: any) => {
          if (res.HasError === false) {
            this.showPopupMsg(res.ErrorMessage);
            this.getFoodSectorMaterialConsumptionList();
            this.getBatchConsumption();
            this.getItemBomListInfo();
            this.spinner.hide();
          } else {
            this.spinner.hide();
          }
        },
        (error: any) => {
          this.toaster.error('error', error.message);
          this.spinner.hide();
        }
      );
    } else {
      this.toaster.error('Expiry date should be greater than Production date');
    }
    this.spinner.hide();
  }

  openHistoryFoodMaterialModal(): void {
    this.isFoodMaterialHisory = true;
    this.dialog.open(this.historyMaterialModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.getFoodSectorMaterialConsumptionHistoryList();
  }

  onClickPopupViewForMaterialHistory(data: any): void {
    this.openPopupViewForMaterialHistory(data.data);
  }

  openPopupViewForMaterialHistory(element: any): void {
    this.dialog.open(this.materialViewModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.getBatchItemBOMInfo(element, '');
  }

  onClickEditFoodSectorMaterial(data: any): void {
    this.editFoodSectorMaterial(data.data);
  }

  editFoodSectorMaterial(element: any) {
    this.JobBatchMaterialId = element.JobBatchId;
    this.spinner.show();
    const key = {
      Ishistory: false,
      PPDId: this.PPID,
      JobBatchId: element.JobBatchId,
    };
    this.sfdService.getBatchItemBOMList(key).subscribe(
      (res: any) => {
        this.materialFoodSectorConsumptionForm
          .get('mActQtys')
          ?.setValue(element.Result);
        this.materialFoodSectorConsumptionForm
          .get('mlotCode')
          ?.setValue(element.BatchNo);
        this.materialFoodSectorConsumptionForm
          .get('mTime')
          ?.setValue(element.RollStarttime);
        this.materialFoodSectorConsumptionForm
          .get('remarks')
          ?.setValue(element.Remarks);
        this.materialFoodSectorConsumptionForm
          .get('isRework')
          ?.setValue(element.IsRework);
        this.getBatchItemBOMInfo(element, 'edit');
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getFoodSectorMaterialConsumptionList() {
    const key = {
      Ishistory: false,
      PPDId: this.PPID,
    };
    this.sfdService.getBatchItemBOMList(key).subscribe(
      (res: any) => {
        this.batchItemBOMList = res.BatchItemBOMList;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }
  getFoodSectorMaterialConsumptionHistoryList() {
    const key = {
      Ishistory: true,
      PPDId: this.PPID,
    };
    this.sfdService.getBatchItemBOMList(key).subscribe(
      (res: any) => {
        this.materialHistoryItemBOMList = res.BatchItemBOMList;
        this.rowDataMaterialConsumptionHistory = res.BatchItemBOMList;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getBatchItemBOMInfo(element: any, actionType: string) {
    if (actionType === 'edit') {
      const key = {
        PUId: this.MachineId,
        JobBatchId: element.JobBatchId,
      };
      this.sfdService.getBatchItemBOMInfo(key).subscribe(
        (res: any) => {
          this.ItemBOMList = res.batchItemBOMList;
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
      this.dialog.closeAll();
    } else {
      const key = {
        PUId: this.MachineId,
        JobBatchId: element.JobBatchId,
      };
      this.sfdService.getBatchItemBOMInfo(key).subscribe(
        (res: any) => {
          this.ItemBOMViewList = res.batchItemBOMList;
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
    }
  }
  //================================================ End ================================================//
  GetLableBatch(element: any): void {
    const key = {
      BatchTypeId: this.materialConsumptionForm.get('materialDate')?.value,
      UserId: 0,
      PUID: this.MachineId,
      TypeId: 1,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.materialConsumptionForm.get('qty')?.setValue(res.Qty);
      this.materialConsumptionForm.get('date')?.setValue(new Date());
      this.qty = res.Qty;
      this.result = res.Result;
      this.columnMaterialBatchHistory.forEach(function (colDef, index) {
        if (colDef.headerName === 'act') {
          colDef.headerName = 'Act Qty' + '(' + res.Result + ')';
        }
      });
      this.columnMaterialConsumptionHistory.forEach(function (colDef, index) {
        if (colDef.headerName === 'act') {
          colDef.headerName = 'Estimated Qty' + '(' + res.Result + ')';
        }
      });
      this.itemCode =
        'Item Code: ' +
        this.ItemTypeList.find((x) => x.BatchItemTypeId === element.value)
          ?.ItemCode;
      this.GetJbBatchHistory();
      this.GetJbBatchHistory1();
      this.GetTotalBatch();
    });
  }

  GetLableBatchForWaste(): void {
    const key = {
      BatchTypeId: 0,
      UserId: 0,
      PUID: this.MachineId,
      TypeId: 3,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.resultWaste = res.Result;
      this.name = res.Name;
      this.columnWasteHistry.forEach(function (colDef, index) {
        if (colDef.headerName === 'qty') {
          colDef.headerName = res.Result;
        }
        if (colDef.headerName === 'mode') {
          colDef.headerName = res.Name;
        }
      });
    });
  }

  GetLableBatchForStatic(): void {
    const key = {
      BatchTypeId: 0,
      UserId: 0,
      PUID: 0,
      TypeId: 2,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.targetQty = res.Qty + ' ' + res.Result;
      this.Result = '(' + res.Result + ')';
    });
  }

  GetLableBatch1(): void {
    const key = {
      BatchTypeId: this.PPID,
      UserId: 0,
      PUID: this.MachineId,
      TypeId: 2,
    };
    this.sfdService.GetLableBatch(key).subscribe((res: any) => {
      this.productionOutputForm.get('time')?.setValue(new Date());
      this.targetQty = res.Qty + ' ' + res.Result;
      this.Result = '(' + res.Result + ')';
    });
  }

  GetTotalBatchForStatic(): void {
    const key = {
      PPDID: 0,
      BatchTypeId: 1,
      BatchItemTypeId: 0,
      UserId: 0,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.totalMaterial = res.ErrorMessage;
    });
  }

  GetTotalBatch(): void {
    const key = {
      PPDID: this.PPID,
      BatchTypeId: 1,
      BatchItemTypeId: this.materialConsumptionForm.get('materialDate')?.value,
      UserId: 0,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.total = res.ErrorMessage;
    });
  }

  GetTotalBatchForStaticTotal(): void {
    const key = {
      PPDID: 0,
      BatchTypeId: 3,
      BatchItemTypeId: 0,
      UserId: 0,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.total1 = res.ErrorMessage;
    });
  }

  GetTotalBatch1(): void {
    const key = {
      PPDID: this.PPID,
      BatchTypeId: 3,
      BatchItemTypeId: 0,
      UserId: 0,
    };
    this.sfdService.GetTotalBatch(key).subscribe((res: any) => {
      this.total1 = res.ErrorMessage;
    });
  }

  GetTotalWaste(): void {
    const key = {
      PPDID: this.PPID,
      UserId: 0,
    };
    this.sfdService.GetTotalWaste(key).subscribe((res: any) => {
      this.totalWaste = res.ErrorMessage;
    });
  }

  GetItemTypeByUnit(element: any): void {
    const key = {
      PUId: this.MachineId,
      BatchTypeId: 1,
      PPId: this.PPID,
      UserId: 0,
    };
    this.sfdService.GetItemTypeByUnit(key).subscribe((res: any) => {
      this.ItemTypeList = res.ItemTypeList;
      this.materialConsumptionForm
        .get('materialDate')
        ?.setValue(this.ItemTypeList[0]?.BatchItemTypeId);
      this.itemCode = this.ItemTypeList.find(
        (x) => x.BatchItemTypeId === this.ItemTypeList[0]?.BatchItemTypeId
      )?.ItemCode;
      this.JobBatchItemTypeId = this.materialConsumptionForm.value.materialDate;
      const code = { value: this.ItemTypeList[0]?.BatchItemTypeId };
      this.GetLableBatch(code);
      this.GetJbBatchHistory();
      this.GetJbBatchHistory1();
      this.GetTotalBatch();
    });
  }

  GetWasteFaultByUnit(): void {
    const key = {
      PUId: this.MachineId,
      UserId: 0,
    };
    this.sfdService.GetWasteFaultByUnit(key).subscribe((res: any) => {
      this.FaultList = res.FaultList;
      this.wasteForm.get('categoryType')?.setValue(this.FaultList[0]?.FaultId);
    });
  }

  getMinutes(event: any): void {
    const sDate = new Date(this.downTimeForm.get('startDate')?.value);
    const eDate = new Date(this.downTimeForm.get('endDate')?.value);
    const dateTimeDifference = eDate.getTime() - sDate.getTime();
    const days = dateTimeDifference / (1000 * 3600 * 24);
    const minutes = parseInt((days * 1440).toFixed(0), 10);
    this.downTimeForm.get('duration')?.setValue(minutes);
  }

  getEndMinutes(event: any): void {
    console.log(event);
    const sDate = this.downTimeForm.get('startDate')?.value;
    const eDate = this.downTimeForm.get('endDate')?.value;
    const dateTimeDifference = eDate.getTime() - sDate.getTime();
    const days = dateTimeDifference / (1000 * 3600 * 24);
    const minutes = parseInt((days * 1440).toFixed(0), 10);
    this.downTimeForm.get('duration')?.setValue(minutes);
  }

  getMinutes1(event: any): void {
    const sDate = this.downTimeForm.get('startDate')?.value;
    const eDate = this.downTimeForm.get('endDate')?.value;
    const dateTimeDifference = eDate.getTime() - sDate.getTime();
    const days = dateTimeDifference / (1000 * 3600 * 24);
    const minutes = (days * 1440).toFixed(0);
    this.downTimeForm.get('duration')?.setValue(minutes);
    this.shortStopsForm.get('duration')?.setValue(minutes);
  }

  getChangeStartTime(element: any): void {
    const min = this.shortStopsForm.get('duration')?.value;
    const today = new Date();
    const sttime = new Date(today.getTime() - min * 60000);
    this.shortStopsForm.get('startDate')?.setValue(sttime);
    this.shortStopsForm.get('endDate')?.setValue(today);
  }

  GetFaultByUnit(): void {
    const key = {
      PUId: this.MachineId,
      UserId: 0,
    };
    this.sfdService.GetFaultByUnit(key).subscribe((res: any) => {
      this.DTFaultList = res.FaultList;
      this.filteredDTFaultList = this.DTFaultList.slice();
      this.downTimeForm.get('fault')?.setValue(this.DTFaultList[0]?.FaultId);
      this.shortStopsForm.get('fault')?.setValue(this.FaultList[0]?.FaultId);
    });
  }

  GetStDuration(): void {
    const key = {
      PUId: this.MachineId,
    };
    this.sfdService.GetStDuration(key).subscribe((res: any) => {
      this.masterList = res.masterList;
    });
  }

  SaveJBDowntimeInfo(): void {
    const key = {
      TransactionTypeId: 1,
      PUID: this.MachineId,
      JobdowtimeId: 0,
      FaultId: this.downTimeForm.get('fault')?.value,
      StartTime: this.downTimeForm.get('startDate')?.value,
      EndTime: this.downTimeForm.get('endDate')?.value,
      Remarks: this.downTimeForm.get('remarks')?.value,
      Duration: this.downTimeForm.get('duration')?.value,
      UserId: 0,
    };
    this.sfdService.SaveJBDowntimeInfo(key).subscribe(
      (res: any) => {
        this.GetJbDowntimeHistory();
        this.showPopupMsg(res.ErrorMessage);
        this.downTimeForm.get('remarks')?.reset();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  SaveJBDowntimeInfoForShortStops(): void {
    const key = {
      TransactionTypeId: 1,
      PUID: this.MachineId,
      JobdowtimeId: 0,
      FaultId: this.shortStopsForm.get('fault')?.value,
      StartTime: this.shortStopsForm.get('startDate')?.value,
      EndTime: this.shortStopsForm.get('endDate')?.value,
      Duration: this.shortStopsForm.get('duration')?.value,
      Remarks: this.shortStopsForm.get('remarks')?.value,
      UserId: 0,
    };
    this.sfdService.SaveJBDowntimeInfo(key).subscribe(
      (res: any) => {
        this.GetJbDowntimeHistory();
        this.showPopupMsg(res.ErrorMessage);
        this.shortStopsForm.get('remarks')?.reset();
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  UpdateJBDowntimeInfo(): void {
    const key = {
      TransactionTypeId: 2,
      PUID: this.MachineId,
      JobdowtimeId: this.JobDownTimeId,
      FaultId: this.downTimeForm.get('fault')?.value,
      StartTime: this.downTimeForm.get('startDate')?.value,
      EndTime: this.downTimeForm.get('endDate')?.value,
      Remarks: this.downTimeForm.get('remarks')?.value,
      Duration: this.downTimeForm.get('duration')?.value,
      UserId: 0,
    };
    this.sfdService.SaveJBDowntimeInfo(key).subscribe(
      (res: any) => {
        console.log(res);
        this.GetJbDowntimeHistory();
        this.showPopupMsg(res.ErrorMessage);
        this.downTimeForm.get('remarks')?.reset();
        this.downTimeMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  SumbitProcessOrderStatus(): void {
    this.groupDataMode = true;

    const key = {
      PPDId: this.PPID,
      UserId: 0,
      PPSID: this.groupDataForm.get('status')?.value,
    };
    this.sfdService.SumbitProcessOrderStatus(key).subscribe((res: any) => {
      if (this.machineSelectProperty === true) {
        this.GetProcessOrderList();
        this.showPopupMsg(res.ErrorMessage);
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
    });
  }

  GetBatchCheckListByUnit(): void {
    this.batchCheckList = [];
    const key = {
      PUId: this.MachineId,
    };
    this.sfdService.GetBatchCheckListByUnit(key).subscribe((res: any) => {

      res.batchCheckList.forEach(
        (
          element: { BatchCheckListTypeId: any; Name: any; DataType: any },
          index: any
        ) => {
          this.BatchCheckListTypeId = element.BatchCheckListTypeId;
          const data = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            DataValue: element.DataType === 'bool' ? false : '',
          };
          this.batchCheckList.push(data);
        }
      );
      const array = [];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < res.batchCheckList.length; i++) {
        if (res.batchCheckList[i].DataType === 'dropdown') {
          array.push(res.batchCheckList[i]);
          this.dropdownArray = array;
        }
        // tslint:disable-next-line:prefer-for-of
        for (let j = 0; j < this.dropdownArray.length; j++) {
          // tslint:disable-next-line:no-unused-expression
          this.newDropdownList[i] = this.dropdownArray[j].BCListType.masterList;
          this.checkListFunctionForDropdown(
            this.batchCheckList[i].BatchCheckListTypeId,
            this.newDropdownList[i][0].TypeName
          );
        }
        console.table(this.newDropdownList[i]);
      }
      this.productionOutputDataSource = new MatTableDataSource<any>(
        this.batchCheckList
      );
    });
  }

  GetBatchCheckListByUnitForProductionOutput(): void {
    this.batchCheckList = [];
    const key = {
      PUId: this.MachineId,
      UserId: 0,
      JobBatchId: this.JobBatchId,
    };
    this.sfdService.GetJbBatchchecklistDetails(key).subscribe((res: any) => {
      const array: any = [];
      res.batchCheckList.forEach(
        (element: {
          BatchCheckListTypeId: any;
          Name: any;
          DataType: any;
          BatchCheckListValue: any;
        }) => {
          const data2 = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            BatchCheckListValue:
              element.DataType === 'date' && element.BatchCheckListValue
                ? this.convertToDate(element.BatchCheckListValue)
                : element.BatchCheckListValue,
          };
          array.push(data2);
          this.batchCheckList = res.batchCheckList;
        }
      );
      this.productionOutputDataSource = new MatTableDataSource<any>(array);
    });
  }

  ViewBatchCheckListByUnitForProductionOutput(): void {
    this.batchCheckList = [];
    const key = {
      PUId: this.MachineId,
      UserId: 0,
      JobBatchId: this.JobBatchId, // 17911
    };
    this.sfdService.GetJbBatchchecklistDetails(key).subscribe((res: any) => {
      const array: any = [];
      res.batchCheckList.forEach(
        (element: {
          BatchCheckListTypeId: any;
          Name: any;
          DataType: any;
          BatchCheckListValue: any;
        }) => {
          const data2 = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            BatchCheckListValue:
              element.DataType === 'date'
                ? this.convertToDate(element.BatchCheckListValue)
                : element.BatchCheckListValue,
          };
          array.push(data2);
        }
      );
      this.ViewProductionOutputDataSource = new MatTableDataSource<any>(array);
      this.GetBatchCheckListByUnit();
    });
  }

  convertToDate(dateString: any): any {
    const b = dateString !== null ? dateString.split('-') : '';
    const c = b[2] + '-' + b[1] + '-' + b[0];
    return new Date(c);
  }

  GetBatchCheckListByUnitOnlyForShow(): void {
    const key = {
      PUId: this.MachineId,
      UserId: 0,
      JobBatchId: this.JobBatchId,
    };
    this.sfdService.GetJbBatchchecklistDetails(key).subscribe((res: any) => {
      res.batchCheckList.forEach(
        (element: { BatchCheckListTypeId: any; Name: any; DataType: any }) => {
          const data = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            DataValue: element.DataType === 'bool' ? false : '',
          };
          this.batchCheckList.push(data);
        }
      );
      this.onlyShowCheckListDataSource = new MatTableDataSource<any>(
        res.batchCheckList
      );

      this.GetJbBatchchecklistDetailsOnlyForShow();
    });
  }

  SaveJBBatchInfoForMaterialConsumption(): void {
    const key = {
      TransactionTypeId: 1,
      PPDID: this.PPID,
      JobBatchId: 0,
      BatchTypeId: 1,
      RollNo: 0,
      Result: this.materialConsumptionForm.value.actQty,
      BatchNo: this.materialConsumptionForm.value.lot,
      BatchItemTypeId: this.materialConsumptionForm.value.materialDate,
      Remarks: this.materialConsumptionForm.value.remarks,
      RollStarttime: this.materialConsumptionForm.value.date,
      UserId: 0,
    };
    const data = {
      plantId: this.plantId,
      lotcode: this.materialConsumptionForm.value.lot,
      eventDateTime: this.materialConsumptionForm.value.date,
      eventTypeId: 1,
      puId: this.MachineId,
      processOrder: this.groupDataForm.get('processOrder')?.value,
      processOrderId: this.PPID,
    };
    this.sfdService.SaveJBBatchInfo(key).subscribe(
      (res: any) => {
        if (res.ErrorMessage.substring(2, 1) === '0') {
          this.sfdService.insertSfdcEvent(data).then(
            (response) => { },
            (error) => {
              this.showPopupMsg(error.ErrorMessage);
            }
          );
        }
        this.GetJbBatchHistory();

        this.GetTotalBatch();
        this.showPopupMsg(res.ErrorMessage);
        this.materialConsumptionForm.get('date')?.setValue(new Date());
        this.materialConsumptionForm
          .get('materialDate')
          ?.setValue(this.ItemTypeList[0]?.BatchItemTypeId);
        this.materialConsumptionForm.get('lot')?.reset();
        this.materialConsumptionForm.get('actQty')?.reset();
        this.materialConsumptionForm.get('remarks')?.reset();
        const start = this.processControlForm.value.datePicker.startDate;
        const selected = { startDate: start, endDate: new Date() };
        this.processControlForm.get('datePicker')?.setValue(selected);
        const start2 = this.qualityControlForm.value.datePicker.startDate;
        const selected2 = { startDate: start2, endDate: new Date() };
        this.qualityControlForm.get('datePicker')?.setValue(selected2);
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }
  UpdateJBBatchInfoForMaterialConsumption(): void {
    const key = {
      TransactionTypeId: 2,
      PPDID: this.PPID,
      JobBatchId: this.JobBatchId,
      BatchTypeId: 1,
      RollNo: 0,
      Result: this.materialConsumptionForm.value.actQty,
      BatchNo: this.materialConsumptionForm.value.lot,
      BatchItemTypeId: this.materialConsumptionForm.value.materialDate,
      Remarks: this.materialConsumptionForm.value.remarks,
      RollStarttime: this.materialConsumptionForm.value.date,
      UserId: 0,
    };
    this.sfdService.SaveJBBatchInfo(key).subscribe(
      (res: any) => {
        this.GetTotalBatch();
        this.GetJbBatchHistory();
        this.showPopupMsg(res.ErrorMessage);
        this.materialConsumptionForm.get('lot')?.reset();
        this.materialConsumptionForm.get('actQty')?.reset();
        this.materialConsumptionForm.get('remarks')?.reset();
        this.materialConsumptionMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  SaveJBBatchInfoForProductionOutput(): void {

    const array: {
      BatchCheckListTypeId: number;
      BatchCheckListValue: any;
    }[] = [];
    this.batchCheckList.forEach((element) => {
      const data = {
        BatchCheckListTypeId: element.BatchCheckListTypeId
          ? element.BatchCheckListTypeId
          : 0,
        BatchCheckListValue: element.DataValue ? element.DataValue : 0,
      };
      array.push(data);
    });
    const key = {
      TransactionTypeId: 1,
      PPDID: this.PPID,
      JobBatchId: 0,
      BatchTypeId: 3,
      RollNo: 0,
      Result: this.productionOutputForm.value.actQty,
      BatchNo: this.productionOutputForm.value.pallet,
      BatchItemTypeId: 0,
      Remarks: this.productionOutputForm.value.remarks,
      RollStarttime: this.productionOutputForm.value.time,
      UserId: 0,
      IPBatch: this.productionOutputForm.value.batchcon
        ? this.productionOutputForm.value.batchcon
        : 0,
      JobBatchCheckList: array,
    };
    const data = {
      plantId: this.plantId,
      lotcode: this.productionOutputForm.value.pallet,
      eventDateTime: this.productionOutputForm.value.time,
      eventTypeId: 2,
      puId: this.MachineId,
      processOrder: this.groupDataForm.get('processOrder')?.value,
      processOrderId: this.PPID,
    };
    this.isbuttDisabled = true;
    this.sfdService.SaveJBBatchInfo(key).subscribe((res: any) => {

      if (this.machineSelectProperty === true) {

        // this.GetJbBatchHistory();
        this.LastInstOPjobBatch();
        this.GetJbBatchHistoryNew();
        this.GetTotalBatch1();
        this.GetLatestLotCode();
        this.showPopupMsg(res.ErrorMessage);
        this.GetBatchCheckListByUnit();
        this.productionOutputForm.get('time')?.setValue(new Date());
        this.productionOutputForm.get('actQty')?.reset();
        this.productionOutputForm.get('remarks')?.reset();
        if (this.isAuto === false) {
          this.productionOutputForm.get('pallet')?.reset();
        }
        this.productionMode = true;
        if (res.ErrorMessage.substring(2, 1) === '0') {
          this.sfdService.insertSfdcEvent(data).then(
            (response) => { },
            (error) => {
              this.showPopupMsg(error.ErrorMessage);
            }
          );
        }
      } else {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('PoListSelection')
        );
      }
      const start = this.processControlForm.value.datePicker.startDate;
      const selected = { startDate: start, endDate: new Date() };
      this.processControlForm.get('datePicker')?.setValue(selected);
      const start2 = this.qualityControlForm.value.datePicker.startDate;
      const selected2 = { startDate: start2, endDate: new Date() };
      this.qualityControlForm.get('datePicker')?.setValue(selected2);

      this.isbuttDisabled = false;
    });
  }

  UpdateJBBatchInfoForProductionOutput(): void {
    const dataArray = this.batchCheckList;
    const array: { BatchCheckListTypeId: any; BatchCheckListValue: any }[] = [];
    dataArray.forEach((element) => {
      const data = {
        BatchCheckListTypeId: element.BatchCheckListTypeId,
        BatchCheckListValue:
          element.hasOwnProperty('DataValue') === true
            ? element.DataValue
            : element.BatchCheckListValue,
      };
      array.push(data);
    });
    const key = {
      TransactionTypeId: 2,
      PPDID: this.PPID,
      JobBatchId: this.JobBatchId,
      BatchTypeId: 3,
      RollNo: 0,
      Result: this.productionOutputForm.value.actQty,
      BatchNo: this.productionOutputForm.value.pallet,
      BatchItemTypeId: 0,
      Remarks: this.productionOutputForm.value.remarks,
      RollStarttime: this.productionOutputForm.value.time,
      UserId: 0,
      IPBatch: this.productionOutputForm.value.batchcon
        ? this.productionOutputForm.value.batchcon
        : 0,
      JobBatchCheckList: array,
    };

    this.sfdService.SaveJBBatchInfo(key).subscribe(
      (res: any) => {
        this.GetLatestLotCode();
        this.LastInstOPjobBatch();
        this.GetJbBatchHistoryNew();
        this.GetBatchCheckListByUnit();
        this.GetTotalBatch1();
        this.showPopupMsg(res.ErrorMessage);
        this.productionOutputForm.get('time')?.setValue(new Date());
        this.productionOutputForm.get('actQty')?.reset();
        this.productionOutputForm.get('remarks')?.reset();
        this.productionMode = true;
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  checkListFunction(id: number, event: any): void {
    const check = this.batchCheckList.find(
      (x) => x.BatchCheckListTypeId === id
    );
    switch (check?.DataType) {
      case 'bool':
        check.DataValue =
          check.DataValue === 'true' || check.BatchCheckListValue === 'true'
            ? false
            : true;
        break;
      case 'number':
        check.DataValue = parseInt(event.target.value, 10);
        break;
      case 'string':
        check.DataValue = event.target.value;
        break;
      case 'date':
        check.DataValue = event.target.value._d;
        break;
      case 'dropdown':
        check.DataValue = event.target.value;
    }
    console.table(this.batchCheckList);
  }
  checkListFunctionForDropdown(id: number, value: any): void {
    const check = this.batchCheckList.find(
      (x) => x.BatchCheckListTypeId === id
    );
    if (check.DataType === 'dropdown') {
      check.DataValue = value;
    }
  }

  checkListFunctionForProcess(element: any, event: any): void {
    // //
    console.log(element);
    if (!this.centerLineMode) {
      const check = this.booleanConvertedArray2.find(
        (x) => x.KpiparaId === element.KpiparaId
      );
      // tslint:disable-next-line:no-non-null-assertion
      check!.KpiValues = event.target.value;
    } else {
      const index = this.processparameter1DataSource.filteredData.findIndex(
        (e: any) => e.KpiparaId === element.KpiparaId
      );
      this.processparameter1DataSource.filteredData[index].KpiValues =
        event.target.value;
    }
  }

  checkListFunctionMaterial(element: any, event: any): void {
    console.log(element);
    if (!this.centerLineMode) {
      const check = this.booleanConvertedArray.find(
        (x) => x.KpiparaId === element.KpiparaId
      );
      check!.KpiValues = event.target.value;
    } else {
      const index = this.processparameter22DataSource.filteredData.findIndex(
        (e: any) => e.KpiparaId === element.KpiparaId
      );
      this.processparameter22DataSource.filteredData[index].KpiValues =
        event.target.value;
    }
  }

  checkListFunctionLine(element: any, event: any): void {
    if (!this.centerLineMode) {
      const check = this.booleanConvertedArray1.find(
        (x) => x.KpiparaId === element.KpiparaId
      );
      check!.KpiValues = check?.KpiValues ? false : true;
    } else {
      const index = this.processparameter33DataSource.filteredData.findIndex(
        (e: any) => e.KpiparaId === element.KpiparaId
      );
      this.processparameter33DataSource.filteredData[index].KpiValues = event
        .target.value
        ? true
        : false;
    }
  }

  editDownTimeHistory(element: any): void {
    this.dialog.closeAll();
  }

  GetLatestLotCode(): void {
    const key = {
      PPDID: this.PPID,
      PUID: this.MachineId,
    };
    this.sfdService.GetLatestLotCode(key).subscribe((res: any) => {
      this.isAuto = res.isAuto;
      if (res.isAuto === true) {
        this.productionOutputForm.get('pallet')?.setValue(res.LotCode);
      } else {
        this.productionOutputForm.get('pallet')?.setValue(res.LotCode);
      }
    });
  }

  showPopupMsg(msg: any): any {
    if (msg !== null || msg !== '') {
      if (msg.substring(2, 1) === '0') {
        this.toaster.success('Success', msg.substring(3, msg.length));
      } else {
        this.toaster.error('Error', msg.substring(3, msg.length));
      }
    }
  }
  // expand group view
  expandAllNode(): void {
    this.treeControl.expandAll();
  }

  openPoModal(): void {
    this.dialog.open(this.displayPoModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.GetProcessOrderList();
  }
  closeaddNewPlantItemModel(): void {
    this.displayUserModal = false;
  }

  getPaginator(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.paginator = this.paginator.toArray()[index];
      data.sort = this.sort.toArray()[index];
    }, 1000);
  }

  getSorting(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.sort = this.sort.toArray()[index];
    }, 1000);
  }

  GetKpiParamInfoList(element: any): void {
    const key = {
      PPD_Id: this.PPID,
      UserId: 0,
      JobKpiParamInfoId: 0,
    };
    this.sfdService.GetKpiParamInfoList(key).subscribe((res: any) => {
      this.centerLineDataSource = new MatTableDataSource<any>(
        res.KpiParameterinfoList
      );
    });
  }

  replaceIcon(value: any): any {
    return value.replace(/(<([^>]+)>)/gi, '');
  }

  closePlantGroupModel(): void {
    this.updateOrderprocessingData = false;
  }

  onNodeSelect(node: any): void {

    if (node.Level === 'Unit') {
      this.updateOrderprocessingData = false;
      this.MachineId = node.PrimaryId;
      this.unitId = node.PrimaryId;
      if (node.text !== '') {
        this.groupDataForm.get('Unit')?.setValue(node.text);
        this.rowDataProcessControl = [];
        this.rowDataQualityControl = [];
        this.customerManagementDataSource.data = [];
        // this.getParameterCavity();

        const tree = this.treeControl.dataNodes;
        const data = this.getPath(tree[0], node.id);
        this.plantId = data.find((c: any) => c.Level === 'Plant').PrimaryId;
        this.groupDataForm.get('intervalType')?.setValue('Time');
        this.getAllQualityCheckList();
        this.SelectUnitName(node);
      } else {
        return;
      }
    }
  }

  SelectUnitName(unitname: any): void {

    this.showButtons = true;
    this.onlymachineSelectProperty = true;
    this.itemCode = 'Item Code: undefined';
    if (unitname.Level === 'Unit') {
      this.UnitName = unitname.text;
      this.isPlantGroupModelVisible = false;
    }
    this.productionOutputForm.get('actQty')?.reset();
    this.productionOutputForm.get('remarks')?.reset();
    if (this.isAuto === false) {
      this.productionOutputForm.get('pallet')?.reset();
    }
    this.groupDataForm.get('processOrder')?.reset();
    this.groupDataForm.get('operationName')?.reset();
    this.groupDataForm.get('productDetail')?.reset();
    this.groupDataForm.get('itemCode')?.reset();
    this.groupDataForm.get('itemDescription')?.reset();
    this.groupDataForm.get('remarks')?.reset();
    this.groupDataForm.get('status')?.reset();
    this.materialConsumptionForm.get('qty')?.reset();
    this.productionOutputForm.get('pallet')?.reset();
    this.total = 'Total: ';
    this.total1 = 'Total: ';
    this.targetQty = '';
    this.centerLineDataSource = new MatTableDataSource<any>([]);
    this.materialConsumptionDataSource = new MatTableDataSource<any>([]);
    this.HistoryBatchDataSource1 = new MatTableDataSource<any>([]);
    this.machineSelectProperty = false;
    this.ItemTypeList = [];
    this.FaultList = [];
    this.groupTypeList = [];
    this.qualityControlGroupTypeList = [];
    this.QualityIntervalTypeDDL = [];
    this.batchConsumptionList = [];
    this.filteredbatchConsumptionList = [];
    this.getMachineProducts();
    this.GetIsShiftStart();
    this.GetLableBatchForWaste();
    this.GetStDuration();
    this.GetFaultByUnit();
    this.GetSTFault();
    this.GetWasteFaultByUnit();
    this.GetBatchCheckListByUnit();
    this.GetJbDowntimeHistory1();
    this.getFoodSector(unitname);
    this.GetCrewScheduleList();
    // this.shiftList.filter(
    //   (c: any) =>
    //     date.getTime() >= new Date(c.ShiftStart).getTime() &&
    //     date.getTime() <= new Date(c.ShiftEnd).getTime()
    // );
  }

  replaceString(value: any): any {
    const data = value.split('"')[1];
    if (data === 'IsOptionalplanticon') {
      return true;
    } else {
      return false;
    }
  }

  openshiftcloseModal(): void {
    this.dialog.open(this.displayshiftcloseRoleModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.GetShiftCloseValidation();
    this.GetValidationInfo();
  }
  opendisplaybatchModal(): void {
    this.dialog.open(this.batchchecklist1RoleModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
  }

  opendisplayOnlyForShowbatchModal(element: any): void {
    this.JobBatchId = element.JobBatchId;
    this.dialog.open(this.batchchecklistOnlyForShowRoleModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    this.GetJbBatchchecklistDetailsOnlyForShow();
  }

  openlastShiftModal(): void {
    this.dialog.open(this.lastshiftModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
  }
  DisplayRightmenu(menuId: any, url: any): any {
    localStorage.setItem('O3RightMenuId', menuId);
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate([url]));
  }
  GetMenuChildList(): any {
    const obj = {
      MenuId:
        localStorage.getItem('O3RightMenuId') === null
          ? 1
          : localStorage.getItem('O3RightMenuId'),
    };
    this.userManagementService.GetMenuChildList(obj).subscribe(
      (data: any) => {
        this.homeCardList = data.BreadcrumList;
      },
      (error) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  GetShiftCloseValidation(): void {

    const key = {
      CrewId: this.crewId,
    };
    this.sfdService.GetShiftCloseValidation(key).subscribe((res: any) => {
      this.availabilityDataSource = new MatTableDataSource<any>(
        res.AvailabilityList
      );
      this.PerformanceDataSource = new MatTableDataSource<any>(
        res.PerformanceList
      );
      this.qualityDataSource = new MatTableDataSource<any>(res.QualityList);
      this.shiftactionDataSource =
        new MatTableDataSource<ShiftCloseInterface>();
    });
  }



  GetIsShiftStart(): void {
    const key = {
      PUID: this.MachineId,
    };
    this.sfdService.GetIsShiftStart(key).subscribe((res: any) => {
      this.crewId = res.CrewId;
      if (this.crewId === 0) {
        this.showShiftClose = false;
      } else {
        this.showShiftClose = true;
      }
      this.GetShiftCloseValidation();
    });
  }

  GetValidationInfo(): void {
    const key = {
      PUID: this.MachineId,
      IsshiftStart: 0,
    };
    this.sfdService.GetValidationInfo(key).subscribe((res: any) => {
      this.ValidationList = res.ValidationList;
      this.shiftDataSource = new MatTableDataSource<any>(res.ValidationList);
    });
  }

  SumbitShiftClose(manPower: any): void {
    // if (manPower >= 0) {
    Swal.fire({
      title: this.translate.instant('MakeSure'),
      text: this.translate.instant('AllDetails'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('Ok'),
      cancelButtonText: this.translate.instant('Cancel'),
    }).then((result) => {
      if (result.value) {
        const key = {
          CrewId: this.crewId,
          ShiftActionList: this.shiftCloseArray,
          ShiftValidationList: this.validationArray,
          ManPowerRequired: manPower,
        };
        this.sfdService.SumbitShiftClose(key).subscribe((res: any) => {
          this.successMessage = res.ErrorMessage;
          this.showPopupMsg(res.ErrorMessage);
          this.GetIsShiftStart();
          this.dialog.closeAll();
        });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.translate.instant('Cancelled'),
          this.translate.instant('AlertShiftMessage'),
          'error'
        );
      }
    });
    // } else {
    //   this.toaster.error(
    //     this.translate.instant('ManPower should be greater than Zero')
    //   );
    // }
  }

  onClickGetBarCodeDetails(data: any): void {
    this.GetBarCodeDetails(data.data);
  }

  GetBarCodeDetails(element: any): void {
    //
    this.batchCheckList = [];
    this.arrayCheckList = [];

    const key1 = {
      PUId: this.MachineId,
      UserId: 0,
      JobBatchId: element.JobBatchId, //this.JobBatchId, // 17911
    };

    this.sfdService.GetJbBatchchecklistDetails(key1).subscribe((res: any) => {
      const array: any = [];
      res.batchCheckList.forEach(
        // tslint:disable-next-line:no-shadowed-variable
        (element: {
          BatchCheckListTypeId: any;
          Name: any;
          DataType: any;
          BatchCheckListValue: any;
        }) => {
          const data2 = {
            BatchCheckListTypeId: element.BatchCheckListTypeId,
            Name: element.Name,
            DataType: element.DataType,
            BatchCheckListValue: element.BatchCheckListValue,
          };
          array.push(data2);
        }
      );

      this.arrayCheckList = array;
      if (
        this.arrayCheckList.length > 0 &&
        this.arrayCheckList.some(
          (data) =>
            data.BatchCheckListValue == 'Local' ||
            data.BatchCheckListValue == 'Export'
        )
      ) {


        const key = {
          UnitId: this.MachineId,
          PPD_ID: this.PPID,
          BCType: this.arrayCheckList.some(
            (data) => data.BatchCheckListValue == 'Local'
          )
            ? 2
            : 1,
          Id: element.JobBatchId,
          PalletType: this.arrayCheckList.some(
            (data) => data.BatchCheckListValue == 'Local'
          )
            ? 'Local'
            : 'Export',
        };

        this.sfdService
          .GetBarCodeDetailsLocalOrExport(key)
          .subscribe((res: any) => {
            console.log(res);
            if (res.GetBarCodeDetails.length > 0) {
              let htmlcontent = res.GetBarCodeDetails[0].HTMLLayout;
              const detailItems = res.GetBarCodeDetails[0].detailItems;
              htmlcontent = htmlcontent.replace(
                '[BarCodeSeries]',
                res.BarCodeSeries
              );

              $.each(detailItems, (i, item) => {
                if (item.Name === 'TimeNow') {
                  htmlcontent = htmlcontent.replace(
                    '[' + item.Name + ']',
                    moment(new Date()).format('DD-MM-YYYY hh:mm A')
                  );
                } else {
                  htmlcontent = htmlcontent.replace(
                    '[' + item.Name + ']',
                    item.Value
                  );
                }
              });

              const printWindow = window.open('', 'Print-Window')!;
              printWindow.document.open();

              const styleTags =
                '' +
                '<style type="text/css">' +
                '@media print {' +
                '{-webkit-print-color-adjust: exact;}' +
                '-webkit-print-color-adjust: exact;' +
                '}' +
                'table, th, td {' +
                'border:1px solid black;' +
                'border-collapse: collapse;' +
                '}' +
                '.td-bold {font-weight:bold; color:blue; }' +
                '</style>';

              const JsBCScript =
                '' +
                '<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.3/dist/JsBarcode.all.min.js"></script>';

              const scriptTags =
                '' +
                '<script type="text/javascript">' +
                'window.addEventListener(' +
                "'load'" +
                ', function () {' +
                'JsBarcode(".barcode").init();' +
                '})' +
                '</script>';

              //printWindow.document.write(styleTags + JsBCScript + scriptTags + '<html><body onload="window.print()">' + htmlcontent + '</body></html>');
              printWindow.document.write(styleTags + JsBCScript + '<html><body onload="setTimeout(() => {window.print();},3000);">' + htmlcontent + '</body></html>');
              printWindow.document.close();

              // window.print();
            } else {
              this.toaster.error('error', 'Data is Empty !');
            }
          });
      } else {
        const key = {
          UnitId: this.MachineId,
          PPD_ID: this.PPID,
          BCType: 1,
          Id: element.JobBatchId,
        };

        this.sfdService.GetBarCodeDetails(key).subscribe((res: any) => {
          console.log(res);
          if (res.GetBarCodeDetails.length > 0) {
            let htmlcontent = res.GetBarCodeDetails[0].HTMLLayout;
            const detailItems = res.GetBarCodeDetails[0].detailItems;
            htmlcontent = htmlcontent.replace(
              '[BarCodeSeries]',
              res.BarCodeSeries
            );

            $.each(detailItems, (i, item) => {
              htmlcontent = htmlcontent.replace(
                '[' + item.Name + ']',
                item.Value
              );
            });

            const printWindow = window.open('', 'Print-Window')!;
            printWindow.document.open();

            const styleTags =
              '' +
              '<style type="text/css">' +
              'table, th, td {' +
              'border:1px solid black;' +
              'border-collapse: collapse;' +
              'padding:0.5em;' +
              '}' +
              '.td-bold {font-weight:bold; color:blue; }' +
              '</style>';

            const JsBCScript =
              '' +
              '<script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.3/dist/JsBarcode.all.min.js"></script>';

            // Not being used anymore. Being sent from BarCodeHtml table from now on.
            const scriptTags =
              '' +
              '<script type="text/javascript">' +
              'window.addEventListener(' +
              "'load'" +
              ', function () {' +
              'JsBarcode(".barcode").init();' +
              '})' +
              '</script>';

            //printWindow.document.write(styleTags + JsBCScript + scriptTags + '<html><body onload="window.print()">' + htmlcontent + '</body></html>');
            printWindow.document.write(styleTags + JsBCScript + '<html><body onload="setTimeout(() => {window.print();},3000);">' + htmlcontent + '</body></html>');
            printWindow.document.close();

            // printWindow?.print();
          } else {
            this.toaster.error('error', 'Data is Empty !');
          }
        });
      }
    });
    this.GetBatchCheckListByUnit();
  }

  GetLastShiftInfo(element: any): void {
    this.dialog.open(this.lastshiftModal, {
      width: '100vw !important',
      height: 'auto',
      minWidth: '100vw',
    });
    const key = {
      Id: this.MachineId, // 1
    };
    this.spinner.show();
    this.sfdService.GetLastShiftInfo(key).subscribe((res: any) => {
      this.masterList = res.ShiftInfoList;
      this.OEEInfoList = res.OEEInfoList;
      const array = res.OEEInfoList;
      this.DowntimeInfoList = res.DowntimeInfoList;
      this.lastShiftDataSource = new MatTableDataSource<any>(res.masterList);
      this.spinner.hide();

      array.forEach((element1: any) => {
        let colorCode = '';
        if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 0 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 20
        ) {
          colorCode = '#FF0000';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 20 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 50
        ) {
          colorCode = '#ffff00';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 50 &&
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) <= 70
        ) {
          colorCode = '#ffa500';
        } else if (
          Math.round(
            element1.OEE ||
            element1.Availability ||
            element1.Performance ||
            element1.Quality
          ) > 70
        ) {
          colorCode = '#008000';
        }
        element1.OEE = element1.OEE.toFixed(2);
        element1.Availability = element1.Availability.toFixed(2);
        element1.Performance = element1.Performance.toFixed(2);
        element1.Quality = element1.Quality.toFixed(2);
        this.showLastShiftProperty = element1.OEE > 0 ? true : false;
        element1.capacityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.OEE),
          secondColor: '#E5E5E5',
          progress: element1.OEE > 0 ? Math.round(element1.OEE) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.availabilityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Availability),
          secondColor: '#E5E5E5',
          progress:
            element1.Availability > 0
              ? Math.round(element1.Availability)
              : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.performanceUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Performance),
          secondColor: '#E5E5E5',
          progress:
            element1.Performance > 0 ? Math.round(element1.Performance) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
        element1.qualityUtilization = {
          barType: 'radial',
          color: this.colorCode(element1.Quality),
          secondColor: '#E5E5E5',
          progress: element1.Quality > 0 ? Math.round(element1.Quality) : ' 0 ',
          radial: {
            depth: 8,
            size: 96,
            label: {
              enable: true,
              color: '#09608C',
            },
          },
        };
      });

      if (res.ShiftInfoList.length > 0) {
        this.UserName = res.ShiftInfoList[0].UserName;
        this.Shift = res.ShiftInfoList[0].Shift;
        this.ShiftStart = this.masterList[0].ShiftStart;
        this.ShiftEnd = this.masterList[0].ShiftEnd;
        this.Supervisor = this.masterList[0].Supervisor;
        this.OEEInfoList = array;
        this.showMode = true;
      } else {
        this.UserName = '';
        this.Shift = '';
        this.ShiftStart = '';
        this.ShiftEnd = '';
        this.Supervisor = '';
        this.OEEInfoList = array;
        this.showMode = true;
      }

      // DownTime Chart
      this.canvas = document.getElementById('downTimeChart');
      this.canvas.height = 300;
      this.canvas.width = 530;
      this.ctx = this.canvas.getContext('2d');
      const faultArray: any[] = [];
      const durationArray: any[] = [];
      res.DowntimeInfoList.forEach((element: any) => {
        faultArray.push(element.Fault);
      });
      res.DowntimeInfoList.forEach((element: any) => {
        durationArray.push(element.Duration);
      });
      const downtime = new Chart(this.ctx, {
        type: 'horizontalBar',
        data: {
          labels: faultArray,
          datasets: [
            {
              data: durationArray,
              label: 'Down Time (Mins)',
              backgroundColor: '#040496',
            },
          ],
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: (tooltipItem: any, data: any) => {
                return data.datasets[0].data[tooltipItem.index] + '%';
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 20,
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  borderDash: [8, 4],
                },
                ticks: {                  beginAtZero: true,
                  stepSize: 10,
                  min: 0,
                  max: 80,
                  callback(value: any, index: any): any {
                    if (value === 0) {
                      return 0 + '%';
                    } else {
                      return value + '%';
                    }
                  },
                },
              },
            ],
          },
        },
      });

      // Weight Chart
      this.canvas = document.getElementById('weightChart');
      this.canvas.height = 300;
      this.canvas.width = 530;
      this.ctx = this.canvas.getContext('2d');
      const pcsFaultArray: any[] = [];
      const amountArray: any[] = [];
      res.WasteInfoList.forEach((element: any) => {
        pcsFaultArray.push(element.Fault);
      });
      res.WasteInfoList.forEach((element: any) => {
        amountArray.push(element.Amount);
      });
      const weight = new Chart(this.ctx, {
        type: 'horizontalBar',
        data: {
          labels: pcsFaultArray,
          datasets: [
            { data: amountArray, label: 'Pcs', backgroundColor: '#040496' },
          ],
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
          tooltips: {
            callbacks: {
              label: (tooltipItem: any, data: any) => {
                return data.datasets[0].data[tooltipItem.index] + '%';
              },
            },
          },
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              padding: 20,
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,                gridLines: {
                  display: false,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                gridLines: {
                  borderDash: [8, 4],
                },
                ticks: {                  beginAtZero: true,
                  stepSize: 20,
                  min: 0,
                  max: 120,
                  callback(value: any, index: any): any {
                    if (value === 0) {
                      return 0 + '%';
                    } else {
                      return value + '%';
                    }
                  },
                },
              },
            ],
          },
        },
      });
    });
  }

  colorCode(value: any): any {
    let colorCode = '';
    if (Math.round(value) > 0 && Math.round(value) <= 20) {
      return (colorCode = '#FF0000');
    } else if (Math.round(value) > 20 && Math.round(value) <= 50) {
      return (colorCode = '#ffff00');
    } else if (Math.round(value) > 50 && Math.round(value) <= 70) {
      return (colorCode = '#ffa500');
    } else if (Math.round(value) > 70) {
      return (colorCode = '#008000');
    } else if (Math.round(value) === 0) {
      return (colorCode = '');
    }
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQualityControlGridReady(params: any): any {
    this.qualityGridApi = params.api;
    this.qualityGridColumnApi = params.columnApi;
  }

  onProcessGridReady(params: any): any {
    this.processGridApi = params.api;
    this.processGridColumnApi = params.columnApi;
  }

  // process order grid section

  abValueGetter(params: any): any {
    if (params.data) {
      return params.data[params.colDef.field]
        ? params.data[params.colDef.field].split('|')[0]
        : '';
    }
  }
  generateColumns(data: any[]): any {
    this.columnDefsProcessControl = [];
    let columnDefinitions: any[] = [];
    data.map((object) => {
      Object.keys(object).map((key) => {
        const mappedColumn = {
          headerName: key, // .toUpperCase()
          // headerClass: 'header-style',
          headerClass: {},
          headerTooltip: key,
          tooltipComponent: 'customTooltip',
          tooltipValueGetter,
          field: key,
          resizable: true,
          wrapText: true,
          rowGroup: key === 'ParameterGroup' ? true : false,
          width:
            key === 'DataType' || key === 'ParameterGroup'
              ? 150
              : key === 'Parameter'
                ? 300
                : 200,
          pinned:
            key === 'Parameter' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? 'left'
              : '',
          lockPinned:
            key === 'Parameter' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? true
              : false,
          cellStyle: {},
          hide: key === 'ParameterGroup' || key === 'DataType' ? true : false,
          filter: true,
          sortable: true,
          editable: false,
          valueParser: {},
          // tslint:disable-next-line:max-line-length
          valueGetter:
            key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'DataType' &&
              key !== 'parameterId'
              ? this.abValueGetter
              : null,
          rowSelection: 'multiple',

          onCellClicked: (params: any) => {
            this.boolColId = params.column.colId;
            this.boolRowIndex = params.rowIndex;
            if (params.data.DataType === 'Bool') {
              params.colDef.cellEditor = 'agRichSelectCellEditor';
              this.GetAllDataTypesDetail(params.data.parameterId);
              this.isProcessGrid = true;
              this.selectionName = params.data.Parameter;
              if (mappedColumn.editable) {
                this.dialog.open(this.qualityBoolListModal, {
                  height: 'auto',
                  width: '45%',
                });
              }
            } else if (params.data.DataType === 'Date') {
              this.isProcessGrid = true;
              this.selectionName = params.data.Parameter;
              if (mappedColumn.editable) {
                this.reOpenProcessCalendar();
              }

              // params.colDef.cellEditor = 'primeCellEditor';
            } else {
              params.colDef.cellEditor = 'agTextCellEditor';
            }
          },
          cellEditor: null,
          cellEditorParams:
            key !== 'Parameter' && key !== 'DataType'
              ? (params: any): Promise<any> => {
                return params.value;
              }
              : null,
        };
        if (this.processGroupType === 'Time') {
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
            ) {
              const fromDate = new Date(key.substring(0, 20));
              const toDate = new Date(key.substring(23, 43));
              // tslint:disable-next-line:max-line-length
              if (
                date.getTime() >= fromDate.getTime() &&
                date.getTime() <= toDate.getTime()  &&
                (key.split('~poStatus')[1].split('~')[0] === '' ||
                  key.split('~poStatus')[1].split('~')[0] === 'InProcess')
              ) {
                return {
                  'font-weight': 'bold',
                  color: params.value
                    ? params.data[params.colDef.field].split('|')[1]
                    : 'black',
                  'background-color': '#bdccdd',
                };
              } else {
                if (params.value) {
                  return {
                    color: params.data[params.colDef.field].split('|')[1],
                  };
                }
              }
            }
          };
          const date = new Date(new Date().setSeconds(0));
          if (
            key !== 'Parameter' &&
            key !== 'DataType' &&
            key !== 'parameterId' &&
            key !== 'ParameterGroup'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            // tslint:disable-next-line:max-line-length
            if (
              date.getTime() >= fromDate.getTime() &&
              date.getTime() <= toDate.getTime() 
              // key.split('~poStatus')[1] === 'InProcess'
            ) {
              if (
                key.split('~poStatus')[1].split('~')[0] === '' ||
                key.split('~poStatus')[1].split('~')[0] === 'InProcess'
              ) {
                mappedColumn.editable = true;
                mappedColumn.lockPinned = true;
                mappedColumn.pinned = 'left';
              } else {
                mappedColumn.editable = false;
              }
              mappedColumn.valueParser = (params: any) => {
                if (this.IsWrite) {
                  // const col = params.colDef.field;
                  // if (col === 'Status') {
                  const dataType = params.data.DataType;
                  if (
                    dataType === 'Int' ||
                    dataType === 'Float' ||
                    dataType === 'String'
                  ) {
                    const newVal = params.newValue;
                    if (dataType === 'Int') {
                      const charcter = Number.isInteger(Number(newVal));
                      if (!charcter) {
                        this.toaster.warning(
                          'DigitsOnly',
                          'Please Select Digits Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        // params.node.setDataValue(params.colDef.field, params.oldValue);
                        return;
                      } else {
                        params.newValue = parseInt(params.newValue, 10);
                      }
                    }
                    if (dataType === 'Float') {
                      const float = parseFloat(newVal);
                      // tslint:disable-next-line:use-isnan
                      if (isNaN(float)) {
                        this.toaster.warning(
                          'FloatOnly',
                          'Please Select Float Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return;
                      } else {
                        params.newValue = parseFloat(params.newValue).toFixed(
                          2
                        );
                      }
                    }
                    const startIntervalDate = params.colDef.field.substring(
                      0,
                      20
                    );
                    const endIntervalDate = params.colDef.field.substring(
                      23,
                      43
                    );
                    if (new Date() > new Date(endIntervalDate)) {
                      this.toaster.warning(
                        'Time Passed',
                        'Slot time has been passed'
                      );
                      return;
                    }
                    let cellData: any;
                    if (!params.oldValue || params.oldValue === '') {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        varId: params.data.parameterId,
                        isOldValue: false,
                        po: params.column.colId.split('~')[1],
                        createdBy: JSON.parse(localStorage.user).UserId,
                        // tslint:disable-next-line:max-line-length
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.processGroupType,
                      };
                    } else {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        varId: params.data.parameterId,
                        endInterval: endIntervalDate,
                        startInterval: startIntervalDate,
                        isOldValue: true,
                        po: params.column.colId.split('~')[1],
                        createdBy: JSON.parse(localStorage.user).UserId,
                        // tslint:disable-next-line:max-line-length
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.processGroupType,
                      };
                    }
                    this.processService.saveProessControl(cellData).subscribe(
                      (response: any) => {
                        const msg = response[0].result;
                        if (msg !== null || msg !== '') {
                          if (msg.substring(2, 1) === '0') {
                            this.toaster.success(
                              'Success',
                              msg.substring(3, msg.length)
                            );
                            params.node.setDataValue(
                              params.colDef.field,
                              response[0].value
                            );
                            if (response[0].value) {
                              const color = response[0].value.split('|')[1];
                              if (color === '#ff2121') {
                                this.sendNotificationRole(
                                  `NCR ID - ${response[0].ncrId}
                                   Out of Specification Limits! The Defect had happened against ${params.column.colId.split('~')[1]
                                  }`,
                                  'Process Control'
                                );
                              }
                              if (color === '#ffff00') {
                                this.sendNotificationRole(
                                  `NCR ID - ${response[0].ncrId}
                                   Watch Out! There is a risk of defect happening against ${params.column.colId.split('~')[1]
                                  }`,
                                  'Process Control'
                                );
                              }
                            }
                          } else {
                            this.toaster.error(
                              'Error',
                              msg.substring(3, msg.length)
                            );
                            params.node.setDataValue(
                              params.colDef.field,
                              response[0].value
                            );
                          }
                        }
                      },
                      (error: any) => {
                        return this.toaster.error('Error', error.message);
                      }
                    );
                  }
                }
              };
            }
          }
          if (
            key !== 'Parameter' &&
            key !== 'parameterId' &&
            key !== 'DataType' &&
            key !== 'ParameterGroup'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            mappedColumn.headerName =
              moment(fromDate).format('HH:mm:ss') +
              ' - ' +
              moment(toDate).format('HH:mm:ss') +
              ' - ' +
              key.split('~')[1] +
              ' - ' +
              key.split('~poStatus')[1].split('~')[0];

            let pcode = '';
            let po = '';
            let name = '';
            po = `PO  :  ${key.split('~')[1]}`;
            pcode = `Code  :  ${key.split('~')[2]}`;
            name = `Name  :  ${key.split('~prodDesc')[1]
              ? key.split('~prodDesc')[1].split('~')[0]
              : ''
              }`;
            mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
          }
        }
        if (
          this.processGroupType === 'Event' ||
          this.processGroupType === 'Manual'
        ) {
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'parameterId' &&
            key !== 'Cavity' &&
            key !== 'DataType'
          ) {
            if (this.processGroupType === 'Event') {
              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' +
                `PO  :  ${key.split('~')[1]}`; // LotCode:  ${key.split('~lotCode')[1].split('~')[0]}
              //  mappedColumn.headerTooltip = `PO  :  ${key.split('~')[1]} `; // LotCode:  ${key.split('~lotCode')[1].split('~')[0]}

              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1]
                ? key.split('~prodDesc')[1].split('~')[0]
                : ''
                }`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;

              // mappedColumn.headerTooltip = `PO :  ${key.split('~')[1]}`+' - '+`Code : ${key.split('~')[2]}`+' - '+name;
            } else {
              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' +
                key.split('~')[1];
              //  mappedColumn.headerTooltip = `PO  :  ${key.split('~')[1]}`;

              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1]
                ? key.split('~prodDesc')[1].split('~')[0]
                : ''
                }`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
              // mappedColumn.headerTooltip = `PO :  ${key.split('~')[1]}`+' - '+`Code : ${key.split('~')[2]}`+' - '+name;
            }
            mappedColumn.editable = true;
          }
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
            ) {
              // if (params.value) {
              return {
                'font-weight': 'bold',
                color: params.value
                  ? params.data[params.colDef.field].split('|')[1]
                  : 'black',
                'background-color': '#bdccdd',
              };
              // }
            }
          };
          mappedColumn.valueParser = (params: any) => {
            console.log(params);
            if (this.IsWrite) {
              const dataType = params.data.DataType;
              if (
                dataType === 'Int' ||
                dataType === 'Float' ||
                dataType === 'String'
              ) {
                const dataType = params.data.DataType;
                let newVal = params.newValue;
                if (dataType === 'Int') {
                  const charcter = Number.isInteger(Number(newVal));
                  if (!charcter) {
                    this.toaster.warning(
                      'DigitsOnly',
                      'Please Select Int Value Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return;
                  } else {
                    params.newValue = parseInt(params.newValue, 10);
                  }
                }
                if (dataType === 'Float') {
                  const float = parseFloat(newVal);
                  // tslint:disable-next-line:use-isnan
                  if (isNaN(float)) {
                    this.toaster.warning(
                      'FloatOnly',
                      'Please Select Float Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return;
                  } else {
                    params.newValue = parseFloat(params.newValue).toFixed(2);
                  }
                }
                if (dataType === 'Date') {
                  const date = params.newValue;
                  if (date.match(new RegExp('/', 'g')).length === 2) {
                  } else {
                    this.toaster.warning(
                      'SlashError',
                      'Please Select Correct Date Format'
                    );
                    return;
                  }
                }
                const startIntervalDate = params.colDef.field.substring(0, 20);
                const endIntervalDate = params.colDef.field.substring(23, 43);
                if (new Date() > new Date(endIntervalDate)) {
                  this.toaster.warning(
                    'Time Passed',
                    'Slot time has been passed'
                  );
                  return;
                }
                // const fromDate = new Date(params.colDef.field.substring(0, 20).replace(/-/g, '/'));
                // const toDate = new Date(params.colDef.field.substring(22, 41).replace(/-/g, '/'));
                let cellData: any;
                if (!params.oldValue || params.oldValue === '') {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    varId: params.data.parameterId,
                    isOldValue: this.processGroupType !== 'Time' ? true : false,
                    po: params.column.colId.split('~')[1],
                    // eventId: params.column.colId
                    //   .split('~EventId')[1]
                    //   .split('~')[0],
                    createdBy: JSON.parse(localStorage.user).UserId,
                    intervalType: this.processGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                } else {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    varId: params.data.parameterId,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    isOldValue: true,
                    po: params.column.colId.split('~')[1],
                    // eventId: params.column.colId
                    //   .split('~EventId')[1]
                    //   .split('~')[0],
                    createdBy: JSON.parse(localStorage.user).UserId,
                    intervalType: this.processGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                }
                this.processService.saveProessControl(cellData).subscribe(
                  (response: any) => {
                    // this.toaster.success('Success', 'Data Added Successfully');
                    // this.showPopupMsg(response[0].result);
                    const msg = response[0].result;
                    if (msg !== null || msg !== '') {
                      if (msg.substring(2, 1) === '0') {
                        this.toaster.success(
                          'Success',
                          msg.substring(3, msg.length)
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          response[0].value
                        );
                        // params.node.setDataValue(params.colDef.field, newVal);
                      } else {
                        this.toaster.error(
                          'Error',
                          msg.substring(3, msg.length)
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                      }
                    }
                  },
                  (error: any) => {
                    return this.toaster.error('Error', error.message);
                  }
                );
                // }
              }
            }
          };
        }
        if (key === 'parameterId') {
          mappedColumn.hide = true;
        }
        columnDefinitions.push(mappedColumn);
      });
    });

    columnDefinitions = columnDefinitions.filter(
      (column, index, self) =>
        index ===
        self.findIndex((colAtIndex) => colAtIndex.field === column.field)
    );
    this.rowSelection = 'multiple';
    this.columns = [];
    const column = columnDefinitions;
    this.columns = column.filter((c) => c.hide !== true);
    return columnDefinitions;
  }
  GetGroupTypeList(): any {
    const key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getVariableGroupbyUnit(key).subscribe(
      (data: any) => {
        this.groupTypeList = data.filter(
          (c: any) => c.groupTypeName !== 'None'
        );
        if (this.groupTypeList.length) {
          this.processControlForm
            .get('groupType')
            ?.setValue(this.groupTypeList[0].parameterGroupTypeId);
          this.variableEventMode();

          console.log(data.BreadcrumList);
        }
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  onIntervalChange(): void { }
  onToProcessDate(): any {
    const getdata = {
      fromDate: moment(
        this.processControlForm.value.datePicker.startDate
      ).utc(),
      toDate: moment(this.processControlForm.value.datePicker.endDate).utc(),
      puId: this.unitId,
      processType: 'PO',
      interval: this.processControlForm.value.timeInterval,
      currentDateTime: new Date(),
      // intervalType: this.processControlForm.value.eventType,
      // tslint:disable-next-line:max-line-length
      intervalType:
        this.processGroupType === 'Time' || this.processGroupType === 'Manual'
          ? this.processGroupType
          : this.processControlForm.value.eventType,
      groupType: this.processGroupType,
      // eventType: [''],
      // timeInterval: ['']
    };
    if (
      getdata.puId === undefined ||
      !getdata.fromDate ||
      this.UnitName === ''
    ) {
      this.toaster.warning('Warning', 'Please Select Unit And Dates');
      this.spinner.hide();
      return;
    }
    const from = this.processControlForm.value.datePicker.startDate;
    const To = this.processControlForm.value.datePicker.endDate;
    const timeDiff = moment(To).diff(moment(from), 'hours');

    // if (timeDiff > 24) {
    //   this.toaster.error(
    //     this.translate.instant('Error'),
    //     this.translate.instant('DateRangeSelect')
    //   );
    //   return;
    // }
    if (!this.processGroupType) {
      return;
    }
    this.processGridApi.showLoadingOverlay();
    this.processService.getParameterProcessControl(getdata).then(
      (response: any) => {
        this.gridOptionsProcessControl.api.hideOverlay();
        const results: any = [];
        // tslint:disable-next-line:space-before-function-paren
        response.forEach(function (this: any, e: any): any {
          const a =
            e.parameterGroup +
            '|' +
            e.parameterName +
            '|' +
            e.parameterId +
            '|' +
            e.dataType;
          if (!this[a]) {
            this[a] = {
              ParameterGroup: e.parameterGroup,
              Parameter: e.parameterName,
              parameterId: e.parameterId,
              DataType: e.dataType,
            };
            results.push(this[a]);
          }
          if (e.dataType === 'Date' && e.value) {
            this[a][e.timInterval1] = moment(e.value, 'DD/MM/YYYY HH:mm:ss')
              .utc(e.value)
              .local()
              .format('DD/MM/YYYY HH:mm:ss');
          } else {
            this[a][e.timInterval1] = e.value;
          }
        }, {});
        this.rowDataProcessControl2 = results;
        this.processGridApi.setRowData(results);
        // this.rowDataProcessControl = response;
        if (this.rowDataProcessControl2) {
          this.columnDefsProcessControl = this.generateColumns(
            this.rowDataProcessControl2
          );
          setTimeout(() => {
            this.gridOptionsProcessControl?.api?.columnController?.resetColumnState();
            if (this.processGroupType === 'Time') {
              const scroll = document.querySelector(
                '#gridContainerProcessControl .ag-body-horizontal-scroll-viewport'
              );
              if (scroll !== null) {
                scroll.scrollLeft = scroll.scrollWidth;
              }
            }
          }, 100);
          if (this.processGroupType === 'Manual') {
            this.onProcessParameterGroupChange();
          }
        }
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getParameterInterval(): void {
    const Key = {
      puId: this.unitId,
    };
    this.processService.getProcessControlInterval(Key).subscribe(
      (response: any) => {
        this.intervalList = response;
        if (response.length > 0) {
          this.processControlForm
            .get('timeInterval')
            ?.setValue(this.intervalList[0].Interval);
          this.onToProcessDate();
        }

      },
      (error: { message: any }) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  variableEventMode(): void {
    this.rowDataProcessControl = [];
    this.processGroupType = this.groupTypeList.find(
      (c: any) =>
        c.parameterGroupTypeId === this.processControlForm.value.groupType
    )?.groupTypeName;
    if (this.processGroupType === 'Time') {
      this.getParameterInterval();
    } else if (this.processGroupType === 'Event') {
      this.getProcessIntervalType();
    } else if (this.processGroupType === 'Manual') {
      this.onToProcessDate();
      this.getProcessParamterGroupList();
    }
  }

  onCellValueChanged(params: any): void {
    if (this.IsWrite) {
      const dataType = params.data.DataType;
      if (dataType === 'Date' || dataType === 'Bool') {
        if (dataType === 'Date') {
          const date = params.value;
          if (date.match(new RegExp('/', 'g')).length === 2) {
            params.value = moment(date, 'DD/MM/YYYY HH:mm:ss')
              .utc()
              .format('DD/MM/YYYY HH:mm:ss');
          } else {
            this.toaster.warning(
              'SlashError',
              'Please Select Correct Date Format'
            );
            return;
          }
        }
        const startIntervalDate = params.colDef.field.substring(0, 20);
        const endIntervalDate = params.colDef.field.substring(23, 43);
        if (new Date() > new Date(endIntervalDate)) {
          this.toaster.warning('Time Passed', 'Slot time has been passed');
          return;
        }
        let cellData: any;
        if (this.processGroupType === 'Time') {
          if (!params.oldValue || params.oldValue === '') {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              varId: params.data.parameterId,
              isOldValue: false,
              po: params.column.colId.split('~')[0],
              createdBy: JSON.parse(localStorage.user).UserId,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.processGroupType,
            };
          } else {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              varId: params.data.parameterId,
              endInterval: endIntervalDate,
              startInterval: startIntervalDate,
              isOldValue: true,
              po: params.column.colId.split('~')[0],
              createdBy: JSON.parse(localStorage.user).UserId,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.processGroupType,
            };
          }
        } else if (
          this.processGroupType === 'Event' ||
          this.processGroupType === 'Manual'
        ) {
          // if (!params.oldValue || params.oldValue === '') {
          //   cellData = {
          //     result: params.value,
          //     entryOn: new Date(),
          //     resultOn: startIntervalDate,
          //     endInterval: startIntervalDate,
          //     startInterval: startIntervalDate,
          //     varId: params.data.parameterId,
          //     isOldValue: true,
          //     po: params.column.colId.split('~')[1],
          //     eventId: params.column.colId.split('~EventId')[1].split('~')[0],
          //     createdBy: JSON.parse(localStorage.user).UserId,
          //     intervalType: this.processGroupType,
          //   };
          // } else {
          cellData = {
            result: params.value,
            entryOn: new Date(),
            resultOn: startIntervalDate,
            varId: params.data.parameterId,
            endInterval: startIntervalDate,
            startInterval: startIntervalDate,
            isOldValue: true,
            po: params.column.colId.split('~')[1],
            // eventId: params.column.colId.split('~EventId')[1].split('~')[0],
            createdBy: JSON.parse(localStorage.user).UserId,
            intervalType: this.processGroupType,
          };
          // }
        }
        this.processService.saveProessControl(cellData).subscribe(
          (response: any) => {
            const msg = response[0].result;
            if (msg !== null || msg !== '') {
              if (msg.substring(2, 1) === '0') {
                this.toaster.success('Success', msg.substring(3, msg.length));
                // params.node.setDataValue(params.colDef.field, newVal);
              } else {
                this.toaster.error('Error', msg.substring(3, msg.length));
                // params.node.setDataValue(params.colDef.field, params.oldValue);
              }
            }
          },
          (error: any) => {
            return this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }
  getContextMenuItemsProcessControl = (params: any) => {
    // const that = this;
    let result: any;
    if (this.IsWrite) {
      result = [
        {
          name: 'Specifiction Limits',
          action: () => {
            // this.parameterId = params.node.data.parameterId;
            this.processControlSpecification(params);
          },
        },
        {
          name: 'Defect - Failure Mode Details',
          action: () => {
            // this.parameterId = params.node.data.parameterId;
            this.processControlDefect(params);
          },
        },
      ];
    }
    return result;
  };

  // ------- Context Menu Process Control
  processControlSpecification(params: any): void {
    this.processControlSpecificationModal = true;
    // this.dialog.open(this.processControlSpecificationModal, {
    //   height: '70%',
    //   width: '90%',
    // });
    const podata = params.column.colId.split('~')[1];
    this.paramterSpcecificationName = params.node.data.Parameter;
    const key = {
      processOrder: podata,
      paramterId: params.node.data.parameterId,
      prodId:
        params.column.colId.split('~prodId')[1] !== undefined
          ? params.column.colId.split('~prodId')[1].split('~')[0]
          : '',
    };
    this.getParameterSpecificationsProcessControl(key);
  }
  processControlDefect(params: any): void {
    this.displayProcssDefectModal = true;
    // this.dialog.open(this.displayProcssDefectModal, {
    //   height: '70%',
    //   width: '90%',
    // });
    this.processparamaterdefects(params);
  }
  getParameterSpecificationsProcessControl(key: any): void {
    this.processService.processparameterspecs(key).subscribe(
      (response: any) => {
        this.parameterspecifications.data = response;
        this.getPaginator(this.parameterspecifications, 0);
        // this.chartSpecifications = response;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  processparamaterdefects(params: any): void {
    const prodId =
      params.column.colId.split('~prodId')[1] !== undefined
        ? params.column.colId.split('~prodId')[1].split('~')[0]
        : '';
    const key = {
      paramId: params.node.data.parameterId,
      prodId,
    };
    this.processService.processparamaterdefects(key).subscribe(
      (response: any) => {
        this.parametrdefect = new MatTableDataSource<any>(response);
        this.getPaginator(this.parametrdefect, 1);
        // this.getPaginator();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }

  // End Context menu Process
  async GetAllDataTypesDetail(val: any): Promise<any> {
    const key = {
      variableId: val,
    };
    await this.machineParamtersService
      .GetAllDataTypesDetail(key)
      .then((res: any) => {
        this.boolList = res.map((c: any) => c.text);
      });
  }
  async GetAllDataTypesDetailQC(val: any): Promise<any> {
    const key = {
      variableId: val,
    };
    await this.qualityParameterService
      .GetAllDataTypesDetail(key)
      .then((res: any) => {
        this.boolList = res.map((c: any) => c.text);
      });
  }
  onProcessControlRefresh(): void {
    if (this.processControlForm.valid) {
      this.rowDataProcessControl = [];
      const start = this.processControlForm.value.datePicker.startDate;
      const selected = {
        startDate: start,
        endDate: new Date(),
      };
      this.processControlForm.get('datePicker')?.setValue(selected);
      // this.processControlForm
      //   .get('datePicker')
      //   ?.setValue([this.processControlForm.value.datePicker[0], new Date()], {
      //     emitEvent: false,
      //   });
      this.onToProcessDate();
    } else {
      // this.toaster.warning('Select all mandatory fields');
    }
  }
  openQualitySpecification(params: any): void {
    this.displayQualitySpecificationModal = true;
    // this.dialog.open(this.displayQualitySpecificationModal, {
    //   height: '90%',
    //   width: '90%',
    // });
    const podata = params.column.colId.split('~')[1];
    this.paramterSpcecificationName = params.node.data.Parameter;
    const key = {
      processOrder: podata,
      paramterId: params.node.data.parameterId,
      prodId:
        params.column.colId.split('~prodId')[1] !== undefined
          ? params.column.colId.split('~prodId')[1].split('~')[0]
          : '',
    };
    this.getParameterSpecifications(key);
  }
  getParameterSpecifications(key: any): void {
    this.qualityParameterService.getParameterSpecifications(key).subscribe(
      (response: any) => {
        this.parameterspecifications.data = response;
        this.getPaginator(this.parameterspecifications, 2);
        this.chartSpecifications = response;
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  openQualityDefecct(params: any): void {
    this.displayQualityDefectModal = true;
    // this.dialog.open(this.displayQualityDefectModal, {
    //   height: '90%',
    //   width: '90%',
    // });
    this.qualityparamaterdefects(params);
  }
  qualityparamaterdefects(params: any): void {
    const prodId =
      params.column.colId.split('~prodId')[1] !== undefined
        ? params.column.colId.split('~prodId')[1].split('~')[0]
        : '';
    const key = {
      paramId: params.node.data.parameterId,
      prodId,
    };
    this.qualityParameterService.qualityparamaterdefects(key).subscribe(
      (response: any) => {
        this.parametrdefect = new MatTableDataSource<any>(response);
        this.getPaginator(this.parametrdefect, 3);
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  // getContextMenuItems = (params: any) => {
  //   // const that = this;
  //   let result: any;
  //   const array = JSON.parse(localStorage.roleName).map((v: any) =>
  //     v.toLowerCase()
  //   );
  //   this.qcRole = array.includes('qc leader') === true ? true : false;
  //   if (this.IsWrite && this.qcRole) {
  //     result = [
  //       {
  //         name: 'Specifiction Limits',
  //         action: () => {
  //           this.openQualitySpecification(params);
  //         },
  //       },
  //       {
  //         name: 'Defect - Failure Mode Details',
  //         action: () => {
  //           this.openQualityDefecct(params);
  //         },
  //       },
  //       {
  //         name: 'QC Verify',
  //         action: () => {
  //           this.openQc(params);
  //         },
  //       },
  //     ];
  //   } else {
  //     result = [
  //       {
  //         name: 'Specifiction Limits',
  //         action: () => {
  //           this.openQualitySpecification(params);
  //         },
  //       },
  //       {
  //         name: 'Defect - Failure Mode Details',
  //         action: () => {
  //           this.openQualityDefecct(params);
  //         },
  //       },
  //     ];
  //   }
  //   return result;
  // }
  getContextMenuItems = (params: any) => {
    // const that = this;
    let result: any;
    if (this.qualityGroupType === 'Time') {
      const key = params.column.colId;
      const date = new Date(new Date().setSeconds(0));

      const fromDate = new Date(key.substring(0, 20));
      const toDate = new Date(key.substring(23, 43));

      const array = JSON.parse(localStorage.roleName).map((v: any) =>
        v.toLowerCase()
      );
      this.qcRole = array.includes('qc leader') === true ? true : false;
      if (
        this.IsWrite &&
        this.qcRole &&
        date.getTime() >= fromDate.getTime() &&
        date.getTime() <= toDate.getTime()  &&
        (key.split('~poStatus')[1].split('~')[0] === 'InProcess' ||
          key.split('~poStatus')[1].split('~')[0] === '')
      ) {
        result = [
          {
            name: 'Specifiction Limits',
            action: () => {
              this.openQualitySpecification(params);
            },
          },
          {
            name: 'Defect - Failure Mode Details',
            action: () => {
              this.openQualityDefecct(params);
            },
          },
          {
            name: 'QC Verify',
            action: () => {
              this.openQc(params);
            },
          },
        ];
      } else {
        result = [
          {
            name: 'Specifiction Limits',
            action: () => {
              this.openQualitySpecification(params);
            },
          },
          {
            name: 'Defect - Failure Mode Details',
            action: () => {
              this.openQualityDefecct(params);
            },
          },
        ];
      }
    } else {
      result = [
        {
          name: 'Specifiction Limits',
          action: () => {
            this.openQualitySpecification(params);
          },
        },
        {
          name: 'Defect - Failure Mode Details',
          action: () => {
            this.openQualityDefecct(params);
          },
        },
        {
          name: 'QC Verify',
          action: () => {
            this.openQc(params);
          },
        },
      ];
    }
    return result;
  };

  saveQcVerify(): void {

    const key = {
      startTimeSlot: this.qcStartTimeSlot,
      timeSlot: this.qcParamsSlot,
      endTimeSlot: this.qcEndTimeSlot,
      processOrderNo: this.qcProcessorderNo,
      verifcationStatus: this.verifcationStatus,
      unitId: this.unitId,
      createdBy: JSON.parse(localStorage.user).UserId,
      createdOn: new Date(),
      prodCode: this.qcProdCode,
      prodDesc: this.qcProcdDesc,
      detail: this.qcdataSource.data, // data
      groupType: this.qualityGroupType,
    };
    this.qualityParameterService.saveQcVerify(key).subscribe(
      (response: any) => {
        // this.toaster.show('Success', 'Verifcation Saved Successfully');
        this.showPopupMsg(response.data);
        this.onToProcessDateQuanlityControl();
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
      }
    );
  }
  verifyChnage(element: any, event: any): void {
    const obj = this.qcdataSource.data.find(
      (x: any) => x.parameterId === element.parameterId
    );
    obj.verificationStatus = event.target.value;
  }

  QcVerifyremarksUpdate(element: any, event: any): void {
    const obj = this.qcdataSource.data.find(
      (x: any) => x.parameterId === element.parameterId
    );
    obj.remarks = event.target.value;
  }

  // QcVerifyremarksUpdate(event: any, data: any): void {
  //   // const remarks = event.target.value;
  //   // const parameterId = parseInt(data.parameterId, 10);
  //   // const m = this._alldata.find((x) => x.parameterId === parameterId);
  //   // m.remarks = remarks;

  //   // const result = this.checkListAddModel;
  // }

  openQc(params: any): void {
    this.qcParamsSlot = params.column.userProvidedColDef.headerName;
    this.qcStartTimeSlot = params.column.userProvidedColDef.field.substring(
      0,
      20
    );
    if (this.qualityGroupType === 'Time') {
      this.qcEndTimeSlot = params.column.userProvidedColDef.field.substring(
        23,
        43
      );
    } else {
      this.qcEndTimeSlot = params.column.userProvidedColDef.field.substring(
        0,
        20
      );
    }
    this.qcheadertooltip = params.column.userProvidedColDef.headerTooltip;
    this.qcProcessorderNo = params.column.colId.split('~')[1];
    this.qcProdCode = params.column.colId.split('~')[3];
    this.qcProcdDesc = params.column.colId.split('~')[2];
    const qcTableArr: any[] = [];
    const dateCol = params.column.colId;

    params.api.forEachLeafNode((node: any) => {
      qcTableArr.push({
        parameter: node.data.Parameter,
        value: node.data[dateCol]
          ? node.data[dateCol].split('|')[0]
          : node.data[dateCol],
        parameterId: node.data.parameterId,
        sample: node.data.Cavity,
        verificationStatus: 'Approve',
        remarks: node.data.remarks,
        ParamaterGroup: node.data.ParameterGroup,
        // isVerified: false,
      });
    });
    this.qcdataSource.data = qcTableArr;

    //  this.getPaginator2(this.qcdataSource , 1)
    // global array empty
    this.detailArray = [];
    // for verified
    this.qcdataSource.data.forEach(
      (ele: {
        parameter: any;
        parameterId: any;
        sample: any;
        value: any;
        verificationStatus: any[];
        remarks: any;
        ParamaterGroup: any;
        // isVerified: any;
      }) => {
        const obj = {
          parameter: ele.parameter,
          parameterId: ele.parameterId,
          sample: ele.sample,
          value: ele.value,
          verificationStatus: ele.verificationStatus
            ? ele.verificationStatus
            : 'Approve',
          remarks: ele.remarks ? ele.remarks : '',
          ParamaterGroup: ele.ParamaterGroup,
        };
        this.detailArray.push(obj);
      }
    );

    // get qc verified data
    const key = {
      startTime: this.qcStartTimeSlot,
      endTime: this.qcEndTimeSlot,
      puId: this.unitId,
    };

    this.qualityParameterService
      .GetQCVerifyDetail(key)
      .subscribe((res: any) => {
        this.verifyCheckedArray = res;
        const mergeArray = this.detailArray.map((element: any) => {
          const tableArray = this.verifyCheckedArray.find(
            (x: any) =>
              x.paramterId === element.parameterId && x.sample == element.sample
          );
          return { ...element, ...tableArray };
        });
        this.qcdataSource.data = mergeArray;

        this._allDataQC = this.qcdataSource.data;
        this.qcdataSource.data = this.addGroups(
          this._allDataQC,
          this.groupByQCColumns
        );

        this.qcdataSource.filterPredicate =
          this.QCcustomFilterPredicate.bind(this);
        this.qcdataSource.filter = performance.now().toString();
      });
    this.getPaginator(this.qcdataSource, 4);
    this.getSorting(this.qcdataSource, 4);

    console.log(this.qcdataSource.paginator);

    // modal open
    this.dialog.open(this.displayQCModal, { height: '90%', width: '90%' });
  }
  // quality process control
  // getContextMenuItems = (params: any) => {
  //   // const that = this;
  //   let result: any;
  //   if (this.IsWrite) {
  //     result = [
  //       {
  //         name: 'Specifiction Limits',
  //         action: () => {
  //           // this.parameterId = params.node.data.parameterId;
  //           this.openQualitySpecification(params);
  //         },
  //       },
  //       {
  //         name: 'Defect - Failure Mode Details',
  //         action: () => {
  //           // this.parameterId = params.node.data.parameterId;
  //           this.openQualityDefecct(params);
  //         },
  //       },
  //       // {
  //       //   name: 'QC Verify',
  //       //   action: () => {
  //       //     this.openQc(params);
  //       //   },
  //       // },
  //     ];
  //   }
  //   return result;
  // }

  onQualityControlRefresh(): void {
    // this.rowDataQualityControl = [];
    this.qualityGridApi.setRowData([]);
    if (this.qualityControlForm.valid) {
      const start = this.qualityControlForm.value.datePicker.startDate;
      const selected = {
        startDate: start,
        endDate: new Date(),
      };
      this.qualityControlForm.get('datePicker')?.setValue(selected);
      // this.qualityControlForm
      //   .get('datePicker')
      //   ?.setValue([this.qualityControlForm.value.datePicker[0], new Date()], {
      //     emitEvent: false,
      //   });
      this.onToProcessDateQuanlityControl();
    } else {
      // this.toaster.warning('Select all mandatory fields');
    }
  }
  sendNotificationRole(descr: any, title: any): void {
    const key = {
      roleName: 'QC leader',
      egId: this.groupDataForm.value.group,
      createdBy: JSON.parse(localStorage.user).UserId,
      desc: descr,
      title,
      pageId: this.pageId
    };
    this.notificationService.addnotification(key).subscribe(
      (response: any) => {
        this.toaster.success('Notification Sent');
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
  }
  async GetQualityAllDataTypesDetail(val: any): Promise<any> {
    const key = {
      variableId: val,
    };
    await this.qualityParameterService
      .GetAllDataTypesDetail(key)
      .then((res: any) => {
        this.qualityboolList = res.map((c: any) => c.text);
      });
  }
  onQualityIntervalChange(): void {
    this.onToProcessDateQuanlityControl();
  }
  qualityControlEventMode(): void {
    this.rowDataQualityControl = [];
    // tslint:disable-next-line:max-line-length
    this.qualityGroupType = this.qualityControlGroupTypeList.find(
      (c: any) =>
        c.parameterGroupTypeId === this.qualityControlForm.value.groupType
    )?.groupTypeName;
    if (this.qualityGroupType === 'Time') {
      this.getParameterIntervalQualityControl();
    } else if (this.qualityGroupType === 'Event') {
      this.getQualityIntervalType();
    } else if (this.qualityGroupType === 'Manual') {
      this.getQualityParamterGroupList();
      this.onToProcessDateQuanlityControl();
    }
  }
  GetQualityControlGroupTypeList(): any {
    const key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getQualityGroupbyUnit(key).subscribe(
      (data: any) => {
        this.qualityControlGroupTypeList = data.filter(
          (c: any) => c.groupTypeName !== 'None'
        );
        this.qualityControlForm
          .get('groupType')
          ?.setValue(this.qualityControlGroupTypeList[0].parameterGroupTypeId);
        this.qualityControlEventMode();
      },
      (error) => {
        this.toaster.error('Error', error.ErrorMessage);
      }
    );
  }
  getParameterIntervalQualityControl(): void {
    const Key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getQualityControlInterval(Key).subscribe(
      (response: any) => {
        this.qualityIntervalList = response;
        if (response.length > 0) {
          this.qualityControlForm
            .get('timeInterval')
            ?.setValue(this.qualityIntervalList[0]?.Interval);
          this.onToProcessDateQuanlityControl();
        }
      },
      (error: { message: any }) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  onToProcessDateQuanlityControl(): any {
    const getdata = {
      fromDate: moment(
        this.qualityControlForm.value.datePicker.startDate
      ).utc(),
      toDate: moment(this.qualityControlForm.value.datePicker.endDate).utc(),
      puId: this.unitId,
      cavity: this.maxCavity,
      processType: 'PO',
      interval: this.qualityControlForm.value.timeInterval,
      currentDateTime: new Date(),
      groupType: this.qualityGroupType,
      intervalType:
        this.qualityGroupType === 'Time' || this.qualityGroupType === 'Manual'
          ? this.qualityGroupType
          : this.qualityControlForm.value.eventType,
    };
    if (
      getdata.puId === undefined ||
      !getdata.fromDate ||
      !getdata.toDate ||
      this.UnitName === ''
    ) {
      this.toaster.warning(this.translate.instant('SelectDatesPlants'));
      return;
    }
    const from = this.qualityControlForm.value.datePicker[0];
    const To = this.qualityControlForm.value.datePicker[1];
    const timeDiff = moment(To).diff(moment(from), 'hours');

    // if (timeDiff > 24) {
    //   this.toaster.error(
    //     this.translate.instant('Error'),
    //     this.translate.instant('DateRangeSelect')
    //   );
    //   return;
    // }
    if (!this.qualityGroupType) {
      return;
    }
    this.qualityGridApi.showLoadingOverlay();
    this.processService.getQualityProcessControl(getdata).then(
      (response: any) => {
        this.gridOptionsQualityControl.api.hideOverlay();
        const results: any = [];
        // tslint:disable-next-line:space-before-function-paren
        response.forEach(function (this: any, e: any): any {
          const a =
            e.parameterGroup +
            '|' +
            e.parameterName +
            '|' +
            e.parameterId +
            '|' +
            e.dataType +
            '|' +
            e.cavity;
          if (!this[a]) {
            // tslint:disable-next-line:max-line-length
            this[a] = {
              ParameterGroup: e.parameterGroup,
              Parameter: e.parameterName,
              parameterId: e.parameterId,
              DataType: e.dataType,
              Cavity: e.cavity,
            };
            results.push(this[a]);
          }
          if (e.dataType === 'Date' && e.value !== null) {
            this[a][e.timInterval1] = moment(e.value, 'DD/MM/YYYY HH:mm:ss')
              .utc(e.value)
              .local()
              .format('DD/MM/YYYY HH:mm:ss');
          } else {
            this[a][e.timInterval1] = e.value;
          }
        }, {});
        this.rowDataQualityControl2 = results;
        this.qualityGridApi.setRowData(results);

        // this.rowDataQualityControl = response;
        if (this.rowDataQualityControl2) {
          console.log(this.rowDataQualityControl2, 'data2233');
          this.columnDefsQualityControl = this.generateColumnsQualityControl(
            this.rowDataQualityControl2
          );
          setTimeout(() => {
            this.gridOptionsQualityControl?.api.columnController?.resetColumnState();
            if (this.qualityGroupType === 'Time') {
              const scroll = document.querySelector(
                '#gridContainerQualityControl .ag-body-horizontal-scroll-viewport'
              );
              if (scroll !== null) {
                scroll.scrollLeft = scroll.scrollWidth;
              }
            }
          }, 100);
          if (this.qualityGroupType === 'Manual') {
            this.onQualityParameterGroupChange();
          }
          // this.getQualityParamterGroupList();
        }
      },
      (error: any) => {
        this.toaster.error('Error', error.message);
        this.spinner.hide();
      }
    );
  }

  onQualityControlCellValueChanged(params: any): void {
    if (this.IsWrite) {
      const dataType = params.data.DataType;
      if (dataType === 'Bool' || dataType === 'Date') {
        let newVal = params.value;
        if (dataType === 'Int') {
          const charcter = this.isCharNumeric(newVal);
          if (!charcter) {
            this.toaster.warning('DigitsOnly', 'Please Select Digits Only');
            // newVal = params.oldValue;
            params.node.setDataValue(params.colDef.field, params.oldValue);
            return;
          }
        }
        if (dataType === 'Float') {
          const float = parseFloat(newVal);
          // tslint:disable-next-line:use-isnan
          if (isNaN(float)) {
            this.toaster.warning(
              'Decimal Only',
              'Please Select Decimal values Only'
            );
            // newVal = params.oldValue;
            params.node.setDataValue(params.colDef.field, params.oldValue);
            return;
          } else {
            params.value = parseFloat(params.value).toFixed(2);
          }
        }
        if (dataType === 'Date') {
          const date = params.value;
          if (date.match(new RegExp('/', 'g')).length === 2) {
            params.value = moment(date, 'DD/MM/YYYY HH:mm:ss')
              .utc()
              .format('DD/MM/YYYY HH:mm:ss');
          } else {
            this.toaster.warning(
              'SlashError',
              'Please Select Correct Date Format'
            );
            return;
          }
        }
        const startIntervalDate = params.colDef.field.substring(0, 20);
        const endIntervalDate = params.colDef.field.substring(23, 43);
        if (new Date() > new Date(endIntervalDate)) {
          this.toaster.warning('Time Passed', 'Slot time has been passed');
          return;
        }
        let cellData: any;
        if (this.qualityGroupType === 'Time') {
          if (!params.oldValue || params.oldValue === '') {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              endInterval: endIntervalDate,
              startInterval: startIntervalDate,
              varId: params.data.parameterId,
              isOldValue: false,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              createdBy: JSON.parse(localStorage.user).UserId,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.qualityGroupType,
            };
          } else {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: endIntervalDate,
              varId: params.data.parameterId,
              endInterval: endIntervalDate,
              startInterval: startIntervalDate,
              isOldValue: true,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              createdBy: JSON.parse(localStorage.user).UserId,
              prodId:
                params.column.colId.split('~prodId')[1] !== undefined
                  ? params.column.colId.split('~prodId')[1].split('~')[0]
                  : '',
              ppId:
                params.column.colId.split('~ppId')[1] !== undefined
                  ? params.column.colId.split('~ppId')[1].split('~')[0]
                  : '',
              uomId:
                params.column.colId.split('~uomId')[1] !== undefined
                  ? params.column.colId.split('~uomId')[1].split('~')[0]
                  : '',
              ppdId:
                params.column.colId.split('~ppdId')[1] !== undefined
                  ? params.column.colId.split('~ppdId')[1].split('~')[0]
                  : '',
              intervalType: this.qualityGroupType,
            };
          }
        } else if (
          this.qualityGroupType === 'Event' ||
          this.qualityGroupType === 'Manual'
        ) {
          if (!params.oldValue || params.oldValue === '') {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: startIntervalDate,
              endInterval: startIntervalDate,
              startInterval: startIntervalDate,
              varId: params.data.parameterId,
              isOldValue: true,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              // eventId: params.column.colId.split('~EventId')[1].split('~')[0],
              createdBy: JSON.parse(localStorage.user).UserId,
              intervalType: this.qualityGroupType,
            };
          } else {
            cellData = {
              result: params.value,
              entryOn: new Date(),
              resultOn: startIntervalDate,
              varId: params.data.parameterId,
              endInterval: startIntervalDate,
              startInterval: startIntervalDate,
              isOldValue: true,
              cavity: params.data.Cavity ? params.data.Cavity : 0,
              po: params.column.colId.split('~')[1],
              // eventId: params.column.colId.split('~EventId')[1].split('~')[0],
              createdBy: JSON.parse(localStorage.user).UserId,
              intervalType: this.qualityGroupType,
            };
          }
        }
        this.processService.saveQualityProcessControl(cellData).subscribe(
          (response: any) => {
            const msg = response[0].result;
            if (msg !== null || msg !== '') {
              if (msg.substring(2, 1) === '0') {
                this.toaster.success('Success', msg.substring(3, msg.length));
                this.gridApi.refreshCells(params);
              } else {
                this.toaster.error('Error', msg.substring(3, msg.length));
              }
            }
          },
          (error: any) => {
            return this.toaster.error('Error', error.message);
          }
        );
      }
    }
  }

  generateColumnsQualityControl(data: any[]): any {
    this.columnDefsQualityControl = [];
    let columnDefinitions: any[] = [];
    data.map((object) => {
      Object.keys(object).map((key) => {
        const mappedColumn = {
          headerName: key === 'Cavity' ? 'Sample' : key, // .toUpperCase()
          headerClass: {},
          headerTooltip: key,
          tooltipComponent: 'customTooltip',
          tooltipValueGetter,
          field: key,
          toolTip: key,
          resizable: true,
          wrapText: true,
          rowGroup: key === 'ParameterGroup' ? true : false,
          width:
            key === 'Cavity' || key === 'DataType' || key === 'ParameterGroup'
              ? 150
              : key === 'Parameter'
                ? 300
                : 200,
          cellStyle: {},
          hide:
            key === 'ParameterGroup' || key === 'Cavity' || key === 'DataType'
              ? true
              : false,
          filter: true,
          sortable: true,
          editable: false,
          valueParser: {},
          valueGetter:
            key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
              ? this.abValueGetter
              : null,
          pinned:
            key === 'Parameter' ||
              key === 'Cavity' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? 'left'
              : '',
          lockPinned:
            key === 'Parameter' ||
              key === 'Cavity' ||
              key === 'DataType' ||
              key === 'ParameterGroup'
              ? true
              : false,
          rowSelection: 'multiple',
          onCellClicked: (params: any) => {
            this.boolColId = params.column.colId;
            this.boolRowIndex = params.rowIndex;
            if (params.data.DataType === 'Bool') {
              params.colDef.cellEditor = 'agRichSelectCellEditor';
              this.GetAllDataTypesDetailQC(params.data.parameterId);
              this.selectionName = params.data.Parameter;
              this.isProcessGrid = false;
              if (mappedColumn.editable) {
                this.dialog.open(this.qualityBoolListModal, {
                  height: 'auto',
                  width: '45%',
                });
              }
            } else if (params.data.DataType === 'Date') {
              this.selectionName = params.data.Parameter;
              this.isProcessGrid = false;
              if (mappedColumn.editable) {
                this.reOpenQualityCalendar();
              }
            } else {
              params.colDef.cellEditor = 'agTextCellEditor';
            }
          },
          cellEditor: null,
          // tslint:disable-next-line:max-line-length
          cellEditorParams:
            key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType'
              ? (params: any): Promise<any> => {
                return params.value;
              }
              : null,
        };
        if (this.qualityGroupType === 'Time') {
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
            ) {
              const fromDate = new Date(key.substring(0, 20));
              const toDate = new Date(key.substring(23, 43));
              // tslint:disable-next-line:max-line-length
              if (
                date.getTime() >= fromDate.getTime() &&
                date.getTime() <= toDate.getTime()  &&
                (key.split('~poStatus')[1].split('~')[0] === '' ||
                  key.split('~poStatus')[1].split('~')[0] === 'InProcess')
              ) {
                return {
                  'font-weight': 'bold',
                  color: params.value
                    ? params.data[params.colDef.field].split('|')[1]
                    : 'black',
                  'background-color': key.split('~isSlotVerified')[1] === '1'
                    ? '#79c500'
                    : '#bdccdd',
                };
              } else {
                if (params.value) {
                  return {
                    color: params.data[params.colDef.field].split('|')[1],
                  };
                }
              }
            }
          };
          const date = new Date(new Date().setSeconds(0));
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'Cavity' &&
            key !== 'DataType' &&
            key !== 'parameterId'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            if (
              date.getTime() >= fromDate.getTime() &&
              date.getTime() <= toDate.getTime()  &&
              (key.split('~poStatus')[1].split('~')[0] === '' ||
                key.split('~poStatus')[1].split('~')[0] === 'InProcess')
            ) {
              mappedColumn.editable = true;
              mappedColumn.lockPinned = true;
              mappedColumn.pinned = 'left';
              mappedColumn.valueParser = (params: any) => {
                console.log(params);
                if (this.IsWrite) {
                  const dataType = params.data.DataType;
                  if (
                    dataType === 'Int' ||
                    dataType === 'Float' ||
                    dataType === 'String'
                  ) {
                    const dataType = params.data.DataType;
                    let newVal = params.newValue;
                    if (dataType === 'Int') {
                      const charcter = Number.isInteger(Number(newVal));
                      if (!charcter) {
                        this.toaster.warning(
                          'DigitsOnly',
                          'Please Select Int Value Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return;
                      } else {
                        params.newValue = parseInt(params.newValue, 10);
                      }
                    }
                    if (dataType === 'Float') {
                      const float = parseFloat(newVal);
                      if (isNaN(float)) {
                        this.toaster.warning(
                          'Decimal Only',
                          'Please Select Decimal values Only'
                        );
                        params.node.setDataValue(
                          params.colDef.field,
                          params.oldValue
                        );
                        return;
                      } else {
                        params.newValue = parseFloat(params.newValue).toFixed(
                          2
                        );
                      }
                    }
                    if (dataType === 'Date') {
                      const date = params.newValue;
                      if (date.match(new RegExp('/', 'g')).length === 2) {
                      } else {
                        this.toaster.warning(
                          'SlashError',
                          'Please Select Correct Date Format'
                        );
                        return;
                      }
                    }
                    const startIntervalDate = params.colDef.field.substring(
                      0,
                      20
                    );
                    const endIntervalDate = params.colDef.field.substring(
                      23,
                      43
                    );
                    if (new Date() > new Date(endIntervalDate)) {
                      this.toaster.warning(
                        'Time Passed',
                        'Slot time has been passed'
                      );
                      return;
                    }
                    let cellData: any;
                    if (!params.oldValue || params.oldValue === '') {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        endInterval: endIntervalDate,
                        startInterval: startIntervalDate,
                        varId: params.data.parameterId,
                        isOldValue:
                          this.qualityGroupType !== 'Time' ? true : false,
                        cavity: params.data.Cavity ? params.data.Cavity : 0,
                        po: params.column.colId.split('~')[1],
                        createdBy: JSON.parse(localStorage.user).UserId,
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.qualityGroupType,
                      };
                    } else {
                      cellData = {
                        result: params.newValue,
                        entryOn: new Date(),
                        resultOn: endIntervalDate,
                        varId: params.data.parameterId,
                        endInterval: endIntervalDate,
                        startInterval: startIntervalDate,
                        isOldValue: true,
                        cavity: params.data.Cavity ? params.data.Cavity : 0,
                        po: params.column.colId.split('~')[1],
                        createdBy: JSON.parse(localStorage.user).UserId,
                        prodId:
                          params.column.colId.split('~prodId')[1] !== undefined
                            ? params.column.colId
                              .split('~prodId')[1]
                              .split('~')[0]
                            : '',
                        ppId:
                          params.column.colId.split('~ppId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppId')[1]
                              .split('~')[0]
                            : '',
                        uomId:
                          params.column.colId.split('~uomId')[1] !== undefined
                            ? params.column.colId
                              .split('~uomId')[1]
                              .split('~')[0]
                            : '',
                        ppdId:
                          params.column.colId.split('~ppdId')[1] !== undefined
                            ? params.column.colId
                              .split('~ppdId')[1]
                              .split('~')[0]
                            : '',
                        intervalType: this.qualityGroupType,
                      };
                    }
                    this.processService
                      .saveQualityProcessControl(cellData)
                      .subscribe(
                        (response: any) => {
                          const msg = response[0].result;
                          if (msg !== null || msg !== '') {
                            if (msg.substring(2, 1) === '0') {
                              this.toaster.success(
                                'Success',
                                msg.substring(3, msg.length)
                              );
                              params.node.setDataValue(
                                params.colDef.field,
                                response[0].value
                              );
                              if (response[0].value) {
                                const color = response[0].value.split('|')[1];
                                if (color === '#ff2121') {
                                  this.sendNotificationRole(
                                    `NCR ID - ${response[0].ncrId}
                                     Out of Specification Limits! The Defect had happened against ${params.column.colId.split('~')[1]
                                    }`,
                                    'Quality Control'
                                  );
                                }
                                if (color === '#ffff00') {
                                  this.sendNotificationRole(
                                    `NCR ID - ${response[0].ncrId}
                                     Watch Out! There is a risk of defect happening against ${params.column.colId.split('~')[1]
                                    }`,
                                    'Quality Control'
                                  );
                                }
                              }
                            } else {
                              this.toaster.error(
                                'Error',
                                msg.substring(3, msg.length)
                              );
                              params.node.setDataValue(
                                params.colDef.field,
                                response[0].value
                              );
                            }
                          }
                        },
                        (error: any) => {
                          return this.toaster.error('Error', error.message);
                        }
                      );
                  }
                }
              };
            }
          }
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'parameterId' &&
            key !== 'Cavity' &&
            key !== 'DataType'
          ) {
            const fromDate = new Date(key.substring(0, 20));
            const toDate = new Date(key.substring(23, 43));
            mappedColumn.headerName =
              moment(fromDate).format('HH:mm:ss') +
              ' - ' +
              moment(toDate).format('HH:mm:ss') +
              ' - ' +
              key.split('~')[1] +
              ' - ' +
              key.split('~poStatus')[1].split('~')[0];

            let pcode = '';
            let po = '';
            let name = '';
            po = `PO  :  ${key.split('~')[1]}`;
            pcode = `Code  :  ${key.split('~')[2]}`;
            name = `Name  :  ${key.split('~prodDesc')[1]
              ? key.split('~prodDesc')[1].split('~')[0]
              : ''
              }`;
            mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
            // mappedColumn.headerTooltip = `PO :  ${key.split('~')[1]}`+' - '+`Code : ${key.split('~')[2]}`+' - '+name;
          }
        }
        // if (
        //   this.qualityGroupType === 'Event' ||
        //   this.qualityGroupType === 'Manual'
        // ) {
        //   if (
        //     key !== 'Parameter' &&
        //     key !== 'ParameterGroup' &&
        //     key !== 'parameterId' &&
        //     key !== 'Cavity' &&
        //     key !== 'DataType'
        //   ) {
        //     if (this.qualityGroupType === 'Event') {
        //       const fromDate = new Date(key.substring(0, 20));
        //       mappedColumn.headerName =
        //         moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
        //         ' - ' +
        //         `PO  :  ${key.split('~')[1]} LotCode:  ${key.split('~lotCode')[1].split('~')[0]
        //         }`;
        //       mappedColumn.headerTooltip = `PO  :  ${key.split('~')[1]
        //         } LotCode:  ${key.split('~lotCode')[1].split('~')[0]}`;
        //     } else {
        //       const fromDate = new Date(key.substring(0, 20));
        //       mappedColumn.headerName =
        //         moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
        //         ' - ' +
        //         key.split('~')[1];
        //       mappedColumn.headerTooltip = `PO  :  ${key.split('~')[1]}`;
        //     }
        //     mappedColumn.editable = true;
        //   }
        //   mappedColumn.cellStyle = (params: any): any => {
        //     if (
        //       key !== 'Parameter' &&
        //       key !== 'ParameterGroup' &&
        //       key !== 'Cavity' &&
        //       key !== 'DataType' &&
        //       key !== 'parameterId'
        //     ) {
        //       return {
        //         'font-weight': 'bold',
        //         color: params.value
        //           ? params.data[params.colDef.field].split('|')[1]
        //           : 'black',
        //         'background-color': '#bdccdd',
        //       };
        //     }
        //   };
        //   mappedColumn.editable = true;
        //   mappedColumn.lockPinned = true;
        //   mappedColumn.pinned = 'left';
        //   mappedColumn.valueParser = (params: any) => {
        //     if (this.IsWrite) {
        //       const dataType = params.data.DataType;
        //       if (
        //         dataType === 'Int' ||
        //         dataType === 'Float' ||
        //         dataType === 'String'
        //       ) {
        //         const dataType = params.data.DataType;
        //         let newVal = params.newValue;
        //         if (dataType === 'Int') {
        //           const charcter = Number.isInteger(Number(newVal));
        //           if (!charcter) {
        //             this.toaster.warning(
        //               'DigitsOnly',
        //               'Please Select Int Value Only'
        //             );
        //             params.node.setDataValue(
        //               params.colDef.field,
        //               params.oldValue
        //             );
        //             return;
        //           } else {
        //             params.newValue = parseInt(params.newValue, 10);
        //           }
        //         }
        //         if (dataType === 'Float') {
        //           const float = parseFloat(newVal);
        //           if (isNaN(float)) {
        //             this.toaster.warning(
        //               'FloatOnly',
        //               'Please Select Float Only'
        //             );
        //             params.node.setDataValue(
        //               params.colDef.field,
        //               params.oldValue
        //             );
        //             return;
        //           } else {
        //             params.newValue = parseFloat(params.newValue).toFixed(2);
        //           }
        //         }
        //         if (dataType === 'Date') {
        //           const date = params.newValue;
        //           if (date.match(new RegExp('/', 'g')).length === 2) {
        //           } else {
        //             this.toaster.warning(
        //               'SlashError',
        //               'Please Select Correct Date Format'
        //             );
        //             return;
        //           }
        //         }
        //         const startIntervalDate = params.colDef.field.substring(0, 20);
        //         const endIntervalDate = params.colDef.field.substring(23, 43);
        //         if (new Date() > new Date(endIntervalDate)) {
        //           this.toaster.warning(
        //             'Time Passed',
        //             'Slot time has been passed'
        //           );
        //           return;
        //         }
        //         let cellData: any;
        //         if (!params.oldValue || params.oldValue === '') {
        //           cellData = {
        //             result: params.newValue,
        //             entryOn: new Date(),
        //             resultOn: startIntervalDate,
        //             endInterval: startIntervalDate,
        //             startInterval: startIntervalDate,
        //             varId: params.data.parameterId,
        //             isOldValue: false,
        //             cavity: params.data.Cavity ? params.data.Cavity : 0,
        //             po: params.column.colId.split('~')[1],
        //             eventId: params.column.colId
        //               .split('~EventId')[1]
        //               .split('~')[0],
        //             createdBy: JSON.parse(localStorage.user).UserId,
        //             intervalType: this.qualityGroupType,
        //             prodId:
        //               params.column.colId.split('~prodId')[1] !== undefined
        //                 ? params.column.colId.split('~prodId')[1].split('~')[0]
        //                 : '',
        //             ppId:
        //               params.column.colId.split('~ppId')[1] !== undefined
        //                 ? params.column.colId.split('~ppId')[1].split('~')[0]
        //                 : '',
        //             uomId:
        //               params.column.colId.split('~uomId')[1] !== undefined
        //                 ? params.column.colId.split('~uomId')[1].split('~')[0]
        //                 : '',
        //             ppdId:
        //               params.column.colId.split('~ppdId')[1] !== undefined
        //                 ? params.column.colId.split('~ppdId')[1].split('~')[0]
        //                 : '',
        //           };
        //         } else {
        //           cellData = {
        //             result: params.newValue,
        //             entryOn: new Date(),
        //             resultOn: startIntervalDate,
        //             varId: params.data.parameterId,
        //             endInterval: startIntervalDate,
        //             startInterval: startIntervalDate,
        //             isOldValue: true,
        //             cavity: params.data.Cavity ? params.data.Cavity : 0,
        //             po: params.column.colId.split('~')[1],
        //             eventId: params.column.colId
        //               .split('~EventId')[1]
        //               .split('~')[0],
        //             createdBy: JSON.parse(localStorage.user).UserId,
        //             intervalType: this.qualityGroupType,
        //             prodId:
        //               params.column.colId.split('~prodId')[1] !== undefined
        //                 ? params.column.colId.split('~prodId')[1].split('~')[0]
        //                 : '',
        //             ppId:
        //               params.column.colId.split('~ppId')[1] !== undefined
        //                 ? params.column.colId.split('~ppId')[1].split('~')[0]
        //                 : '',
        //             uomId:
        //               params.column.colId.split('~uomId')[1] !== undefined
        //                 ? params.column.colId.split('~uomId')[1].split('~')[0]
        //                 : '',
        //             ppdId:
        //               params.column.colId.split('~ppdId')[1] !== undefined
        //                 ? params.column.colId.split('~ppdId')[1].split('~')[0]
        //                 : '',
        //           };
        //         }
        //         this.processService
        //           .saveQualityProcessControl(cellData)
        //           .subscribe(
        //             (response: any) => {
        //               const msg = response[0].result;
        //               if (msg !== null || msg !== '') {
        //                 if (msg.substring(2, 1) === '0') {
        //                   this.toaster.success(
        //                     'Success',
        //                     msg.substring(3, msg.length)
        //                   );
        //                   params.node.setDataValue(
        //                     params.colDef.field,
        //                     response[0].value
        //                   );
        //                   if (response[0].value) {
        //                     const color = response[0].value.split('|')[1];
        //                     if (color === '#ff2121') {
        //                       this.sendNotificationRole(
        //                         `NCR ID - ${response[0].ncrId}
        //                          Out of Specification Limits! The Defect had happened against ${params.column.colId.split('~')[1]
        //                         }`,
        //                         'Quality Control'
        //                       );
        //                     }
        //                     if (color === '#ffff00') {
        //                       this.sendNotificationRole(
        //                         `NCR ID - ${response[0].ncrId}
        //                          Watch Out! There is a risk of defect happening against ${params.column.colId.split('~')[1]
        //                         }`,
        //                         'Quality Control'
        //                       );
        //                     }
        //                   }
        //                 } else {
        //                   this.toaster.error(
        //                     'Error',
        //                     msg.substring(3, msg.length)
        //                   );
        //                   params.node.setDataValue(
        //                     params.colDef.field,
        //                     response[0].value
        //                   );
        //                 }
        //               }
        //             },
        //             (error: any) => {
        //               return this.toaster.error('Error', error.message);
        //             }
        //           );
        //       }
        //     }
        //   };
        // }
        if (
          this.qualityGroupType === 'Event' ||
          this.qualityGroupType === 'Manual'
        ) {
          if (
            key !== 'Parameter' &&
            key !== 'ParameterGroup' &&
            key !== 'parameterId' &&
            key !== 'Cavity' &&
            key !== 'DataType'
          ) {
            // tslint:disable-next-line:max-line-length
            if (this.qualityGroupType === 'Event') {
              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' +
                `PO  :  ${key.split('~')[1]}
                `; // LotCode:  ${key.split('~lotCode')[1].split('~')[0]}
              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1]
                ? key.split('~prodDesc')[1].split('~')[0]
                : ''
                }`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
            } else {
              const fromDate = new Date(key.substring(0, 20));
              mappedColumn.headerName =
                moment(fromDate).format('YYYY-MM-DD HH:mm:ss') +
                ' - ' +
                key.split('~')[1];

              // mappedColumn.headerTooltip = 'PO: ' + key.split('~')[1];

              let pcode = '';
              let po = '';
              let name = '';
              po = `PO  :  ${key.split('~')[1]}`;
              pcode = `Code  :  ${key.split('~')[2]}`;
              name = `Name  :  ${key.split('~prodDesc')[1]
                ? key.split('~prodDesc')[1].split('~')[0]
                : ''
                }`;
              mappedColumn.headerTooltip = po + '~' + pcode + '~' + name;
              // mappedColumn.headerTooltip = `PO :  ${key.split('~')[1]}`+' - '+`Code : ${key.split('~')[2]}`+' - '+name;
            }
            mappedColumn.editable = true;
          }
          mappedColumn.cellStyle = (params: any): any => {
            if (
              key !== 'Parameter' &&
              key !== 'ParameterGroup' &&
              key !== 'Cavity' &&
              key !== 'DataType' &&
              key !== 'parameterId'
            ) {
              // if (params.value) {
              return {
                'font-weight': 'bold',
                color: params.value
                  ? params.data[params.colDef.field].split('|')[1]
                  : 'black',
                'background-color': key.split('~isSlotVerified')[1] === '1'
                  ? '#79c500'
                  : '#bdccdd',
              };
              // }
            }
          };
          mappedColumn.valueParser = (params: any) => {
            console.log(params);
            if (this.IsWrite) {
              const dataType = params.data.DataType;
              if (
                dataType === 'Int' ||
                dataType === 'Float' ||
                dataType === 'String'
              ) {
                const dataType = params.data.DataType;
                let newVal = params.newValue;
                if (dataType === 'Int') {
                  const charcter = Number.isInteger(Number(newVal));
                  if (!charcter) {
                    this.toaster.warning(
                      'DigitsOnly',
                      'Please Select Int Value Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return;
                  } else {
                    params.newValue = parseInt(params.newValue, 10);
                  }
                }
                if (dataType === 'Float') {
                  const float = parseFloat(newVal);
                  // tslint:disable-next-line:use-isnan
                  if (isNaN(float)) {
                    this.toaster.warning(
                      'FloatOnly',
                      'Please Select Float Only'
                    );
                    // newVal = params.oldValue;
                    params.node.setDataValue(
                      params.colDef.field,
                      params.oldValue
                    );
                    return;
                  } else {
                    params.newValue = parseFloat(params.newValue).toFixed(2);
                  }
                }
                if (dataType === 'Date') {
                  const date = params.newValue;
                  if (date.match(new RegExp('/', 'g')).length === 2) {
                  } else {
                    this.toaster.warning(
                      'SlashError',
                      'Please Select Correct Date Format'
                    );
                    return;
                  }
                }
                const startIntervalDate = params.colDef.field.substring(0, 20);
                const endIntervalDate = params.colDef.field.substring(23, 43);
                if (new Date() > new Date(endIntervalDate)) {
                  this.toaster.warning(
                    'Time Passed',
                    'Slot time has been passed'
                  );
                  return;
                }
                // const fromDate = new Date(params.colDef.field.substring(0, 19).replace(/-/g, '/'));
                // const toDate = new Date(params.colDef.field.substring(22, 41).replace(/-/g, '/'));
                let cellData: any;
                if (!params.oldValue || params.oldValue === '') {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    varId: params.data.parameterId,
                    isOldValue: this.qualityGroupType !== 'Time' ? true : false,
                    cavity: params.data.Cavity ? params.data.Cavity : 0,
                    po: params.column.colId.split('~')[1],
                    // eventId: params.column.colId
                    //   .split('~EventId')[1]
                    //   .split('~')[0],
                    createdBy: JSON.parse(localStorage.user).UserId,
                    intervalType: this.qualityGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                } else {
                  cellData = {
                    result: params.newValue,
                    entryOn: new Date(),
                    resultOn: startIntervalDate,
                    varId: params.data.parameterId,
                    endInterval: startIntervalDate,
                    startInterval: startIntervalDate,
                    isOldValue: true,
                    cavity: params.data.Cavity ? params.data.Cavity : 0,
                    po: params.column.colId.split('~')[1],
                    // eventId: params.column.colId
                    // .split('~EventId')[1]
                    // .split('~')[0],
                    createdBy: JSON.parse(localStorage.user).UserId,
                    intervalType: this.qualityGroupType,
                    prodId:
                      params.column.colId.split('~prodId')[1] !== undefined
                        ? params.column.colId.split('~prodId')[1].split('~')[0]
                        : '',
                    ppId:
                      params.column.colId.split('~ppId')[1] !== undefined
                        ? params.column.colId.split('~ppId')[1].split('~')[0]
                        : '',
                    uomId:
                      params.column.colId.split('~uomId')[1] !== undefined
                        ? params.column.colId.split('~uomId')[1].split('~')[0]
                        : '',
                    ppdId:
                      params.column.colId.split('~ppdId')[1] !== undefined
                        ? params.column.colId.split('~ppdId')[1].split('~')[0]
                        : '',
                  };
                }
                this.processService
                  .saveQualityProcessControl(cellData)
                  .subscribe(
                    (response: any) => {
                      // this.toaster.success('Success', 'Data Added Successfully');
                      // this.showPopupMsg(response[0].result);
                      const msg = response[0].result;
                      if (msg !== null || msg !== '') {
                        if (msg.substring(2, 1) === '0') {
                          this.toaster.success(
                            'Success',
                            msg.substring(3, msg.length)
                          );
                          params.node.setDataValue(
                            params.colDef.field,
                            response[0].value
                          );
                          if (response[0].value) {
                            const color = response[0].value.split('|')[1];
                            if (color === '#ff2121') {
                              this.sendNotificationRole(
                                `NCR ID - ${response[0].ncrId}
                                                       Out of Specification Limits! The Defect had happened against ${params.column.colId.split(
                                  '~'
                                )[1]
                                }`,
                                'Quality Control'
                              );
                            }
                            if (color === '#ffff00') {
                              this.sendNotificationRole(
                                `NCR ID - ${response[0].ncrId}
                                                       Watch Out! There is a risk of defect happening against ${params.column.colId.split(
                                  '~'
                                )[1]
                                }`,
                                'Quality Control'
                              );
                            }
                          }
                          // params.node.setDataValue(params.colDef.field, newVal);
                        } else {
                          this.toaster.error(
                            'Error',
                            msg.substring(3, msg.length)
                          );
                          const colorElements = document.getElementsByClassName(
                            'ag-cell-focus'
                          ) as HTMLCollectionOf<HTMLElement>;
                          const color = colorElements[0].style.color;
                          params.node.setDataValue(
                            params.colDef.field,
                            response[0].value
                          );
                        }
                      }
                    },
                    (error: any) => {
                      return this.toaster.error('Error', error.message);
                    }
                  );
                // }
              }
            }
          };
        }
        if (key === 'parameterId') {
          mappedColumn.hide = true;
        }
        columnDefinitions.push(mappedColumn);
      });
    });

    columnDefinitions = columnDefinitions.filter(
      (column, index, self) =>
        index ===
        self.findIndex((colAtIndex) => colAtIndex.field === column.field)
    );
    this.rowSelection = 'multiple';
    // if (!this.IsWrite)
    // {
    //   columnDefinitions.forEach((elem) =>
    //   {
    //     if(elem.editable)
    //     {
    //       elem.editable = false;
    //     }
    //     // elem.editable = false;
    //   });
    // }
    this.columnsQC = [];
    const columnQC = columnDefinitions;
    this.columnsQC = columnQC.filter((c) => c.hide !== true);
    return columnDefinitions;
  }

  getParameterCavity(): void {
    const Key = {
      puId: this.unitId,
    };
    this.qualityParameterService.getMaxCavity(Key).subscribe(
      (response: any) => {
        this.maxCavity = response.cavity;
        this.groupDataForm.get('processType')?.setValue(response.processType);
        const val = response.cavity;
        const arr: any[] = [];
        for (let index = 0; index < val; index++) {
          // const element = index + 1;
          arr.push({ value: index + 1 });
        }
        this.cavityList = arr;
        this.showCavity = this.cavityList.length > 1 ? true : false;
      },
      (error: { message: any }) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  isCharNumeric(charStr: any): boolean {
    return !!/\d/.test(charStr);
  }

  // quality check list section

  highlight(row: any): void { }

  getAllQualityCheckList(): void {
    const key = {
      plantId: this.plantId,
      puId: this.unitId,
    };
    if (this.executeRole === true) {
      this.hidetrue = true;
    } else {
      this.hidetrue = false;
    }
    this.qualityexecutionService.getCheckList(key).subscribe(
      (checklist: any) => {
        this.customerManagementDataSource.data = checklist;
        this.getPaginator(this.customerManagementDataSource, 4); //good to go
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  OpenEditCheckList(listId: any, checklistExecutionModal: any): void {
    this.shiftName = null;
    this.checklistDataForm.get('shift')?.reset();


    this.itemColumns = ['items', 'good', 'bad', 'score', 'remarks'];

    this.checklistId = listId.checkListId;

    this.GetGroup();
    this.getListType();
    this.getItemType();
    this.getCheckListById(listId);

    this.resetForm();
    this.goodImgArray = [];
    this.dialog.open(checklistExecutionModal, {
      width: '90vw !important',
      height: '90vh',
      minWidth: '90vw',
    });
    const d = new Date();
    this.checklistDataForm.get('executionDate')?.setValue(d);
    this.formMode = false;
  }

  getListType(): any {
    this.checklistService.getTypes().subscribe(
      (areadata: any) => {
        this.listTypeDDL = areadata;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getItemType(): any {
    this.checklistService.getItemTypes().subscribe(
      (areadata: any) => {
        this.itemTypeDDL = areadata;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
        this.spinner.hide();
      }
    );
  }

  // getCurrentProcessOrder(val: any): void {
  //   const data = {
  //     puId: this.MachineId,
  //   };
  //   this.qualityParameterService.getCurrentProcessOrder(data).subscribe(
  //     (response) => {
  //       if (response.length) {
  //         this.currentprocessOrder = response[0].ProcessOrder;
  //         this.PPID = response[0].PPD_Id;
  //         this.manualInput(val);
  //       } else {
  //         this.currentprocessOrder = null;
  //         this.PPID = null;
  //         this.manualInput(val);
  //       }
  //     },
  //     (error) => {
  //       this.toaster.error('Error', error.error.message);
  //     }
  //   );
  // }

  manualInput(val: any): void {
    const data = {
      plantId: this.plantId,
      lotcode: null,
      eventDateTime: new Date(),
      eventTypeId: 3,
      puId: this.MachineId,
      type: val
      // processOrder: this.currentprocessOrder,
      // processOrder: this.groupDataForm.get('processOrder')?.value,
      // processOrderId: this.PPID,
    };
    this.sfdService.insertSfdcEvent(data).then(
      (response) => {
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('ManualInput') +
          ' ' +
          this.translate.instant('Event') +
          ' ' +
          this.translate.instant('AddedSuccessfully')
        );
        if (val === 'process') {
          this.onProcessControlRefresh();
        } else {
          this.onQualityControlRefresh();
        }
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  // C1-Result Time Should Not Be More Than Current Time!"

  manualOutPut(): void {
    const data = {
      plantId: this.plantId,
      lotcode: null,
      eventDateTime: new Date(),
      eventTypeId: 4,
      puId: this.MachineId,
      processOrder: this.groupDataForm.get('processOrder')?.value,
      processOrderId: this.PPID,
    };
    this.sfdService.insertSfdcEvent(data).then(
      (response) => {
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('ManualOutPut') +
          ' ' +
          this.translate.instant('Event') +
          ' ' +
          this.translate.instant('AddedSuccessfully')
        );
      },
      (error) => {
        this.showPopupMsg(error.ErrorMessage);
      }
    );
  }

  getPath(model: any, id: any): any {
    let path;
    const item = model;

    if (!model || typeof model !== 'object') {
      return;
    }

    if (model.id === id) {
      return [item];
    }

    (model.children || []).some(
      (child: any) => (path = this.getPath(child, id))
    );
    return path && [item, ...path];
  }

  getCheckListById(element: any): void {
    const checkList = {
      checkListId: element.qualityCheckListId,
      unitId: this.unitId,
    };

    this.qualityexecutionService
      .getCheckListByIdForExecution(checkList)
      .subscribe(
        (response: any) => {
          this.checklistDataForm
            .get('group')
            ?.setValue(this.groupDataForm.get('group')?.value);
          this.checklistDataForm.get('plant')?.setValue(this.plantId);
          this.checklistDataForm
            .get('unitName')
            ?.setValue(this.groupDataForm.get('Unit')?.value);
          this.checklistDataForm
            .get('checktype')
            ?.setValue(response[0].listType);
          this.checklistDataForm
            .get('checkname')
            ?.setValue(response[0].listName);
          this.checklistDataForm
            .get('currentProcessOrder')
            ?.setValue(
              response[0].currentProcessOrder === null
                ? ''
                : response[0].currentProcessOrder
            );
          this.checklistDataForm
            .get('currentProcessOrderId')
            ?.setValue(response[0].currentProcessOrderId);
          this.isAuto = response.currentProcessOrder;
          this.valueCheck = this.checklistDataForm.value.currentProcessOrderId;
          if (this.valueCheck) {
            this.isAuto = true;
          } else {
            this.isAuto = false;
          }

          this.checklistDataForm
            .get('currentProductName')
            ?.setValue(
              response[0].currentProduct === null
                ? ''
                : response[0].currentProduct
            );
          this.preCheck = this.checklistDataForm.value.currentProductName;
          if (this.preCheck) {
            this.preAuto = true;
          } else {
            this.preAuto = false;
          }
          this.checklistDataForm
            .get('previousProcessOrder')
            ?.setValue(
              response[0].prevProcessOrder === null
                ? ''
                : response[0].prevProcessOrder
            );
          this.checklistDataForm
            .get('previousProcessOrderId')
            ?.setValue(response[0].prevProcessOrderId);
          this.valueCheck2 =
            this.checklistDataForm.value.previousProcessOrderId;
          if (this.valueCheck2) {
            this.isAuto2 = true;
          } else {
            this.isAuto2 = false;
          }

          this.checklistDataForm
            .get('previousProductName')
            ?.setValue(
              response[0].prevProduct === null ? '' : response[0].prevProduct
            );
          this.preCheck2 = this.checklistDataForm.value.previousProductName;
          if (this.preCheck2) {
            this.preAuto2 = true;
          } else {
            this.preAuto2 = false;
          }
          this.getDateShifts(event);
          this.checklistDataForm.get('area')?.setValue(element.areaName);
          response.forEach((ele: any) => {
            const row = {
              id: this.counter,
              item: ele.itemName,
              itemtype: ele.itemType,
              drop: ele.itemGroup,
              checkListDetailId: ele.checkListDetailId,
              remarks: '',
              score: 0,
              catType: '',
              goodImage: ele.goodExampleImage,
              badImage: ele.badExampleImage,
            };
            this.addtabledata.push(row);
            const f = new File([''], 'filename');
            this.goodImgArray.push(f);
          });

          response.forEach((item: any, index: any) => {
            item.id = index + 1;
            item.remarks = '';
            item.score = '';
            item.catType = '';
          });

          this._alldata = response;
          this.checkListAddModel.data = this.addGroups(
            this._alldata,
            this.groupByColumns
          );
          this.checkListAddModel.filterPredicate =
            this.customFilterPredicate.bind(this);
          this.checkListAddModel.filter = performance.now().toString();

          const goodImage = response.filter((element: any) => {
            if (element.goodExampleImage.split('/')[5]?.length > 0) {
              return element;
            }
          });
          if (goodImage.length > 0) {
            this.GoodExampleImage = true;
          } else {
            this.removeImagesColumns('good');
          }
          const badImage = response.filter((element: any) => {
            if (element.badExampleImage.split('/')[5]?.length > 0) {
              return element;
            }
          });
          if (badImage.length > 0) {
            this.BadExampleImage = true;
          } else {
            this.removeImagesColumns('bad');
          }
        },
        (error: any) => {
          this.toaster.error(
            this.translate.instant('Error'),
            this.translate.instant('WentWrong')
          );
        }
      );
  }

  getDateShifts(event: any): void {
    this.timeDif(event);
    const key = {
      Date: this.checklistDataForm.value.executionDate,
      PUID: this.unitId,
    };
    this.checklistDataForm.get('shift')?.reset();
    this.checklistDataForm.get('shiftName')?.reset();
    this.crewService.GetCrewScheduleList(key).then(
      (response: any) => {
        const date = new Date();
        this.shiftList = response.CrewScheduleList;
        // date.getTime() >= fromDate.getTime() &&
        // date.getTime() <= toDate.getTime()
        // tslint:disable-next-line:max-line-length
        const record = this.shiftList.filter(
          (c: any) =>
            date.getTime() >= new Date(c.ShiftStart).getTime() &&
            date.getTime() <= new Date(c.ShiftEnd).getTime()
        );
        if (response.CrewScheduleList.length > 0) {
          this.checklistDataForm.get('shift')?.setValue(record[0].CrewId);
          this.checklistDataForm.get('shiftName')?.setValue(record[0].Shift);
        } else {
          // this.toaster.warning(
          //   this.translate.instant('ShiftNotFound'),
          //   this.translate.instant('DefineShift'),
          //   {
          //     timeOut: 3000,
          //   }
          // );
          console.log('shift Not Found');
        }
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
        this.spinner.hide();
      }
    );
  }

  GetGroup(): void {
    const key = {
      Id: 0,
    };
    this.usermanagementService.getGroupData(key).subscribe((res: any) => {
      this.Groups = res.masterList;

      this.groupDataForm.get('group')?.setValue(res.masterList[0].TypeId);
      this.getPlants();
    });
  }

  addGroups(data: any[], groupByColumns: string[]): any[] {
    const rootGroup = new Group();
    rootGroup.expanded = true;
    return this.getSublevel(data, 0, groupByColumns, rootGroup);
  }

  getSublevel(
    data: any[],
    level: number,
    groupByColumns: string[],
    parent: Group
  ): any[] {
    if (level >= groupByColumns.length) {
      return data;
    }
    const groups = this.uniqueBy(
      data.map((row) => {
        const result = new Group();
        result.level = level + 1;
        result.parent = parent;
        for (let i = 0; i <= level; i++) {
          result[groupByColumns[i]] = row[groupByColumns[i]];
          console.log(row[groupByColumns[i]]);
        }
        return result;
      }),
      JSON.stringify
    );

    const currentColumn = groupByColumns[level];
    let subGroups: any[] = [];
    groups.forEach((group: any) => {
      const rowsInGroup = data.filter(
        (row) => group[currentColumn] === row[currentColumn]
      );
      group.totalCounts = rowsInGroup.length;
      const subGroup = this.getSublevel(
        rowsInGroup,
        level + 1,
        groupByColumns,
        group
      );
      subGroup.unshift(group);
      subGroups = subGroups.concat(subGroup);
    });
    return subGroups;
  }

  removeImagesColumns(name: string): void {
    const removeIndex = this.itemColumns.findIndex((i: any) => {
      return i === name;
    });
    if (removeIndex >= 0) {
      const good = this.itemColumns.splice(removeIndex, 1);
    }
  }

  addCheckListExecution(): void {
    const result = this._alldata;
    const executionDetails: any[] = [];
    result.forEach((element, i) => {
      const v = {
        checkListDetailId: element.checkListDetailId,
        remarks: element.remarks,
        acutalValue: element.score,
        goodImage: element.goodImage,
        badImage: element.badImage,
        itemTypeId: element.itemType,
        catType:
          element.itemType !== 4
            ? element.catType
            : this.goodImgArray[i].name === 'filename'
              ? ''
              : this.goodImgArray[i].name,
      };
      executionDetails.push(v);
    });
    const found = executionDetails.some((el) => el.catType !== '');
    if (!found) {
      this.toaster.warning(this.translate.instant('SelectAnyValue'));
      return;
    }
    const formdata = new FormData();
    for (let index = 0; index < this.goodImgArray.length; index++) {
      formdata.append('goodImages', this.goodImgArray[index]);
    }


    const key = {
      userId: JSON.parse(localStorage.user).UserId,
      checkListId: this.checklistId,
      execDate: this.checklistDataForm.get('executionDate')?.value,
      shift: this.checklistDataForm.get('shift')?.value,
      unitId: this.unitId,
      processOrder: this.checklistDataForm
        .get('currentProcessOrder')
        ?.value.toString(),
      previousProcessOrder:
        this.isAuto2 === false
          ? this.checklistDataForm.get('previousProcessOrder')?.value
          : this.checklistDataForm.get('previousProcessOrderId')?.value,
      productName: this.checklistDataForm.get('currentProductName')?.value,
      previousProductName: this.checklistDataForm.get('previousProductName')
        ?.value,
      executionDetails,
    };
    formdata.append('checkListexecution', JSON.stringify(key));
    this.qualityexecutionService.addCheckListExecution(formdata).subscribe(
      (response) => {
        this.dialog.closeAll();
        this.toaster.success(
          this.translate.instant('Success'),
          this.translate.instant('AuditExecution') +
          this.translate.instant('AddedSuccessfully')
        );
        this.sendNotification();
        this.resetForm();

        this.getAllQualityCheckList();
      },
      (error) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  sendNotification(): void {
    const key = {
      roleName: 'Line Leader',
      createdBy: JSON.parse(localStorage.user).UserId,
      egId: this.checklistDataForm.value.group,
      title: 'CheckList Execution',
      desc:
        'Execution has been created in check list ' +
        this.checklistDataForm.value.checkname +
        ' by ' +
        JSON.parse(localStorage.user).UserName,
    };
    this.notificationService.addnotification(key).subscribe(
      (response: any) => { },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  customFilterPredicate(data: any | Group, filter: string): boolean {
    return data instanceof Group ? data.visible : this.getDataRowVisible(data);
  }

  getDataRowVisible(data: any): boolean {
    const groupRows = this.checkListAddModel.data.filter((row) => {
      if (!(row instanceof Group)) {
        return false;
      }
      let match = true;
      this.groupByColumns.forEach((column: any) => {
        if (!row[column] || !data[column] || row[column] !== data[column]) {
          match = false;
        }
      });
      return match;
    });

    if (groupRows.length === 0) {
      return true;
    }
    const parent = groupRows[0] as Group;
    return parent.visible && parent.expanded;
  }

  QCcustomFilterPredicate(data: any | Group, filter: string): boolean {
    return data instanceof Group
      ? data.visible
      : this.getQCDataRowVisible(data);
  }

  getQCDataRowVisible(data: any): boolean {
    const groupRows = this.qcdataSource.data.filter((row) => {
      if (!(row instanceof Group)) {
        return false;
      }
      let match = true;
      this.groupByQCColumns.forEach((column: any) => {
        if (!row[column] || !data[column] || row[column] !== data[column]) {
          match = false;
        }
      });
      return match;
    });

    if (groupRows.length === 0) {
      return true;
    }
    const parent = groupRows[0] as Group;
    return parent.visible && parent.expanded;
  }

  timeDif(event: any): any {
    const today = new Date();

    const startDate = moment(this.checklistDataForm.value.executionDate);
    const endDate = moment(today);
    const timeDiff = endDate.diff(startDate, 'hours');

    // if (timeDiff > 24 || timeDiff < -24) {
    //   this.toaster.warning(
    //     this.translate.instant('Error'),
    //     this.translate.instant('DateRangeSelect')
    //   );
    //   return;
    // }
  }

  resetForm(): void {
    this.checklistDataForm.reset();
    this.dialog.closeAll();

    this.addtabledata = [];
    this.addtabledata.length = 0;
  }
  uniqueBy(a: any, key: any): any {
    const seen: any = {};
    return a.filter((item: any) => {
      const k = key(item);
      return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    });
  }

  imageZoomModal(imagePath: string): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModel, { height: '90%', width: '90%' });
  }

  imageZoomModalShow(imagePath: string): void {
    this.currentImagePath = imagePath;
    this.dialog.open(this.imageZoomModelShow, { height: '90%', width: '90%' });
  }

  getPlantByGroup(): void {
    const key = {
      GroupId: this.checklistDataForm.value.group,
    };
    // this.MachineId = null;
    this.machineService.getPlantsData(key).subscribe(
      (data: any) => {
        this.plantDDL = data.DepartList;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
      }
    );
  }

  getPlants(): void {
    const key = {
      GroupId: this.groupDataForm.value.group,
    };
    this.usermanagementService.getDepartments(key).subscribe((res: any) => {
      this.Plants = res.DepartList;
      this.checklistDataForm.get('plant')?.setValue(this.Plants[0].DeptId);
    });
  }

  getArea(): any {
    const key = {
      plantId: this.checklistDataForm.value.plant,
    };
    this.AreaServices.getQualityArea(key).subscribe(
      (areadata: any) => {
        this.areaDDL = areadata;
      },
      (error: any) => {
        this.toaster.error(
          this.translate.instant('Error'),
          this.translate.instant('WentWrong')
        );
        this.spinner.hide();
      }
    );
  }

  scoreUpdate(event: any, data: any): void {
    this.detailPrentId = data.checkListDetailId;
    const checkListDetailId = parseInt(data.checkListDetailId, 10);
    const d = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    if (data.itemType === 1) {
      const v = event.value;
      d.catType = v;
    } else {
      const score = event.target.value === '' ? '' : event.target.value;
      d.score = score;
      d.catType = score;
    }

    const result = this.checkListAddModel;
  }

  onChangeradio(value: any): void {
    if (value.value === 'Yes') {
      this.yes;
    } else {
      this.no;
    }
  }

  uploadedFile(event: any, checkListDetailId: number): void {
    const ind = this.addtabledata.findIndex(
      (c: any) => c.checkListDetailId === checkListDetailId
    );
    const found = this.goodImgArray[ind];
    if (found) {
      this.goodImgArray[ind] = event.target.files[0];
      this.addtabledata[ind].catType = event.target.files[0]?.name;
    } else {
      if (event.target.files.length > 0) {
        this.fileSave = event.target.files[0];
        this.addtabledata[ind].catType = event.target.files[0].name;
        this.goodImgArray.push(this.fileSave);
      }
    }
  }

  onDateChange(event: any, element: any): void {
    this.getDateShifts(event);
    const checkListDetailId = parseInt(element.checkListDetailId, 10);
    const d = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    d.catType = event.target.value;
  }

  remarksUpdate(event: any, data: any): void {
    const remarks = event.target.value;
    const checkListDetailId = parseInt(data.checkListDetailId, 10);
    const m = this._alldata.find(
      (x) => x.checkListDetailId === checkListDetailId
    );
    m.remarks = remarks;

    const result = this.checkListAddModel;
  }
  expandprocess() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = false;
    this.Collapsehide = true;
  }
  closeprocess() {
    this.isCardExpanded = !this.isCardExpanded;
    this.Exdpandhide = true;
    this.Collapsehide = false;
  }
  expandquality() {
    this.isCardExpandedQuality = !this.isCardExpandedQuality;
    this.ExdpandhideQuality = false;
    this.CollapsehideQuality = true;
  }
  closequality() {
    this.isCardExpandedQuality = !this.isCardExpandedQuality;
    this.ExdpandhideQuality = true;
    this.CollapsehideQuality = false;
  }
  closeParamterValuesModelVisible(): void {
    this.isParamterValuesModelVisible = false;
  }

  onClickParamterAnalysisProcess(): void {
    
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.processControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.processControlForm.value.datePicker.endDate));
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const selectedRows = this.processGridApi
      .getSelectedRows()
      .filter(
        (c: any) =>
          c.DataType === 'Int' ||
          c.DataType === 'Bool' ||
          c.DataType === 'Float'
      );
    this.spinnerButtonOptions.active = true;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleYearlyTargetTbl, {
      panelClass: 'custom-dialog-container',
      width: '95vw !important',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    this.selectedParameters = selectedRows;
    this.chartArray = [];
    this.selectedProducts = this.machineProducts;
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter;
      const key = {
        parameterId: element.parameterId,
        groupType: this.processGroupType,
        products: this.machineProducts.map((c) => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId;
      await this.processService.getProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinnerButtonOptions.active = false;
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const Productarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            const arrProduct = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            array.push({
              x: new Date(c.processTime).getTime(),
              y: parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL)); // LSL Rename To LRL
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL)); // LCL Rename To LSL
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL)); // UCL Rename To USL
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL)); // USL Rename To URL
            URLarray.push(arrURL);
            arrProduct.push(new Date(c.processTime).getTime());
            arrProduct.push(c.Product); // USL Rename To URL
            Productarray.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            time: {
              useUTC: false
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            tooltip: {
              formatter(): any {
                let s = '';
                this.points?.forEach((point: any) => {
                  console.log(point);
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: [
              {
                title: {
                  text: 'Result',
                },
                opposite: false,
              },
              {
                title: {
                  text: 'Product',
                  style: {
                    color: '#252031',
                  },
                },
                opposite: true,
              },
            ],
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
          console.log(this.chartArray);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinnerButtonOptions.active = false;
  }

  onChangeParamterAnalysisProcess(): void {
    const selectedRows = this.selectedParameters;
    this.spinner.show();
    this.chartArray = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter;
      const key = {
        parameterId: element.parameterId,
        groupType: this.qualityGroupType,
        products: this.selectedProducts.map((c) => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId;
      await this.processService.getProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinner.hide();
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const Productarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            const arrProduct = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            array.push({
              x: new Date(c.processTime).getTime(),
              y: parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL)); // LSL Rename To LRL
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL)); // LCL Rename To LSL
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL)); // UCL Rename To USL
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL)); // USL Rename To URL
            URLarray.push(arrURL);
            arrProduct.push(new Date(c.processTime).getTime());
            arrProduct.push(c.Product); // USL Rename To URL
            Productarray.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            time: {
              useUTC: false
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: [
              {
                title: {
                  text: 'Result',
                },
                opposite: false,
              },
              {
                title: {
                  text: 'Product',
                  style: {
                    color: '#252031',
                  },
                },
                opposite: true,
              },
            ],
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
                // dataLabels: {
                //   enabled: true,
                //   formatter(): any {
                //     
                //     return `<span>${this.point.label}</span>`;
                //   }
                // }
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinner.hide();
  }

  onClickParamterComparsionProcess(): void {
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.processControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.processControlForm.value.datePicker.endDate));

    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const selectedRows = this.processGridApi
      .getSelectedRows()
      .filter((c: any) => c.DataType === 'Int' || c.DataType === 'Float');
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleParameterComparison, {
      panelClass: 'custom-dialog-container',
      width: '95vw !important',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    this.selectedParameters = selectedRows;
    this.selectedProducts = this.machineProducts;
    const array: any[] = [];
    const yAxisArr: any[] = [];
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.processGroupType,
      products: this.machineProducts.map((c) => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getParameterControlComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              // arr.push(new Date(data[j].processTime).getTime());
              // arr.push(parseFloat(data[j].result));
              // dataArr.push(arr);
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          console.log(dataArr);
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          time: {
            useUTC: false
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                console.log(point);
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }

  onChangeParamterComparisionProcess(): void {
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length
    const selectedRows = this.selectedParameters;
    const array: any[] = [];
    const yAxisArr: any[] = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.processGroupType,
      products: this.selectedProducts.map((c) => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getParameterControlComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              // arr.push(new Date(data[j].processTime).getTime());
              // arr.push(parseFloat(data[j].result));
              // dataArr.push(arr);
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          console.log(dataArr);
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          time: {
            useUTC: false
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                console.log(point);
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }

  onClickControlProcessOrderProcess(): any {
    const key = {
      fromDate: this.processControlForm.value.datePicker[0],
      toDate: this.processControlForm.value.datePicker[1],
      puId: this.unitId,
      processType: this.processControlForm.value.processType,
    };
    this.spinnerButtonOptionsOrders.active = true;
    this.processService
      .getQualityControlProcessOrder(key)
      .subscribe((response: any) => {
        this.dialog.open(this.displayProcessOrdersModal, {
          height: '90%',
          width: '90%',
        });
        this.ProcessOrder.data = response;
        this.getPaginator(this.ProcessOrder, 5);
      });
    this.spinnerButtonOptionsOrders.active = false;
  }

  onClickParamterAnalysisQuality(): any {
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.qualityControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.qualityControlForm.value.datePicker.endDate));

    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const selectedRows = this.qualityGridApi
      .getSelectedRows()
      .filter(
        (c: any) =>
          c.DataType === 'Int' ||
          c.DataType === 'Bool' ||
          c.DataType === 'Float'
      );
    this.spinnerButtonOptions.active = true;
    this.selectedParameters = selectedRows;
    this.chartArray = [];
    this.selectedProducts = this.machineProducts;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleYearlyTargetTblQuality, {
      panelClass: 'custom-dialog-container',
      width: '95vw !important',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    selectedRows.forEach(async (element: any) => {
      const parameterName = element.Parameter + ' (' + element.Cavity + ')';
      const key = {
        parameterId: element.parameterId,
        cavity: element.Cavity ? element.Cavity : 0,
        groupType: this.qualityGroupType,
        products: this.machineProducts.map((c) => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate,
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId + '_' + element.Cavity;
      await this.processService.getQualityProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinnerButtonOptions.active = false;
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            // array.push(arr);
            array.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL));
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL));
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL));
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL));
            URLarray.push(arrURL);
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            legend: {
              enabled: true,
            },
            time: {
              useUTC: false
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  console.log(point);
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: {
              title: {
                text: 'Result',
              },
              opposite: false,
              // tickInterval: 50
            },
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
                marker: {
                  enabled: true,
                },
                label: {
                  onArea: false,
                },
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
          console.log(this.chartArray);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinnerButtonOptions.active = false;
        }
      );
    });
    this.spinnerButtonOptions.active = false;
  }
  onChangeParameterAnalysisQuality(): any {
    
    this.chartArray = [];
    const selectedRows = this.selectedParameters;
    if (selectedRows.length === 0) {
      return;
    }
    this.spinner.show();
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    // tslint:disable-next-line:max-line-length
    selectedRows.forEach(async (element: any) => {
      const parameterName =
        this.qualityGroupType === 'Time'
          ? element.Parameter + ' (' + element.Cavity + ')'
          : element.Parameter;
      const key = {
        parameterId: element.parameterId,
        cavity: element.Cavity ? element.Cavity : 0,
        groupType: this.qualityGroupType,
        products: this.selectedProducts.map((c) => c.Prod_Id).toString(),
        fromDate: fromDate,
        toDate: toDate,
      };
      const chartObj = { id: '', chartOption: {} };
      chartObj.id = element.parameterId + '_' + element.Cavity;
      await this.processService.getQualityProcessParameterAnalysis(key).then(
        (data: any) => {
          this.spinner.hide();
          const LRLarray: any[] = [];
          const LSLarray: any[] = [];
          const LWLarray: any[] = [];
          const TGTarray: any[] = [];
          const UWLarray: any[] = [];
          const USLarray: any[] = [];
          const URLarray: any[] = [];
          const array: any[] = [];
          data.forEach((c: any) => {
            // tslint:disable-next-line:one-variable-per-declaration
            const arr = [],
              arrLRL = [];
            const arrLSL = [];
            const arrLWL = [];
            const arrTGT = [];
            const arrUWL = [];
            const arrUSL = [];
            const arrURL = [];
            arr.push(new Date(c.processTime).getTime());
            arr.push(parseFloat(c.result));
            // array.push(arr);
            array.push({
              x: new Date(c.processTime).getTime(),
              y: isNaN(c.result) ? '' : parseFloat(c.result),
              label: c.Product,
            });
            arrLRL.push(new Date(c.processTime).getTime());
            arrLRL.push(parseFloat(c.LRL));
            LRLarray.push(arrLRL);
            arrLSL.push(new Date(c.processTime).getTime());
            arrLSL.push(parseFloat(c.LSL));
            LSLarray.push(arrLSL);
            arrLWL.push(new Date(c.processTime).getTime());
            arrLWL.push(parseFloat(c.LWL));
            LWLarray.push(arrLWL);
            arrTGT.push(new Date(c.processTime).getTime());
            arrTGT.push(parseFloat(c.TGT));
            TGTarray.push(arrTGT);
            arrUWL.push(new Date(c.processTime).getTime());
            arrUWL.push(parseFloat(c.UWL));
            UWLarray.push(arrUWL);
            arrUSL.push(new Date(c.processTime).getTime());
            arrUSL.push(parseFloat(c.USL));
            USLarray.push(arrUSL);
            arrURL.push(new Date(c.processTime).getTime());
            arrURL.push(parseFloat(c.URL));
            URLarray.push(arrURL);
          });
          this.stock = new StockChart({
            plotOptions: {
              series: {
                turboThreshold: 50000000,
              },
            },
            chart: {
              height: 730,
            },
            rangeSelector: {
              inputEnabled: false,
              selected: 1,
            },
            title: {
              text: parameterName.toUpperCase(),
            },
            credits: {
              enabled: false,
            },
            time: {
              useUTC: false
            },
            legend: {
              enabled: true,
            },
            tooltip: {
              formatter(): any {
                // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
                let s = '';
                this.points?.forEach((point: any) => {
                  console.log(point);
                  if (point.series.name === 'Result') {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>' +
                      '<br/><span style="color: #252031">Product : ' +
                      point.point.label +
                      '<span><br/>';
                  } else {
                    s +=
                      '<br/> <span style="color: ' +
                      point.series.color +
                      '">' +
                      point.series.name +
                      ' : ' +
                      point.y +
                      '<span><br/>';
                  }
                });
                return s;
              },
            },
            yAxis: {
              title: {
                text: 'Result',
              },
              opposite: false,
              // tickInterval: 50
            },
            series: [
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'Result',
                type: 'line',
                data: array,
                color: '#040496',
                marker: {
                  enabled: true,
                },
                label: {
                  onArea: false,
                },
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LRL',
                type: 'line',
                data: LRLarray,
                color: '#00ff00',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LSL',
                type: 'line',
                data: LSLarray,
                color: '#FF5733',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'LWL',
                type: 'line',
                data: LWLarray,
                color: '#9C412D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'TGT',
                type: 'line',
                data: TGTarray,
                color: '#9C902D',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'UWL',
                type: 'line',
                data: UWLarray,
                color: '#25B79B',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'USL',
                type: 'line',
                data: USLarray,
                color: '#257AB7',
                dashStyle: 'ShortDash',
              },
              {
                tooltip: {
                  valueDecimals: 2,
                },
                name: 'URL',
                type: 'line',
                data: URLarray,
                color: '#FF0909',
                dashStyle: 'ShortDash',
              },
            ],
          });

          chartObj.chartOption = this.stock;
          this.chartArray.push(chartObj);
          console.log(this.chartArray);
        },
        (error: any) => {
          this.toaster.error('Error', error.ErrorMessage);
          this.spinner.hide();
        }
      );
    });
  }

  onClickParamterComparsionQuality(): void {
    this.range.reset();
    this.range.get('fromDate').setValue(new Date(this.qualityControlForm.value.datePicker.startDate));
    this.range.get('toDate').setValue(new Date(this.qualityControlForm.value.datePicker.endDate));
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const selectedRows = this.qualityGridApi
      .getSelectedRows()
      .filter((c: any) => c.DataType === 'Int' || c.DataType === 'Float');
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length
    this.dialog.open(this.visibleParameterComparisonQuality, {
      panelClass: 'custom-dialog-container',
      width: '95vw !important',
      height: '100vh',
      minWidth: '95vw',
      maxHeight: '100vh',
    });
    this.selectedParameters = selectedRows;
    this.selectedProducts = this.machineProducts;
    const array: any = [];
    const yAxisArr: any[] = [];
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.qualityGroupType,
      products: this.machineProducts.map((c) => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getQualityProcessParameterComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              // arr.push(new Date(data[j].processTime).getTime());
              // arr.push(parseFloat(data[j].result));
              // dataArr.push(arr);
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          console.log(dataArr);
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          time: {
            useUTC: false
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                console.log(point);
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }

  onChangeParamterComparsionQuality(): void {
    this.spinnerButtonOptions1.active = true;
    // tslint:disable-next-line:max-line-length

    const selectedRows = this.selectedParameters;
    const array: any = [];
    const yAxisArr: any[] = [];
    let fromDate = new Date(this.range?.value.fromDate);
    fromDate.setHours(0);
    fromDate.setMinutes(0);
    fromDate.setSeconds(0);
    const toDate = new Date(this.range?.value.toDate);
    toDate.setHours(23);
    toDate.setMinutes(59);
    toDate.setSeconds(59);
    const values = selectedRows
      .map((value: any) => value.parameterId)
      .toString();
    const valueNames = selectedRows.map((value: any) => value.Parameter);
    const seletedGroups = selectedRows.map(
      (value: any) => value.ParameterGroup
    );
    const uniqueGroups = [...new Set(seletedGroups)];
    const dataArrName: any[] = [];
    const key = {
      parameterId: values,
      groupType: this.qualityGroupType,
      products: this.selectedProducts.map((c) => c.Prod_Id).toString(),
      fromDate: fromDate,
      toDate: toDate,
    };
    this.spinner.show();
    this.processService.getQualityProcessParameterComparison(key).then(
      (data: any) => {
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < valueNames.length; i++) {
          const dataArr = [];
          // tslint:disable-next-line:prefer-for-of
          for (let j = 0; j < data.length; j++) {
            // const arr = [];
            if (valueNames[i] === data[j].name) {
              // arr.push(new Date(data[j].processTime).getTime());
              // arr.push(parseFloat(data[j].result));
              // dataArr.push(arr);
              dataArr.push({
                x: new Date(data[j].processTime).getTime(),
                y: isNaN(data[j].result) ? '' : parseFloat(data[j].result),
                label: data[j].product,
              });
            }
          }
          let negativeArr = [];
          console.log(dataArr);
          negativeArr = dataArr.map((c) => c.y);
          const obj = {
            tooltip: {
              valueDecimals: 2,
            },
            name: valueNames[i],
            type: 'line',
            data: dataArr,
            color: this.highChartsColor[i],
            yAxis: i,
          };
          array.push(obj);
          yAxisArr.push({
            lineWidth: 1,
            opposite: negativeArr.some((v) => v < 0) ? true : false,
            title: {
              text: valueNames[i],
              style: {
                color: this.highChartsColor[i],
              },
            },
            labels: {
              style: {
                color: this.highChartsColor[i],
              },
            },
          });
        }
        this.chart = new StockChart({
          chart: {
            height: 730,
          },
          time: {
            useUTC: false
          },
          plotOptions: {
            series: {
              turboThreshold: 50000000,
              events: {
                hide(): any {
                  // this.yAxis.axisTitle.hide();
                  this.yAxis.update({
                    visible: false,
                  });
                },
                show(): any {
                  this.yAxis.update({
                    visible: true,
                  });
                },
              },
            },
          },
          rangeSelector: {
            inputEnabled: false,
            selected: 1,
          },
          title: {
            text: uniqueGroups.toString(),
          },
          credits: {
            enabled: false,
          },
          legend: {
            enabled: true,
          },
          tooltip: {
            formatter(): any {
              // let s = '<b>' + StockChart.dateFormat('%A, %b %e, %Y', this.x) + '</b>';
              let s = '';
              this.points?.forEach((point: any) => {
                console.log(point);
                s +=
                  '<br/> <span style="color: ' +
                  point.series.color +
                  '">' +
                  point.series.name +
                  ' : ' +
                  point.y +
                  '<span><br/>' +
                  '<br/><span style="color: ' +
                  point.series.color +
                  '">Product : ' +
                  point.point.label +
                  '<span><br/>';
              });
              return s;
            },
          },
          yAxis: yAxisArr,
          series: array,
        });
        this.spinner.hide();
      },
      (error: any) => {
        this.toaster.error('Error', error.error.message);
        this.spinner.hide();
      }
    );
    this.spinnerButtonOptions1.active = false;
  }

  getProcessParamterGroupList(): void {
    const key = {
      paramterType: 'Process Control',
      puId: this.unitId,
      groupType: this.processGroupType,
    };
    this.processService.getParamterGroupList(key).subscribe(
      (data: any) => {
        this.processparameterGroupList = data;
        this.processControlForm
          .get('parameterGroup')
          ?.setValue(this.processparameterGroupList);
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  getQualityParamterGroupList(): void {
    const key = {
      paramterType: 'Quality Control',
      puId: this.unitId,
      groupType: this.qualityGroupType,
    };
    this.processService.getParamterGroupList(key).subscribe(
      (data: any) => {
        this.qualityparameterGroupList = data;
        this.qualityControlForm
          .get('parameterGroup')
          ?.setValue(this.qualityparameterGroupList);
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
  onProcessParameterGroupChange(): void {
    const instance = this.processGridApi.getFilterInstance('ParameterGroup');
    const myArray: any = [];
    // tslint:disable-next-line:prefer-for-of
    for (
      let i = 0;
      i < this.processControlForm.value.parameterGroup.length;
      i++
    ) {
      myArray.push(this.processControlForm.value.parameterGroup[i].vgDesc);
    }
    instance?.setModel({
      values: myArray.length > 0 ? myArray : [],
    });
    this.processGridApi.onFilterChanged();
  }
  onQualityParameterGroupChange(): void {
    const filterValue = this.qualityControlForm.value.parameterGroup;
    const instance = this.qualityGridApi.getFilterInstance('ParameterGroup');
    const myArrayquality: any = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < filterValue.length; i++) {
      myArrayquality.push(filterValue[i].vgDesc);
    }
    instance?.setModel({
      values: myArrayquality.length > 0 ? myArrayquality : [],
    });
    this.qualityGridApi.onFilterChanged();
  }
  onClickControlProcessOrderQuality(): any {
    const key = {
      fromDate: moment(
        this.qualityControlForm.value.datePicker.startDate
      ).utc(),
      toDate: moment(this.qualityControlForm.value.datePicker.endDate).utc(),
      puId: this.unitId,
      cavity: this.maxCavity,
      processType: this.qualityControlForm.value.processType,
    };
    this.spinnerButtonOptionsOrders.active = true;
    this.processService
      .getQualityControlProcessOrder(key)
      .subscribe((response: any) => {
        this.dialog.open(this.displayQualityOrdersModal, {
          height: '90%',
          width: '90%',
        });
        this.qualityProcessOrder.data = response;
        this.getPaginator(this.qualityProcessOrder, 6);
      });
    this.spinnerButtonOptionsOrders.active = false;
  }
  disabledDate = (current: Date): boolean =>
    // Can not select days before today and today
    differenceInCalendarDays(current, this.today) > 0;
  groupHeaderClick(row: any): void {
    console.log('row ==>', row);
    row.expanded = !row.expanded;
    this.checkListAddModel.filter = performance.now().toString(); // bug here need to fix
  }
  QCgroupHeaderClick(row: any): void {
    console.log('row ==>', row);
    row.expanded = !row.expanded;
    this.qcdataSource.filter = performance.now().toString(); // bug here need to fix
  }

  applyFilter(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.qualityProcessOrder.filter = filterValue.trim().toLowerCase();
  }

  PControllapplyFilter(event: any): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.ProcessOrder.filter = filterValue.trim().toLowerCase();
  }

  isGroup(index: any, item: any): boolean {
    return item.level;
  }
  saveBool(qualityBoolVal: any): void {
    const itemArr: any[] = [];
    let rowNode: any;
    if (this.isProcessGrid) {
      this.processGridApi.forEachLeafNode((node: any) => {
        itemArr.push(node);
      });
      const filterIndex: any = itemArr.filter(
        (c) => c.rowIndex === this.boolRowIndex
      );
      rowNode = this.processGridApi.getRowNode(filterIndex[0].id);
    } else {
      this.qualityGridApi.forEachLeafNode((node: any) => {
        itemArr.push(node);
      });
      const filterIndex: any = itemArr.filter(
        (c) => c.rowIndex === this.boolRowIndex
      );
      rowNode = this.qualityGridApi.getRowNode(filterIndex[0].id);
    }
    rowNode.setDataValue(this.boolColId, qualityBoolVal);
    this.dialog.closeAll();
  }
  reOpenQualityCalendar(): any {
    const self = this;
    setTimeout(() => {
      self.qualitypicker.open();
    }, 50);
  }
  reOpenProcessCalendar(): any {
    const self = this;
    setTimeout(() => {
      self.processpicker.open();
    }, 50);
  }

  processgridDate(event: any): void {
    const itemArr: any[] = [];
    this.processGridApi.forEachLeafNode((node: any) => {
      itemArr.push(node);
    });
    const filterIndex: any = itemArr.filter(
      (c) => c.rowIndex === this.boolRowIndex
    );
    const rowNode = this.processGridApi.getRowNode(filterIndex[0].id);
    rowNode.setDataValue(
      this.boolColId,
      moment(event.value).format('DD/MM/YYYY HH:mm:ss')
    );
  }
  qualitygridDate(event: any): void {
    const itemArr: any[] = [];
    this.qualityGridApi.forEachLeafNode((node: any) => {
      itemArr.push(node);
    });
    const filterIndex: any = itemArr.filter(
      (c) => c.rowIndex === this.boolRowIndex
    );
    const rowNode = this.qualityGridApi.getRowNode(filterIndex[0].id);
    rowNode.setDataValue(
      this.boolColId,
      moment(event.value).format('DD/MM/YYYY HH:mm:ss')
    );
  }
  excelExportPC(): void {
    const params = {
      fileName: 'PC' + new Date(),
    };
    this.gridOptionsProcessControl.api.exportDataAsExcel(params);
    // this.gridApi.exportDataAsExcel();
  }
  csvExportPC(): void {
    const params = {
      fileName: 'PC ' + new Date(),
    };
    this.gridOptionsProcessControl.api.exportDataAsCsv(params);
  }
  pdfExport() {
    this.selectedColumns = [];
    this.processControlForm.get('pdfcolumn')?.setValue('');
    this.dialog.open(this.pdfModel, {
      width: '50vw !important',
      height: '65vh',
      minWidth: '50vw',
    });
  }

  downloadPDF() {
    const columnsToExport = this.getColumnsToExport();

    const widths = this.getExportedColumnsWidths(columnsToExport);

    const rowsToExport = this.getRowsToExport(columnsToExport);

    const body = [columnsToExport, ...rowsToExport];

    const fillColor = (rowIndex, node, columnIndex) => {
      if (rowIndex < node.table.headerRows) {
        return '#f8f8f8';
      }
      return rowIndex % 2 === 0 ? '#fcfcfc' : '#ffffff';
    };

    const hLineWidth = (i, node) =>
      i === 0 || i === node.table.body.length ? 1 : 1;

    const vLineWidth = (i, node) =>
      i === 0 || i === node.table.widths.length ? 1 : 0;

    const hLineColor = (i, node) =>
      i === 0 || i === node.table.body.length ? '#dde2eb' : '#babfc7';

    const vLineColor = (i, node) =>
      i === 0 || i === node.table.widths.length ? '#dde2eb' : '#babfc7';

    const docDefintiion = {
      pageOrientation: 'landscape',
      content: [
        {
          style: 'myTable',
          table: {
            widths,
            body,
          },
          layout: {
            fillColor,
          },
        },
      ],
      images: {
        'ag-grid-logo': 'Good',
      },
      styles: {
        myTable: {
          margin: [0, 0, 0, 0],
        },
        tableHeader: {
          bold: true,
          margin: [0, 25 / 3, 0, 0],
        },
        tableCell: {},
      },
    };
    pdfMake.createPdf(docDefintiion).download('ProcessControl.pdf');
    this.dialog.closeAll();
    this.processControlForm.get('pdfcolumn')?.setValue('');
    this.selectedColumns = [];
  }

  columnSelect() {
    let column = [];
    this.selectedColumns = [];
    column = this.processControlForm.get('pdfcolumn')?.value;
    for (let i = 0; i < column.length; i++) {
      this.selectedColumns.push(column[i].headerName);
    }
    this.selectedColumns = this.selectedColumns.toString();
  }

  getRowsToExport(columnsToExport) {
    let rowsToExport = [];

    this.gridOptionsProcessControl.api.forEachNodeAfterFilterAndSort((node) => {
      let rowToExport = columnsToExport.map(({ colId }) => {
        let cellValue = this.gridOptionsProcessControl.api.getValue(
          colId,
          node
        );
        let tableCell = this.createTableCell(cellValue, colId);
        return tableCell;
      });
      rowsToExport.push(rowToExport);
    });

    return rowsToExport;
  }

  createTableCell(cellValue, colId) {
    const tableCell = {
      text: cellValue !== undefined ? cellValue : '',
      // noWrap: PDF_PAGE_ORITENTATION === "landscape",
      style: 'tableCell',
    };

    const pdfExportOptions = this.getPdfExportOptions(colId);

    if (pdfExportOptions) {
      const { styles, createURL } = pdfExportOptions;
    }

    return tableCell;
  }

  getExportedColumnsWidths(columnsToExport) {
    return columnsToExport.map(() => 100 / columnsToExport.length + '%');
  }

  getColumnsToExport() {
    let columnsToExport = [];
    let column;
    this.gridOptionsProcessControl.columnApi
      .getAllDisplayedColumns()
      .forEach((col) => {
        const select = this.selectedColumns.split(',');
        if (col.userProvidedColDef) {
          column = select.find(
            (x: any) => x == col.userProvidedColDef.headerName
          );
          if (column) {
            let pdfExportOptions = this.getPdfExportOptions(col.getColId());
            if (pdfExportOptions && pdfExportOptions.skipColumn) {
              return;
            }
            let headerCell = this.createHeaderCell(col);
            columnsToExport.push(headerCell);
          }
        } else {
          let pdfExportOptions = this.getPdfExportOptions(col.getColId());
          if (pdfExportOptions && pdfExportOptions.skipColumn) {
            return;
          }
          let headerCell = this.createHeaderCell(col);
          columnsToExport.push(headerCell);
        }
      });

    return columnsToExport;
  }

  createHeaderCell(col) {
    let headerCell = {
      text: '',
      colSpan: '',
      colId: '',
    };

    let isColGroup = col.hasOwnProperty('children');

    if (isColGroup) {
      headerCell.text = col.originalColumnGroup.colGroupDef.headerName;
      headerCell.colSpan = col.children.length;
      headerCell.colId = col.groupId;
    } else {
      let headerName = col.colDef.headerName;

      if (col.sort) {
        headerName += ` (${col.sort})`;
      }
      if (col.filterActive) {
        headerName += ` [FILTERING]`;
      }

      headerCell.text = headerName;
      headerCell.colId = col.getColId();
    }

    headerCell['style'] = 'tableHeader';

    return headerCell;
  }

  getPdfExportOptions(colId) {
    let col = this.gridOptionsProcessControl.columnApi.getColumn(colId);
    return col.colDef.pdfExportOptions;
  }
  excelExportQC(): void {
    const params = {
      fileName: 'QC' + new Date(),
    };
    this.gridOptionsQualityControl.api.exportDataAsExcel(params);
    // this.gridApi.exportDataAsExcel();
  }
  csvExportQC(): void {
    const params = {
      fileName: 'QC ' + new Date(),
    };
    this.gridOptionsQualityControl.api.exportDataAsCsv(params);
  }
  pdfExportQC() {
    this.selectedColumnsQC = [];
    this.qualityControlForm.get('pdfcolumnQC')?.setValue('');
    this.dialog.open(this.pdfModelQC, {
      width: '50vw !important',
      height: '65vh',
      minWidth: '50vw',
    });
  }

  downloadPDFQC() {
    const columnsToExport = this.getColumnsToExportQC();

    const widths = this.getExportedColumnsWidthsQC(columnsToExport);

    const rowsToExport = this.getRowsToExportQC(columnsToExport);

    const body = [columnsToExport, ...rowsToExport];

    const fillColor = (rowIndex, node, columnIndex) => {
      if (rowIndex < node.table.headerRows) {
        return '#f8f8f8';
      }
      return rowIndex % 2 === 0 ? '#fcfcfc' : '#ffffff';
    };

    const hLineWidth = (i, node) =>
      i === 0 || i === node.table.body.length ? 1 : 1;

    const vLineWidth = (i, node) =>
      i === 0 || i === node.table.widths.length ? 1 : 0;

    const hLineColor = (i, node) =>
      i === 0 || i === node.table.body.length ? '#dde2eb' : '#babfc7';

    const vLineColor = (i, node) =>
      i === 0 || i === node.table.widths.length ? '#dde2eb' : '#babfc7';

    const docDefintiion = {
      pageOrientation: 'landscape',
      content: [
        {
          style: 'myTable',
          table: {
            widths,
            body,
          },
          layout: {
            fillColor,
          },
        },
      ],
      images: {
        'ag-grid-logo': 'Good',
      },
      styles: {
        myTable: {
          margin: [0, 0, 0, 0],
        },
        tableHeader: {
          bold: true,
          margin: [0, 25 / 3, 0, 0],
        },
        tableCell: {},
      },
    };
    pdfMake.createPdf(docDefintiion).download('QualityControl.pdf');
    this.dialog.closeAll();
    this.processControlForm.get('pdfcolumnQC')?.setValue('');
    this.selectedColumnsQC = [];
  }

  GetMaintanceInfo(object: any): void {
    const key = {
      PUID: this.MachineId,
      JobDownTimeId: object.JobDownTimeId,
    };
    this.sfdService.GetMaintanceInfo(key).subscribe(
      (res: any) => {
        if (res.HasError) {
          this.toaster.error('Error', res.ErrorMessage);
        } else {
          this.toaster.success('Success', res.ErrorMessage);
        }
      },
      (error) => {
        // You can access status:
        console.log(error.status);
      }
    );
  }

  columnSelectQC() {
    let column = [];
    this.selectedColumnsQC = [];
    column = this.qualityControlForm.get('pdfcolumnQC')?.value;
    for (let i = 0; i < column.length; i++) {
      this.selectedColumnsQC.push(column[i].headerName);
    }
    this.selectedColumnsQC = this.selectedColumnsQC.toString();
  }

  getRowsToExportQC(columnsToExport) {
    let rowsToExport = [];

    this.gridOptionsQualityControl.api.forEachNodeAfterFilterAndSort((node) => {
      let rowToExport = columnsToExport.map(({ colId }) => {
        let cellValue = this.gridOptionsQualityControl.api.getValue(
          colId,
          node
        );
        let tableCell = this.createTableCellQC(cellValue, colId);
        return tableCell;
      });
      rowsToExport.push(rowToExport);
    });

    return rowsToExport;
  }

  createTableCellQC(cellValue, colId) {
    const tableCell = {
      text: cellValue !== undefined ? cellValue : '',
      // noWrap: PDF_PAGE_ORITENTATION === "landscape",
      style: 'tableCell',
    };

    const pdfExportOptions = this.getPdfExportOptionsQC(colId);

    if (pdfExportOptions) {
      const { styles, createURL } = pdfExportOptions;
    }

    return tableCell;
  }

  getExportedColumnsWidthsQC(columnsToExport) {
    return columnsToExport.map(() => 100 / columnsToExport.length + '%');
  }

  getColumnsToExportQC() {
    let columnsToExport = [];
    let column;
    this.gridOptionsQualityControl.columnApi
      .getAllDisplayedColumns()
      .forEach((col) => {
        const select = this.selectedColumnsQC.split(',');
        if (col.userProvidedColDef) {
          column = select.find(
            (x: any) => x == col.userProvidedColDef.headerName
          );
          if (column) {
            let pdfExportOptions = this.getPdfExportOptionsQC(col.getColId());
            if (pdfExportOptions && pdfExportOptions.skipColumn) {
              return;
            }
            let headerCell = this.createHeaderCellQC(col);
            columnsToExport.push(headerCell);
          }
        } else {
          let pdfExportOptions = this.getPdfExportOptions(col.getColId());
          if (pdfExportOptions && pdfExportOptions.skipColumn) {
            return;
          }
          let headerCell = this.createHeaderCell(col);
          columnsToExport.push(headerCell);
        }
      });

    return columnsToExport;
  }

  createHeaderCellQC(col) {
    let headerCell = {
      text: '',
      colSpan: '',
      colId: '',
    };

    let isColGroup = col.hasOwnProperty('children');

    if (isColGroup) {
      headerCell.text = col.originalColumnGroup.colGroupDef.headerName;
      headerCell.colSpan = col.children.length;
      headerCell.colId = col.groupId;
    } else {
      let headerName = col.colDef.headerName;

      if (col.sort) {
        headerName += ` (${col.sort})`;
      }
      if (col.filterActive) {
        headerName += ` [FILTERING]`;
      }

      headerCell.text = headerName;
      headerCell.colId = col.getColId();
    }

    headerCell['style'] = 'tableHeader';

    return headerCell;
  }

  getPdfExportOptionsQC(colId) {
    let col = this.gridOptionsQualityControl.columnApi.getColumn(colId);
    return col.colDef.pdfExportOptions;
  }
  getMachineProducts(): void {
    //
    const data = {
      puId: this.unitId,
    };
    this.machineProducts = [];
    this.processService.getMachineProducts(data).subscribe(
      (response) => {
        const key = {
          Prod_Id: 0,
          Prod_Desc: 'Other',
        };

        this.machineProducts = response;
        this.machineProducts.unshift(key);
      },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }
}
const tooltipValueGetter = (params: any) => ({ value: params.value });

class Group {
  [key: string]: any;
  level = 0;
  parent!: Group; // =new Group();
  expanded = true;
  totalCounts = 0;
  get visible(): boolean {
    return !this.parent || (this.parent.visible && this.parent.expanded);
  }
}
